(function () {
  function parseJson(script) {
    if (!script) return null;
    const raw = script.textContent;
    try {
      return JSON.parse(raw);
    } catch (e) {
      try {
        return JSON.parse(raw.replace(/([{,]\s*)(\d+)\s*:/g, '$1"$2":'));
      } catch (e2) {
        console.error('Bundle builder: JSON parse failed', e);
        return null;
      }
    }
  }

  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
  }

  function formatMoneyAmount(cents) {
    const formatted = formatMoney(cents);
    return formatted.replace(/[^\d,.-]/g, '').trim();
  }

  function formatPriceDelta(cents) {
    if (!cents) return '';
    const sign = cents > 0 ? '+' : '-';
    return `${sign}${formatMoneyAmount(Math.abs(cents))}\u00a0€`;
  }

  function generateBundleInstanceId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function sanitizeBundleGroup(group) {
    if (typeof group !== 'string') return '';
    return group.trim().replace(/-/g, '');
  }

  function generateBundleId(group, instanceId) {
    const bundleGroup = sanitizeBundleGroup(group) || 'Rezept';
    const id = String(instanceId || generateBundleInstanceId()).replace(/-/g, '');
    return `${bundleGroup}-${id}`;
  }

  function toProductVariantGid(id) {
    if (id == null || id === '') return '';
    const raw = String(id).trim();
    if (raw.indexOf('gid://shopify/ProductVariant/') === 0) return raw;
    const numeric = parseInt(raw, 10);
    if (!numeric) return '';
    return `gid://shopify/ProductVariant/${numeric}`;
  }

  function bundleLineProperties(bundleId, parentVariantId, bundleTitle, bundleGroup, instanceId, parentHandle) {
    const props = {
      _BundleId: bundleId,
      _DiscountId: bundleId
    };
    if (bundleGroup) {
      props._BundleGroup = bundleGroup;
    }
    if (instanceId) {
      props._BundleInstance = instanceId;
    }
    const parentVariantGid = toProductVariantGid(parentVariantId);
    if (parentVariantGid) {
      props._BundleParentVariantId = parentVariantGid;
    }
    if (parentHandle) {
      props._BundleParentHandle = String(parentHandle);
    }
    if (bundleTitle) {
      props._BundleTitle = bundleTitle;
    }
    return props;
  }

  function bundleAddonLineProperties(bundleId, bundleGroup, discountScaleQty, instanceId) {
    const props = {
      _BundleId: bundleId,
      _DiscountId: bundleId,
      _BundleDiscountScaleQty: String(discountScaleQty)
    };
    if (bundleGroup) {
      props._BundleGroup = bundleGroup;
    }
    if (instanceId) {
      props._BundleInstance = instanceId;
    }
    return props;
  }

  function bundleGiftLineProperties(instanceId, slot) {
    const props = { _BundleGift: '1' };
    if (instanceId) {
      props._BundleInstance = instanceId;
    }
    if (slot) {
      props._BundleGiftSlot = String(slot);
    }
    return props;
  }

  function bundlePaidGiftLineProperties(instanceId, slot) {
    const props = { _BundleExternalAddon: '1' };
    if (instanceId) {
      props._BundleInstance = instanceId;
    }
    if (slot) {
      props._BundleGiftSlot = String(slot);
    }
    return props;
  }

  function bundleGratisExtraLineProperties() {
    return {
      _BundleGratisExtra: '1',
      GRATIS: 'Goodie'
    };
  }

  function formatDrawerProductTitle(title) {
    if (!title) return '';
    const parts = title
      .split(' - ')
      .map((part) => part.trim())
      .filter(Boolean);
    if (parts.length > 2) return parts.slice(2).join(' - ');
    return title;
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    const options = [];
    if (variant.option1 != null && variant.option1 !== '') options.push(variant.option1);
    if (variant.option2 != null && variant.option2 !== '') options.push(variant.option2);
    if (variant.option3 != null && variant.option3 !== '') options.push(variant.option3);
    return options;
  }

  /* START: abo recharge encoder */
  let rechargeEncoderPromise = null;

  function loadRechargeEncoder() {
    if (window.recharge?.encodeBundle) {
      window.recharge.init({ storeIdentifier: window.Shopify.shop });
      return Promise.resolve(window.recharge);
    }
    if (rechargeEncoderPromise) return rechargeEncoderPromise;
    rechargeEncoderPromise = fetch(
      'https://static.rechargecdn.com/assets/storefront/recharge-client-1.3.0.min.js'
    )
      .then((response) => {
        if (!response.ok) throw new Error('Recharge Client konnte nicht geladen werden.');
        return response.text();
      })
      .then((source) => {
        const patched = source.replace('return nf});', 'nf.encodeBundle=OP;return nf});');
        const script = document.createElement('script');
        script.textContent = patched;
        document.head.appendChild(script);
        if (!window.recharge?.encodeBundle) {
          throw new Error('Recharge Encoder fehlt.');
        }
        window.recharge.init({ storeIdentifier: window.Shopify.shop });
        return window.recharge;
      })
      .catch((error) => {
        rechargeEncoderPromise = null;
        throw error;
      });
    return rechargeEncoderPromise;
  }
  /* END: abo recharge encoder */

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.formId = this.getAttribute('data-form-id');
      this.kitOptionIndex = parseInt(this.getAttribute('data-kit-option-index'), 10);
      this.kitOptionPosition = parseInt(this.getAttribute('data-kit-option-position'), 10);
      this.drawerId = this.getAttribute('data-drawer-id');
      this.forceDrawerSoldOut = this.getAttribute('data-drawer-force-sold-out') === 'true';
      this.bundleGroup = this.getAttribute('data-bundle-group') || 'Rezept';
      this.bundleTitle = this.getAttribute('data-bundle-title') || 'Dein Bundle';
      this.redirectToCheckout = this.getAttribute('data-redirect-to-checkout') === 'true';
      this.subscriptionMode = this.getAttribute('data-subscription') === 'true';
      this.subscriptionCollectionId = this.getAttribute('data-subscription-collection-id') || '';
      this.subscriptionAddonCollectionId =
        this.getAttribute('data-subscription-addon-collection-id') || '';
      this.subscriptionAddonProductId =
        this.getAttribute('data-subscription-addon-product-id') || '';
      this.subscriptionAddonVariantId =
        this.getAttribute('data-subscription-addon-variant-id') || '';
      this.subscriptionAddonLabel = this.getAttribute('data-subscription-addon-label') || 'Shaker';
      this.atcSuccessMessage =
        this.getAttribute('data-atc-success-message') || '🎉 Auswahl komplett!';
      this.useKitIndexAsQuantity =
        this.getAttribute('data-use-kit-index-as-quantity') === 'true';
      this.variantPricingOnly = this.getAttribute('data-variant-pricing-only') === 'true';
      this.giftMode = this.getAttribute('data-gift-mode') || 'standard';
      this.showGifts = this.getAttribute('data-show-gifts') !== 'false';
      this.addGiftsInBundle = this.getAttribute('data-add-gifts-in-bundle') === 'true';
      this.includePaidGiftsInBundle =
        this.getAttribute('data-include-paid-gifts-in-bundle') === 'true';
      this.hideLineItemVariantName =
        this.getAttribute('data-hide-line-item-variant-name') !== 'false';
      this.hideGiftsInKitRows = this.getAttribute('data-hide-gifts-in-kit-rows') !== 'false';
      this.kitGiftsPreset = parseInt(this.getAttribute('data-kit-gifts-preset'), 10) || 0;
      this.scrollToFlavorStep = this.getAttribute('data-scroll-to-flavor-step') !== 'false';
      this.giftOptional = this.getAttribute('data-gift-optional') === 'true';
      this.giftDeclineLabel =
        this.getAttribute('data-gift-decline-label') || 'Ich möchte keinen';
      this.gift1OptInMode = this.getAttribute('data-gift-1-opt-in') === 'true';
      this.gift1AcceptLabel =
        this.getAttribute('data-gift-1-accept-label') || 'Ja, Ich möchte einen';
      this.gift1DeclineLabel =
        this.getAttribute('data-gift-1-decline-label') || 'Nein, ich möchte keinen';
      this.gift1DeclineBundleGroup = this.getAttribute('data-gift-1-decline-bundle-group') || '';
      this.preset1NoGifts = this.getAttribute('data-preset-1-no-gifts') === 'true';
      this.hideKitSelection = this.getAttribute('data-hide-kit-selection') === 'true';
      this.hideGiftComparePrices = this.getAttribute('data-hide-gift-compare-prices') === 'true';
      this.bonusGiftPopup = this.getAttribute('data-bonus-gift-popup') === 'true';
      this.flexibleSelection = this.getAttribute('data-flexible-selection') === 'true';
      this.optionalExtraSlot =
        !this.flexibleSelection && this.getAttribute('data-optional-extra-slot') === 'true';
      this.gratisExtraProduct = this.getAttribute('data-gratis-extra-product') === 'true';
      this.gratisExtraEnabled = this.gratisExtraProduct;
      this.gratisExtraPreset = parseInt(this.getAttribute('data-gratis-extra-preset'), 10) || 0;
      this.gratisExtraPlaceholder =
        this.getAttribute('data-gratis-extra-placeholder') || 'GRATIS: Geschmack auswählen...';
      this.gratisExtraDrawerTitle =
        this.getAttribute('data-gratis-extra-drawer-title') || 'GRATIS Geschmack wählen';
      this.gratisExtraCompareCents =
        parseInt(this.getAttribute('data-gratis-extra-compare-cents'), 10) || 0;
      this.promoGiftsEnabled = this.getAttribute('data-promo-gifts') === 'true';
      this.promoGiftsCount = Math.max(
        1,
        parseInt(this.getAttribute('data-promo-gifts-count'), 10) || 2
      );
      this.promoGiftsPlaceholder =
        this.getAttribute('data-promo-gifts-placeholder') || 'Rezeptkarten auswählen...';
      this.promoGiftsDrawerTitle =
        this.getAttribute('data-promo-gifts-drawer-title') || 'Rezeptkarten auswählen';
      this.promoGiftsCompareCents =
        parseInt(this.getAttribute('data-promo-gifts-compare-cents'), 10) || 0;
      this.drawerDefaultTitle =
        this.getAttribute('data-drawer-default-title') || 'Wähle Deine Rezeptkarten';
      this.flexibleConfig = this.flexibleSelection
        ? parseJson(this.querySelector('[data-bundle-flexible-config]')) || {}
        : null;
      this._flexibleUpgradeInProgress = false;
      this._flexibleVolumeGoalActive = false;
      this._flexibleVolumeGoalTimeout = null;
      this._flexibleLastSelectionCount = 0;
      this._flexibleMaxExtraQty = 99;
      this._optionalMaxExtraQty = 99;

      this.variants = parseJson(this.querySelector('[data-bundle-variants]')) || [];
      this.parentVariantMap = parseJson(this.querySelector('[data-bundle-parent-map]')) || null;
      this.products = parseJson(this.querySelector('[data-bundle-products]')) || [];
      this.gratisExtraProducts =
        parseJson(this.querySelector('[data-bundle-gratis-extra-products]')) || [];
      this.gratisExtraPanel = this.querySelector('[data-gratis-extra-panel]');
      this.promoGiftsProducts =
        parseJson(this.querySelector('[data-bundle-promo-gifts-products]')) || [];
      this.promoGiftsPanel = this.querySelector('[data-promo-gifts-panel]');
      this.promoGiftsSlotsEl = this.querySelector('[data-promo-gifts-slots]');
      if (!this.promoGiftsEnabled || this.promoGiftsProducts.length === 0) {
        this.promoGiftsEnabled = false;
      }
      this.presets = this._normalizePresets(parseJson(this.querySelector('[data-bundle-presets]')) || []);
      this.giftPricing = parseJson(this.querySelector('[data-bundle-gifts]')) || {
        minQuantity: 4,
        totalCompare: 0,
        items: []
      };
      this.giftSelections = {};
      this.giftPickLabel = this.getAttribute('data-gift-pick-label') || 'Farbe wählen';
      this.colorsPlaceholder =
        this.getAttribute('data-colors-placeholder') || 'Farben auswählen...';
      this.giftSelectionPlaceholder =
        this.getAttribute('data-gift-selection-placeholder') || this.colorsPlaceholder;
      this._activePickerContext = null;

      this.slotsEl = this.querySelector('[data-bundle-slots]');
      this.gratisExtraSlotEl = this.querySelector('[data-gratis-extra-slot]');
      this.promoGiftsPlaceholderImageHtml =
        this.querySelector('[data-promo-gifts-placeholder-image]')?.innerHTML || '';
      this.slotTemplate = this.querySelector('[data-bundle-slot-template]');
      this.drawer = document.getElementById(this.drawerId);
      this._configureDrawer();
      this.drawerList = this.querySelector('[data-drawer-list]');
      this.drawerConfirm = this.querySelector('[data-drawer-confirm]');
      this.drawerConfirmTitle = this.querySelector('[data-drawer-confirm-title]');
      this.drawerConfirmCount = this.querySelector('[data-drawer-confirm-count]');
      this._drawerConfirmDefaultTitle = this.drawerDefaultTitle;
      this.drawerTotal = this.querySelector('[data-drawer-total]');
      this.drawerCompare = this.querySelector('[data-drawer-compare]');
      this.drawerDiscountBadge = this.querySelector('[data-drawer-discount-badge]');
      this.drawerCelebration = this.querySelector('[data-drawer-celebration]');
      this.drawerGoalToast = this.querySelector('[data-drawer-goal-toast]');
      this.drawerUpgradeProgress = this.drawer?.querySelector('[data-drawer-upgrade-progress]');
      this.drawerUpgradeProgressText = this.drawer?.querySelector(
        '[data-drawer-upgrade-progress-text]'
      );
      this.drawerUpgradeProgressBadge = this.drawer?.querySelector(
        '[data-drawer-upgrade-progress-badge]'
      );
      this.atcCelebration = this.querySelector('[data-atc-celebration]');
      this.atcGoalToast = this.querySelector('[data-atc-goal-toast]');
      this.atcButton = this.querySelector('[data-bundle-atc]');
      this._drawerLastTotal = 0;
      this._celebrationTimeout = null;
      this._drawerGoalToastTimeout = null;
      this._atcGoalToastTimeout = null;
      this._colorsGoalToastTimeout = null;
      this._atcCelebrationTimeout = null;
      this._colorsDrawerLastCount = 0;
      this._colorsCelebrationTimeout = null;
      this._missingHighlightTimeout = null;

      this.selections = [];
      this.gratisExtraSelection = null;
      this.promoGiftSelections = [];
      this.drawerMode = 'default';
      this.presetSelections = {};
      this.drawerQuantities = {};
      this._kitSelectInProgress = false;
      this._kitRevertInProgress = false;
      this._suppressDrawerPersist = false;
      this.activePreset = null;
      this.defaultUnitPrice = parseInt(this.getAttribute('data-default-unit-price'), 10) || 0;
      this.enableCustomPresetComparePrices =
        this.getAttribute('data-enable-custom-preset-compare') === 'true';

      this._bindEvents();
      this._placeKitGifts(this._getSelectedKitRow()?.getAttribute('data-preset-index'), {
        animate: false
      });
      this._syncSubscriptionInterval();
      this._initGiftDrawer();
      this._initGiftInfoModal();
      this._initColorsDrawer();
      this._renderColorsPanelSlotsFromGiftData();
      this._updateColorsVisibility();
      this._initGiftSelections();
      this._registerParentCardPrice();
      this._waitForForm();
      requestAnimationFrame(() => {
        this._updateKitRowPricing();
      });
    }

    _getLowestKitRowPrice() {
      const seedEl = this.querySelector('[data-bundle-lowest-kit-price]');
      if (seedEl) {
        try {
          const seed = JSON.parse(seedEl.textContent || '{}');
          const seedPrice = parseInt(seed.price, 10) || 0;
          if (seedPrice > 0) {
            const seedCompare = parseInt(seed.compare, 10) || 0;
            return {
              price: seedPrice,
              compare: seedCompare > seedPrice ? seedCompare : 0
            };
          }
        } catch (_error) {
          // Fall through to kit-row scan.
        }
      }

      let lowestPrice = 0;
      let lowestCompare = 0;

      this.querySelectorAll('[data-bundle-kit-row]').forEach((row) => {
        if (row.hasAttribute('data-plain-single')) return;
        const price = parseInt(row.getAttribute('data-computed-price'), 10) || 0;
        if (price <= 0) return;
        if (lowestPrice === 0 || price < lowestPrice) {
          lowestPrice = price;
          lowestCompare = parseInt(row.getAttribute('data-computed-compare'), 10) || 0;
        }
      });

      if (lowestCompare <= lowestPrice) lowestCompare = 0;
      return lowestPrice > 0 ? { price: lowestPrice, compare: lowestCompare } : null;
    }

    _registerParentCardPrice() {
      const parentId = this.getAttribute('data-parent-product-id');
      const parentHandle = this.getAttribute('data-parent-product-handle');
      if (!parentId) return;

      const lowest = this._getLowestKitRowPrice();
      const price = lowest?.price || parseInt(this.getAttribute('data-parent-card-price'), 10) || 0;
      const compare = lowest
        ? lowest.compare
        : parseInt(this.getAttribute('data-parent-card-compare'), 10) || 0;
      if (!price) return;

      this.setAttribute('data-parent-card-price', String(price));
      if (compare > price) {
        this.setAttribute('data-parent-card-compare', String(compare));
      } else {
        this.removeAttribute('data-parent-card-compare');
      }

      if (typeof registerBundleParentCardPrice === 'function') {
        registerBundleParentCardPrice(parentId, parentHandle, price, compare);
        applyStoredBundleParentCardPrices();
      }
    }

    _waitForForm() {
      const tryInit = () => {
        if (!this.form) {
          requestAnimationFrame(tryInit);
          return;
        }
        this._initFromForm();
      };
      tryInit();
    }

    get form() {
      return (
        document.getElementById(this.formId) ||
        document.forms.namedItem(this.formId) ||
        document.forms[this.formId]
      );
    }

    get variantPicker() {
      return document.querySelector(`variant-picker[form-id="${this.formId}"]`);
    }

    _normalizePresets(presets) {
      const fallbackQtyByPreset = { 1: 4, 2: 8, 3: 1, 4: 4 };
      return presets.map((preset, index) => {
        const presetIndex = parseInt(preset.presetIndex, 10) || index + 1;
        const indexQuantity = this.useKitIndexAsQuantity ? presetIndex : null;
        return {
          ...preset,
          presetIndex,
          quantity:
            indexQuantity ||
            parseInt(preset.quantity, 10) ||
            fallbackQtyByPreset[presetIndex] ||
            1,
          discountPercent: this._parseDiscountPercent(preset.discountPercent),
          customCompareCents: parseInt(preset.customCompareCents, 10) || 0,
          bundleGroup: preset.bundleGroup || null,
          noGifts: Boolean(preset.noGifts)
        };
      });
    }

    _parseDiscountPercent(value) {
      const parsed = parseFloat(String(value ?? '').replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : 0;
    }

    _getImplicitKitTierDiscountPercent(quantity) {
      if (!this.useKitIndexAsQuantity) return 0;
      const tierDiscounts = {
        1: 0,
        2: 12.4249,
        3: 16.5665,
        4: 24.8998
      };
      return tierDiscounts[quantity] || 0;
    }

    _resolveVariantPricingDiscount(quantity, configuredDiscount) {
      const configured = this._parseDiscountPercent(configuredDiscount);
      if (configured > 0) return configured;
      return this._getImplicitKitTierDiscountPercent(quantity);
    }

    _hasOptionalExtraSlots() {
      return this.flexibleSelection || this.optionalExtraSlot;
    }

    _getMaxSelectableQty() {
      if (this.flexibleSelection) return this._getFlexibleMaxQty();
      if (this.optionalExtraSlot) {
        const maxKit = this._getMaxKitQuantity();
        return maxKit > 0 ? maxKit : this._optionalMaxExtraQty;
      }
      return this._getRequiredQty();
    }

    _getMaxSelectableQtyForKitValue(kitValue, presetIndex) {
      if (!this.flexibleSelection) {
        return this._getPresetQuantityForKitValue(kitValue) || this._getRequiredQty();
      }

      const index =
        parseInt(presetIndex, 10) || this._getPresetIndexForKitValue(kitValue) || 1;
      const config = this._getFlexiblePresetConfig(index);
      const targetQty = this._getPresetQuantityForKitValue(kitValue);

      if (config?.autoUpgrade && targetQty && !this._isSingleKitFlexible()) return targetQty;
      if (config?.unlimitedExtras || config?.allowExtras) return this._flexibleMaxExtraQty;
      return targetQty || this._getBaseRequiredQty();
    }

    _getFlexiblePresetConfig(presetIndex) {
      if (!this.flexibleSelection || !this.flexibleConfig?.presets) return null;
      return this.flexibleConfig.presets[String(presetIndex)] || null;
    }

    _presetHasVolumeDiscount(presetIndex) {
      const config = this._getFlexiblePresetConfig(presetIndex);
      return Boolean(config?.volumeTiers?.length);
    }

    _flexiblePresetAllowsExtras(presetIndex) {
      if (!this.flexibleSelection) return false;
      const config = this._getFlexiblePresetConfig(presetIndex);
      return Boolean(config?.unlimitedExtras || config?.allowExtras);
    }

    _getBaseRequiredQty() {
      const presetQty = parseInt(this.activePreset?.quantity, 10);
      if (presetQty) return presetQty;
      const rowQty = parseInt(this._getSelectedKitRow()?.getAttribute('data-preset-quantity'), 10);
      if (rowQty) return rowQty;
      return 1;
    }

    _getEffectiveSelectionCount() {
      if (this.drawer?.open) {
        return this._getDrawerTotalQty();
      }
      return this.selections.length;
    }

    _getPricingQuantity() {
      if (this.optionalExtraSlot && this.useKitIndexAsQuantity) {
        const count = this._getEffectiveSelectionCount();
        if (count <= 0) return this._getBaseRequiredQty();
        return count;
      }
      if (!this.flexibleSelection) {
        return this._getRequiredQty();
      }
      const effective = this._getEffectiveSelectionCount();
      const base = this._getBaseRequiredQty();
      return Math.max(effective, base);
    }

    _getDiscountScaleQuantity() {
      const base = this._getPricingQuantity();
      if (this._isGift1OptInDeclined()) return base;
      return base + 1;
    }

    _getPresetPricingQuantity(preset) {
      return parseInt(preset?.quantity, 10) || 0;
    }

    _getGratisExtraCompareCents(presetIndex) {
      if (!this.gratisExtraEnabled) return 0;
      if (!this._isGratisExtraPresetActive(presetIndex)) return 0;
      const configuredCompare = this.gratisExtraCompareCents || 0;
      if (configuredCompare > 0) return configuredCompare;
      if (this.gratisExtraSelection) {
        return this._getVariantCompareCentsForCart(this.gratisExtraSelection.variantId);
      }
      return 0;
    }

    _getPromoGiftsCompareCents() {
      if (!this.promoGiftsEnabled) return 0;
      if (this.promoGiftsCompareCents > 0) {
        return this.promoGiftsCompareCents * this.promoGiftsCount;
      }
      return (this.promoGiftSelections || []).reduce((sum, selection) => {
        return sum + this._getVariantCompareCentsForCart(selection.variantId);
      }, 0);
    }

    _getCompareExtrasCents(quantity, presetIndex) {
      return (
        this._getGiftCompareForQuantity(quantity, presetIndex) +
        this._getGratisExtraCompareCents(presetIndex) +
        this._getPromoGiftsCompareCents()
      );
    }

    _getOptionalTierQuantity(count) {
      const row = this._getKitRowForSelectionCount(count);
      return parseInt(row?.getAttribute('data-preset-quantity'), 10) || count;
    }

    _getOptionalPricingDiscount() {
      const count = this._getEffectiveSelectionCount();
      const tierQty = count > 0 ? this._getOptionalTierQuantity(count) : this._getBaseRequiredQty();
      const preset = this._getPresetForQuantity(tierQty);
      return preset?.discountPercent || this.activePreset?.discountPercent || 0;
    }

    _getOptionalPricingKitRow(count) {
      if (count <= 0) return this._getSelectedKitRow();
      return this._getKitRowForSelectionCount(count) || this._getSelectedKitRow();
    }

    _getPresetForQuantity(qty) {
      const parsedQty = parseInt(qty, 10);
      if (!parsedQty) return null;
      return (
        this.presets.find((preset) => preset.quantity === parsedQty) ||
        this.presets.find((preset) => preset.presetIndex === parsedQty) ||
        null
      );
    }

    _calcOptionalTierPricing(qty) {
      const row = this._getKitRowForSelectionCount(qty);
      if (!row) return { finalTotal: 0, compareTotal: 0, savings: 0 };
      const preset = this._getPresetForRow(row);
      return this._calcPresetPricing(
        qty,
        preset?.discountPercent || 0,
        {},
        this._getKitVariantCents(row),
        this._getKitVariantCompareCents(row),
        preset?.presetIndex
      );
    }

    _getOptionalUpgradeProgress() {
      return null;
    }

    _shouldTriggerCurrentGoalCelebration(total, previousTotal, required) {
      if (required <= 0 || total < required || previousTotal >= required) return false;

      if (this.flexibleSelection) {
        return parseInt(this.activePreset?.presetIndex, 10) === 2;
      }

      if (this.optionalExtraSlot && this.useKitIndexAsQuantity) return true;

      return !this.optionalExtraSlot;
    }

    _shouldClearGoalCelebration(total, required) {
      if (this.flexibleSelection) {
        const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
        if (presetIndex === 2) return total < required;
        return true;
      }
      if (this.optionalExtraSlot && this.useKitIndexAsQuantity) return total < required;
      return !this.optionalExtraSlot && total < required;
    }

    _getGoalCelebrationMessage(total, required) {
      if (this.flexibleSelection && parseInt(this.activePreset?.presetIndex, 10) === 2) {
        return (
          this.flexibleConfig?.profiBestpriceGoalText || 'Wow! Du hast den Bestpreis erreicht!'
        );
      }
      return null;
    }

    _getTopVolumeTierQuantity(presetIndex) {
      const config = this._getFlexiblePresetConfig(presetIndex);
      if (!config?.volumeTiers?.length) return 0;
      return Math.max(
        ...config.volumeTiers.map((tier) => parseInt(tier.quantity, 10) || 0),
        0
      );
    }

    _getVolumeBestpriceGoalText() {
      return (
        this.flexibleConfig?.volumeBestpriceGoalText || '🎉 Maximalen Rabatt freigeschaltet'
      );
    }

    _getVolumeBestpriceGoalDuration() {
      const configured = parseInt(this.flexibleConfig?.volumeBestpriceGoalDuration, 10);
      return Number.isFinite(configured) && configured > 0 ? configured : 3000;
    }

    _isVolumeBestpriceGoalMessage(message) {
      if (!message) return false;
      const knownTexts = [this.flexibleConfig?.volumeBestpriceGoalText].filter(Boolean);
      return (
        knownTexts.includes(message) ||
        /maximalen rabatt freigeschaltet/i.test(message) ||
        /maximaler rabatt erreicht/i.test(message)
      );
    }

    _getBestpriceProgressText() {
      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      if (this._presetHasVolumeDiscount(presetIndex)) {
        return (
          this.flexibleConfig?.volumeBestpriceProgressText || '🛒 Shoppe weiter zum Bestpreis'
        );
      }
      return (
        this.flexibleConfig?.bestpriceProgressText ||
        '🛒 Shoppe unbegrenzt weiter zum Bestpreis'
      );
    }

    _isBestpriceGoalMessage(message) {
      if (!message) return false;
      if (this._isVolumeBestpriceGoalMessage(message)) return true;
      const knownTexts = [
        this.flexibleConfig?.profiBestpriceGoalText,
        this.flexibleConfig?.bestpriceGoalText,
        this.getAttribute('data-bestprice-goal-text'),
        'Wow! Du hast den Bestpreis erreicht!'
      ].filter(Boolean);
      return knownTexts.includes(message) || /bestpreis/i.test(message);
    }

    _getGoalToastDuration(message) {
      if (this._isVolumeBestpriceGoalMessage(message)) {
        return this._getVolumeBestpriceGoalDuration();
      }
      if (this._isBestpriceGoalMessage(message)) {
        return this._getBestpriceGoalToastDuration();
      }
      return 1500;
    }

    _getBestpriceGoalToastDuration() {
      const configured = parseInt(this.flexibleConfig?.bestpriceGoalDuration, 10);
      return Number.isFinite(configured) && configured > 0 ? configured : 4000;
    }

    _clearFlexibleVolumeGoalBanner() {
      clearTimeout(this._flexibleVolumeGoalTimeout);
      this._flexibleVolumeGoalTimeout = null;
      this._flexibleVolumeGoalActive = false;
      this._ensureDrawerUpgradeProgressRefs();
      if (this.drawerUpgradeProgressText) {
        this.drawerUpgradeProgressText.textContent = '';
      }
    }

    _showFlexibleVolumeGoalBanner(message) {
      const banner = this.querySelector('[data-flexible-progress-banner]');
      const progressTextEl = this.querySelector('[data-flexible-progress-text]');
      const progressBadgeEl = this.querySelector('[data-flexible-progress-badge]');
      if (!banner || !progressTextEl) return;

      this._clearFlexibleVolumeGoalBanner();
      this._flexibleVolumeGoalActive = true;
      banner.hidden = false;
      banner.classList.remove('is-inline-progress');
      progressTextEl.textContent = message;
      if (progressBadgeEl) {
        progressBadgeEl.hidden = true;
        progressBadgeEl.textContent = '';
      }
      this._setFlexibleProgressInteractiveState(banner, null);

      this._ensureDrawerUpgradeProgressRefs();
      if (this.drawerUpgradeProgress) {
        this.drawerUpgradeProgress.hidden = false;
        if (this.drawerUpgradeProgressText) {
          this.drawerUpgradeProgressText.textContent = message;
        }
        if (this.drawerUpgradeProgressBadge) {
          this.drawerUpgradeProgressBadge.hidden = true;
          this.drawerUpgradeProgressBadge.textContent = '';
        }
        this._setFlexibleProgressInteractiveState(this.drawerUpgradeProgress, null);
      }

      this._flexibleVolumeGoalTimeout = setTimeout(() => {
        this._flexibleVolumeGoalActive = false;
        this._flexibleVolumeGoalTimeout = null;
        this._updateFlexibleProgressBanner();
      }, this._getVolumeBestpriceGoalDuration());
    }

    _maybeTriggerVolumeBestpriceCelebration(previousTotal, total) {
      if (!this.flexibleSelection) return;

      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      if (!this._presetHasVolumeDiscount(presetIndex)) return;

      const topTierQty = this._getTopVolumeTierQuantity(presetIndex);
      if (!topTierQty) return;

      if (total < topTierQty) {
        this._clearFlexibleVolumeGoalBanner();
        this._updateFlexibleProgressBanner();
        return;
      }

      if (previousTotal >= topTierQty) return;

      const message = this._getVolumeBestpriceGoalText();
      this._showFlexibleVolumeGoalBanner(message);
      this._triggerCelebration({
        ...this._getRecipeCelebrationContext(),
        message
      });
    }

    _updateOptionalProgressBanner() {
      this._ensureDrawerUpgradeProgressRefs();
      this._updateDrawerUpgradeProgress(this._getOptionalUpgradeProgress());
    }

    _getEffectivePresetIndexForPricing() {
      const presetIndex = parseInt(this.activePreset?.presetIndex, 10) || 1;
      if (!this.flexibleSelection) return presetIndex;

      const config = this._getFlexiblePresetConfig(presetIndex);
      if (config?.autoUpgrade) {
        const effectiveQty = this._getEffectiveSelectionCount();
        const upgradeAt = parseInt(config.upgradeAtQuantity, 10) || 8;
        const upgradeTo = parseInt(config.upgradeToPreset, 10) || 2;
        if (effectiveQty >= upgradeAt) return upgradeTo;
      }

      return presetIndex;
    }

    _getFlexibleDiscountPercent(presetIndex, effectiveQty) {
      const preset = this.presets.find((p) => p.presetIndex === presetIndex);
      const config = this._getFlexiblePresetConfig(presetIndex);

      if (config?.volumeTiers?.length) {
        let discount = preset?.discountPercent || 0;
        [...config.volumeTiers]
          .sort((a, b) => a.quantity - b.quantity)
          .forEach((tier) => {
            if (effectiveQty >= tier.quantity) {
              discount = this._parseDiscountPercent(tier.discountPercent);
            }
          });
        return discount;
      }

      if (config?.autoUpgrade) {
        const upgradeAt = parseInt(config.upgradeAtQuantity, 10) || 8;
        const upgradeTo = parseInt(config.upgradeToPreset, 10) || 2;
        if (effectiveQty >= upgradeAt) {
          const targetPreset = this.presets.find((p) => p.presetIndex === upgradeTo);
          return targetPreset?.discountPercent || 0;
        }
        return 0;
      }

      return preset?.discountPercent || 0;
    }

    _getActiveDiscountPercent() {
      if (this.optionalExtraSlot && this.useKitIndexAsQuantity) {
        return this._getOptionalPricingDiscount();
      }
      if (!this.flexibleSelection) {
        return this.activePreset?.discountPercent || 0;
      }
      const presetIndex = parseInt(this.activePreset?.presetIndex, 10) || 1;
      const pricingPresetIndex = this._getEffectivePresetIndexForPricing();
      const effectiveQty = this._presetHasVolumeDiscount(presetIndex)
        ? this._getEffectiveSelectionCount()
        : this._getPricingQuantity();
      if (this._presetHasVolumeDiscount(presetIndex)) {
        return this._getFlexibleDiscountPercent(presetIndex, effectiveQty);
      }
      return this._getFlexibleDiscountPercent(pricingPresetIndex, effectiveQty);
    }

    _normalizeBundleGroup(value) {
      return sanitizeBundleGroup(value);
    }

    _getEffectiveBundleGroup() {
      if (this._isGift1OptInDeclined()) {
        const declineGroup = this._normalizeBundleGroup(this.gift1DeclineBundleGroup);
        if (declineGroup) return declineGroup;
      }

      if (this.hideKitSelection) {
        const hostGroup = this._normalizeBundleGroup(this.bundleGroup);
        if (hostGroup) return hostGroup;
      }

      const rowGroup = this._normalizeBundleGroup(
        this._getSelectedKitRow()?.getAttribute('data-bundle-group')
      );
      if (rowGroup) return rowGroup;

      const presetGroup = this._normalizeBundleGroup(this.activePreset?.bundleGroup);
      if (presetGroup) return presetGroup;

      if (this.flexibleSelection) {
        const pricingPresetIndex = this._getEffectivePresetIndexForPricing();
        const effectiveConfigGroup = this._normalizeBundleGroup(
          this._getFlexiblePresetConfig(pricingPresetIndex)?.bundleGroup
        );
        if (effectiveConfigGroup) return effectiveConfigGroup;
      }

      return this.bundleGroup;
    }

    _getBundleCartTitle(preset) {
      const presetTitle = preset?.cartTitle?.trim();
      if (presetTitle) return presetTitle;
      return this.bundleTitle;
    }

    _getKitRowCount() {
      return this.querySelectorAll('[data-bundle-kit-row]').length;
    }

    _isSingleKitFlexible() {
      return this.flexibleSelection && this._getKitRowCount() <= 1;
    }

    _getFlexibleMaxQty() {
      const presetIndex = parseInt(this.activePreset?.presetIndex, 10) || 1;
      const config = this._getFlexiblePresetConfig(presetIndex);
      if (config?.autoUpgrade && !this._isSingleKitFlexible()) {
        return this._getBaseRequiredQty();
      }
      if (config?.unlimitedExtras || config?.allowExtras) {
        return this._flexibleMaxExtraQty;
      }
      return this._getBaseRequiredQty();
    }

    _getMaxKitQuantity() {
      const rows = [...this.querySelectorAll('[data-bundle-kit-row]')];
      if (!rows.length) return 0;
      return Math.max(
        ...rows.map((row) => parseInt(row.getAttribute('data-preset-quantity'), 10) || 0),
        0
      );
    }

    _isAtMaxKitTier() {
      const maxQty = this._getMaxKitQuantity();
      if (!maxQty) return false;
      return this._getBaseRequiredQty() >= maxQty;
    }

    _checkFlexibleUpgrade() {
      if (!this.flexibleSelection || this._flexibleUpgradeInProgress) return;

      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      const config = this._getFlexiblePresetConfig(presetIndex);
      if (!config?.autoUpgrade || this._isSingleKitFlexible()) return;

      const effectiveQty = this._getEffectiveSelectionCount();
      const upgradeAt = parseInt(config.upgradeAtQuantity, 10) || 8;
      const upgradeTo = parseInt(config.upgradeToPreset, 10) || 2;

      if (effectiveQty < upgradeAt || presetIndex === upgradeTo) return;

      const row = this.querySelector(`[data-bundle-kit-row][data-preset-index="${upgradeTo}"]`);
      if (!row) return;

      this._autoSelectKit(row);
    }

    _getKitRowForSelectionCount(count) {
      const rows = [...this.querySelectorAll('[data-bundle-kit-row]')];
      if (!rows.length || count <= 0) return null;

      const presetQuantities = rows
        .map((row) => parseInt(row.getAttribute('data-preset-quantity'), 10) || 0)
        .filter((qty) => qty > 0);
      const maxQty = Math.max(...presetQuantities, 0);
      const targetQty = Math.min(count, maxQty);

      return (
        rows.find((row) => parseInt(row.getAttribute('data-preset-quantity'), 10) === targetQty) ||
        null
      );
    }

    _checkOptionalKitSync() {
      if (
        !this.optionalExtraSlot ||
        !this.useKitIndexAsQuantity ||
        this._flexibleUpgradeInProgress
      ) {
        return;
      }

      const count = this._getEffectiveSelectionCount();
      if (count <= 0) return;

      const targetRow = this._getKitRowForSelectionCount(count);
      if (!targetRow) return;

      const currentQty = this._getBaseRequiredQty();
      const targetQty = parseInt(targetRow.getAttribute('data-preset-quantity'), 10);
      if (targetQty <= currentQty) return;

      this._autoSelectKit(targetRow, { preserveSelections: true });
    }

    _syncOptionalAfterSelectionChange() {
      if (!this.optionalExtraSlot) return;
      this._checkOptionalKitSync();
      this._updateKitRowPricing();
      this._updateKitRowSwitchability();
      this._updateDrawerPricing();
      this._syncDrawerQtyDisplay();
      this._updateOptionalProgressBanner();
      this._updateUi();
    }

    _autoSelectKit(row, options = {}) {
      const { preserveSelections = false } = options;
      if (!row || this._flexibleUpgradeInProgress) return;

      this._flexibleUpgradeInProgress = true;
      try {
        const kitValue = row.getAttribute('data-kit-value');
        const optionValueId = row.getAttribute('data-option-value-id');
        const presetIndex = row.getAttribute('data-preset-index');
        const variantId = row.getAttribute('data-variant-id');
        const preservedSelections = preserveSelections ? [...this.selections] : null;
        const preservedDrawerQty =
          preserveSelections && this.drawer?.open ? { ...this.drawerQuantities } : null;

        if (variantId) {
          this._setFormVariantId(variantId);
        }
        this._setKitOptionInForm(optionValueId);
        this._syncGalleryForKitRow(row);

        this.querySelectorAll('[data-bundle-kit-row]').forEach((r) => {
          r.classList.toggle('is-selected', r === row);
          r.toggleAttribute('aria-current', r === row);
        });

        const previousKit = this.activePreset?.kitValue;
        if (previousKit && previousKit !== kitValue) {
          this._saveSelectionsForPreset(previousKit);
        }

        this._applyPresetForKit(kitValue, presetIndex);

        if (preserveSelections) {
          if (preservedSelections) this.selections = this._sanitizeSelections(preservedSelections);
          if (preservedDrawerQty) {
            const sanitizedDrawerQty = {};
            Object.entries(preservedDrawerQty).forEach(([variantId, count]) => {
              const product = this.products.find((entry) => String(entry.variant_id) === variantId);
              if (this._isProductAvailable(product) && count) {
                sanitizedDrawerQty[variantId] = count;
              }
            });
            this.drawerQuantities = sanitizedDrawerQty;
          }
          if (kitValue) this._saveSelectionsForPreset(kitValue);
        } else {
          const incoming = preservedSelections?.length
            ? preservedSelections
            : this._getIncomingSelections(previousKit);
          this._loadSelectionsForPreset(kitValue, previousKit, incoming);
        }

        this._renderSlots();
        if (this.flexibleSelection) {
          this._updateFlexibleProgressBanner();
        }
        this._updateKitRowPricing();
        this._updateKitRowSwitchability();
        this._updateUi();
        this._updateDrawerPricing();
        this._syncDrawerQtyDisplay();
        this._placeKitGifts(presetIndex);
      } finally {
        this._flexibleUpgradeInProgress = false;
      }
    }

    _getFlexibleUpgradeProgress() {
      if (!this.flexibleSelection) return null;

      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      const config = this._getFlexiblePresetConfig(presetIndex);
      if (!config?.autoUpgrade) return null;
      if (presetIndex === 1) return null;

      const effectiveQty = this._getEffectiveSelectionCount();
      const baseQty = this._getBaseRequiredQty();
      const upgradeAt = parseInt(config.upgradeAtQuantity, 10) || 8;
      const upgradeTo = parseInt(config.upgradeToPreset, 10) || 2;

      if (effectiveQty >= upgradeAt || effectiveQty < baseQty) return null;
      if (!config.upgradeRewardLabel) return null;
      if (presetIndex === upgradeTo) return null;

      const remaining = upgradeAt - effectiveQty;
      const rewardLabel = String(config.upgradeRewardLabel)
        .replace(/^gratis\s+/i, '')
        .trim();

      return {
        remaining,
        rewardLabel: config.upgradeRewardLabel,
        progressText: `Noch ${remaining} für`,
        badgeText: rewardLabel ? `GRATIS ${rewardLabel}` : 'GRATIS'
      };
    }

    _getFlexibleVolumeProgress() {
      if (!this.flexibleSelection) return null;

      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      if (!this._presetHasVolumeDiscount(presetIndex)) return null;

      const config = this._getFlexiblePresetConfig(presetIndex);
      if (!config?.volumeTiers?.length) return null;

      const count = this._getEffectiveSelectionCount();
      const nudgeMap = this.flexibleConfig?.volumeNudgeTexts || {};
      const customNudge = nudgeMap[String(count)] || nudgeMap[count];
      if (customNudge) {
        return {
          type: 'volume-nudge',
          html: customNudge
        };
      }

      const tiers = [...config.volumeTiers].sort((a, b) => a.quantity - b.quantity);

      for (let i = 0; i < tiers.length; i += 1) {
        const tier = tiers[i];
        const tierQty = parseInt(tier.quantity, 10) || 0;
        if (!tierQty || count >= tierQty) continue;

        const remaining = tierQty - count;
        const discountLabel = String(tier.discountPercent ?? '')
          .trim()
          .replace('.', ',');
        return {
          remaining,
          rewardLabel: `${discountLabel}% Rabatt`,
          progressText: `Noch ${remaining} für`,
          badgeText: `${discountLabel}% RABATT`
        };
      }

      return null;
    }

    _getFlexibleStarterProfiSavingsProgress() {
      if (!this.flexibleSelection) return null;

      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      if (presetIndex !== 1) return null;

      const starterQty = this._getBaseRequiredQty();
      const count = this._getEffectiveSelectionCount();
      if (!starterQty || count < starterQty) return null;

      const starterRow = this.querySelector('[data-bundle-kit-row][data-preset-index="1"]');
      const profiRow = this.querySelector('[data-bundle-kit-row][data-preset-index="2"]');
      if (!starterRow || !profiRow) return null;

      const starterPreset = this._getPresetForRow(starterRow);
      const profiPreset = this._getPresetForRow(profiRow);
      if (!starterPreset || !profiPreset) return null;

      const profiQty = parseInt(profiRow.getAttribute('data-preset-quantity'), 10) || 8;
      const quantities = this._selectionsToQuantities(this.selections || []);

      const starterPricing = this._calcPresetPricing(
        starterQty,
        starterPreset.discountPercent || 0,
        quantities,
        this._getKitVariantCents(starterRow),
        this._getKitVariantCompareCents(starterRow),
        starterPreset.presetIndex
      );

      const profiPricing = this._calcPresetPricing(
        profiQty,
        profiPreset.discountPercent || 0,
        quantities,
        this._getKitVariantCents(profiRow),
        this._getKitVariantCompareCents(profiRow),
        profiPreset.presetIndex
      );

      const additionalSavings = Math.max(0, profiPricing.savings - starterPricing.savings);
      if (additionalSavings <= 0) return null;

      return {
        type: 'starter-profi-upsell',
        action: 'switch-profi',
        html: this._buildStarterProfiSavingsHtml(additionalSavings)
      };
    }

    _buildStarterProfiSavingsHtml(amountCents) {
      const amount = formatMoney(amountCents);
      const kitLabel = this.flexibleConfig?.starterProfiSavingsBadge || 'Profi-Kit';
      const template =
        this.flexibleConfig?.starterProfiSavingsText || 'Spare weitere __AMOUNT__ im';
      const amountBadge = `<span class="badge badge--primary bk-media-bundle-builder__flexible-progress-inline-badge">${amount}</span>`;
      const text = template.replace(/__AMOUNT__|\{amount\}/g, amountBadge);
      return `${text} ${kitLabel}`;
    }

    _getFlexibleVolumeBestpriceProgress() {
      if (!this.flexibleSelection) return null;

      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      if (!this._presetHasVolumeDiscount(presetIndex)) return null;

      const topTierQty = this._getTopVolumeTierQuantity(presetIndex);
      if (!topTierQty) return null;

      const count = this._getEffectiveSelectionCount();
      const baseQty = this._getBaseRequiredQty();
      if (count < topTierQty || count < baseQty) return null;

      return { type: 'bestprice' };
    }

    _getFlexibleProfiBestpriceProgress() {
      if (!this.flexibleSelection) return null;

      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      if (presetIndex !== 2) return null;

      const count = this._getEffectiveSelectionCount();
      const baseQty = this._getBaseRequiredQty();
      if (!baseQty || count < baseQty) return null;

      return { type: 'bestprice' };
    }

    _getFlexibleProgress() {
      return (
        this._getFlexibleProfiBestpriceProgress() ||
        this._getFlexibleVolumeBestpriceProgress() ||
        this._getFlexibleStarterProfiSavingsProgress() ||
        this._getFlexibleUpgradeProgress() ||
        this._getFlexibleVolumeProgress()
      );
    }

    _setFlexibleProgressInteractiveState(element, progress) {
      if (!element) return;
      const isClickable = progress?.action === 'switch-profi';
      element.classList.toggle('is-clickable', isClickable);
      if (isClickable) {
        element.setAttribute('role', 'button');
        element.tabIndex = 0;
      } else {
        element.removeAttribute('role');
        element.removeAttribute('tabindex');
      }
    }

    _switchToProfiKitFromStarterUpsell(options = {}) {
      const row = this.querySelector('[data-bundle-kit-row][data-preset-index="2"]');
      if (!row) return;
      const kitValue = row.getAttribute('data-kit-value');
      if (!this._canSwitchToKit(kitValue)) {
        this._highlightMissing(row);
        return;
      }
      const keepDrawerOpen = options.fromDrawer ?? Boolean(this.drawer?.open);
      this._selectKit(row, { keepDrawerOpen });
    }

    _handleFlexibleProgressAction(progress, options = {}) {
      if (progress?.action === 'switch-profi') {
        this._switchToProfiKitFromStarterUpsell(options);
      }
    }

    _updateFlexibleProgressBanner() {
      if (this._flexibleVolumeGoalActive) return;

      const banner = this.querySelector('[data-flexible-progress-banner]');
      const progressTextEl = this.querySelector('[data-flexible-progress-text]');
      const progressBadgeEl = this.querySelector('[data-flexible-progress-badge]');
      const progress = this._getFlexibleProgress();
      const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
      const selectionCount = this._getEffectiveSelectionCount();
      const showBanner =
        Boolean(progress) && !(this._presetHasVolumeDiscount(presetIndex) && selectionCount < 1);

      if (banner) {
        if (!showBanner) {
          banner.hidden = true;
          this._setFlexibleProgressInteractiveState(banner, null);
          banner.classList.remove('is-inline-progress');
        } else {
          banner.hidden = false;

          if (progress.type === 'bestprice') {
            if (progressTextEl) {
              const bestpriceText = this._getBestpriceProgressText();
              if (bestpriceText.includes('<')) {
                progressTextEl.innerHTML = bestpriceText;
              } else {
                progressTextEl.textContent = bestpriceText;
              }
            }
            if (progressBadgeEl) {
              progressBadgeEl.hidden = true;
              progressBadgeEl.textContent = '';
            }
          } else if (progress.html) {
            if (progressTextEl) {
              progressTextEl.innerHTML = progress.html;
            }
            if (progressBadgeEl) {
              progressBadgeEl.hidden = true;
              progressBadgeEl.textContent = '';
            }
          } else {
            if (progressTextEl) {
              progressTextEl.textContent = progress.progressText || '';
            }
            if (progressBadgeEl) {
              if (progress.badgeText) {
                progressBadgeEl.textContent = progress.badgeText;
                progressBadgeEl.hidden = false;
              } else {
                progressBadgeEl.hidden = true;
                progressBadgeEl.textContent = '';
              }
            }
          }

          this._setFlexibleProgressInteractiveState(banner, progress);
          banner.classList.toggle('is-inline-progress', progress.type === 'starter-profi-upsell');
        }
      }

      const shippingBanner = this.querySelector('[data-flexible-shipping-banner]');
      if (shippingBanner) {
        const minQty = parseInt(this.flexibleConfig?.shippingBannerMinQty, 10) || 0;
        shippingBanner.hidden = !(minQty > 0 && selectionCount >= minQty);
      }

      this._updateDrawerUpgradeProgress(progress);
    }

    _updateDrawerUpgradeProgress(progress) {
      const wrap = this.drawerUpgradeProgress;
      if (!wrap) return;

      if (!progress) {
        wrap.hidden = true;
        wrap.classList.remove('is-inline-progress');
        this._setFlexibleProgressInteractiveState(wrap, null);
        return;
      }

      if (progress.type === 'starter-profi-upsell') {
        wrap.hidden = true;
        wrap.classList.remove('is-inline-progress');
        this._setFlexibleProgressInteractiveState(wrap, null);
        return;
      }

      if (progress.type === 'bestprice') {
        wrap.hidden = false;
        if (this.drawerUpgradeProgressText) {
          this.drawerUpgradeProgressText.textContent = this._getBestpriceProgressText();
        }
        if (this.drawerUpgradeProgressBadge) {
          this.drawerUpgradeProgressBadge.hidden = true;
          this.drawerUpgradeProgressBadge.textContent = '';
        }
        this._setFlexibleProgressInteractiveState(wrap, null);
        return;
      }

      if (this.drawerUpgradeProgressText) {
        if (progress.html) {
          this.drawerUpgradeProgressText.innerHTML = progress.html;
        } else {
          this.drawerUpgradeProgressText.textContent = progress.progressText || '';
        }
      }
      if (this.drawerUpgradeProgressBadge) {
        if (progress.html || !progress.badgeText) {
          this.drawerUpgradeProgressBadge.hidden = true;
          this.drawerUpgradeProgressBadge.textContent = '';
        } else {
          this.drawerUpgradeProgressBadge.hidden = false;
          this.drawerUpgradeProgressBadge.textContent = progress.badgeText;
        }
      }
      wrap.hidden = false;
      wrap.classList.toggle('is-inline-progress', progress.type === 'starter-profi-upsell');
      this._setFlexibleProgressInteractiveState(wrap, progress);
    }

    _syncFlexibleAfterSelectionChange() {
      if (!this.flexibleSelection) return;
      const previousTotal = this._flexibleLastSelectionCount ?? 0;
      const total = this._getEffectiveSelectionCount();
      this._maybeTriggerVolumeBestpriceCelebration(previousTotal, total);
      this._flexibleLastSelectionCount = total;
      this._checkFlexibleUpgrade();
      this._updateFlexibleProgressBanner();
      this._updateKitRowPricing();
      this._updateKitRowSwitchability();
      this._updateDrawerPricing();
      this._syncDrawerQtyDisplay();
      this._updateUi();
    }

    _applyBundleDiscount(bundleBaseCents, discountPercent) {
      const base = bundleBaseCents || 0;
      if (!base) return 0;
      const discountBps = Math.round(this._parseDiscountPercent(discountPercent) * 100);
      return Math.floor((base * (10000 - discountBps)) / 10000);
    }

    _applyScaledSubtotalDiscount(subtotalCents, discountPercent) {
      const subtotal = subtotalCents || 0;
      if (!subtotal) return 0;
      const discountBps = Math.round(this._parseDiscountPercent(discountPercent) * 100);
      return Math.round((subtotal * (10000 - discountBps)) / 10000);
    }

    _applyCardsOrderDiscount(unitCents, quantity, discountPercent) {
      const unit = unitCents || 0;
      const qty = quantity || 0;
      if (!unit || !qty) return 0;
      const discount = this._parseDiscountPercent(discountPercent);
      const subtotal = unit * qty;
      if (qty === 3) {
        const discountBps = Math.round(discount * 100);
        return Math.round((subtotal * (10000 - discountBps)) / 10000);
      }
      const discountBps = Math.round(discount * 100);
      const unitDiscount = Math.floor((unit * discountBps) / 10000);
      return (unit - unitDiscount) * qty;
    }

    _getCardsOnlyGiftCompare(quantity) {
      if (this.giftMode !== 'single_always' || quantity !== 1) return 0;
      return this._getGiftCompareForQuantity(quantity);
    }

    _getDrawerOpenFrom(side = 'right') {
      const query =
        window.themeVariables?.breakpoints?.['sm-max'] || 'screen and (max-width: 699px)';
      return window.matchMedia(query).matches ? 'bottom' : side;
    }

    _configureDrawer() {
      if (!this.drawer) return;
      Object.defineProperty(this.drawer, 'openFrom', {
        get: () => 'right',
        configurable: true
      });
    }

    _setFormVariantId(variantId) {
      const form = this.form;
      if (!form || !variantId) return;
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;
      idInput.disabled = false;
      idInput.value = String(variantId);
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    _getVariantById(variantId) {
      if (!variantId) return null;
      return this.variants.find((variant) => String(variant.id) === String(variantId)) || null;
    }

    _buildGalleryVariantPayload(variant) {
      if (!variant) return null;
      return {
        id: variant.id,
        featured_media:
          variant.featured_media_id != null
            ? {
                id: variant.featured_media_id,
                position: variant.featured_media_position
              }
            : null
      };
    }

    _syncGalleryForKitRow(row) {
      if (!row || this.variantPicker) return;
      const variant = this._getVariantById(row.getAttribute('data-variant-id'));
      if (!variant) return;
      this._syncGalleryWithoutPicker(variant);
    }

    async _syncGalleryWithoutPicker(variant) {
      const form = this.form;
      if (!form || !variant?.id) return;

      const sectionId = this.getAttribute('data-section-id');
      const handle = this.getAttribute('data-product-handle');
      const previousVariant = this._lastGalleryVariant || null;
      const nextVariant = this._buildGalleryVariantPayload(variant);

      if (!sectionId || !handle) {
        this._applyGalleryFilterDom(variant);
        this._dispatchGalleryVariantChange(form, nextVariant, previousVariant);
        this._lastGalleryVariant = nextVariant;
        return;
      }

      const requestId = (this._gallerySyncRequestId = (this._gallerySyncRequestId || 0) + 1);

      try {
        const root = window.Shopify?.routes?.root || '/';
        const url = `${root}products/${handle}?variant=${variant.id}&section_id=${encodeURIComponent(sectionId)}`;
        const html = await (await fetch(url)).text();
        if (requestId !== this._gallerySyncRequestId) return;

        const fragment = document.createRange().createContextualFragment(html);
        form.dispatchEvent(
          new CustomEvent('product:rerender', {
            detail: { htmlFragment: fragment, productChange: false }
          })
        );
        this._dispatchGalleryVariantChange(form, nextVariant, previousVariant);
        this._lastGalleryVariant = nextVariant;

        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', String(variant.id));
        window.history.replaceState({ path: nextUrl.toString() }, '', nextUrl.toString());
      } catch (_error) {
        if (requestId !== this._gallerySyncRequestId) return;
        this._applyGalleryFilterDom(variant);
        this._dispatchGalleryVariantChange(form, nextVariant, previousVariant);
        this._lastGalleryVariant = nextVariant;
      }
    }

    _dispatchGalleryVariantChange(form, variant, previousVariant) {
      if (!form || !variant) return;
      this._suppressVariantChangeHandling = true;
      try {
        form.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: {
              formId: form.id,
              variant,
              previousVariant
            }
          })
        );
      } finally {
        this._suppressVariantChangeHandling = false;
      }
    }

    _applyGalleryFilterDom(variant) {
      const gallery = document.querySelector(`product-gallery[form="${this.formId}"]`);
      if (!gallery || !variant) return;

      const kitValue = String(getVariantOptions(variant)[this.kitOptionIndex] || '')
        .trim()
        .toLowerCase();
      if (!kitValue) return;

      const mediaItems = Array.from(gallery.querySelectorAll('.product-gallery__media'));
      const filteredIndexes = [];

      mediaItems.forEach((mediaEl, index) => {
        const alt =
          mediaEl.querySelector('img')?.getAttribute('alt') ||
          mediaEl.querySelector('img')?.alt ||
          '';
        if (!alt.includes('#')) return;

        const groupValue = alt.split('#').pop().split('_').pop().trim().toLowerCase();
        if (groupValue && groupValue !== kitValue) {
          filteredIndexes.push(index);
        }
      });

      gallery.setAttribute(
        'filtered-indexes',
        JSON.stringify(filteredIndexes.map((index) => index + 1))
      );

      gallery.querySelectorAll('media-carousel').forEach((carousel) => {
        carousel.dispatchEvent(
          new CustomEvent('carousel:filter', { detail: { filteredIndexes } })
        );
      });
      gallery.querySelectorAll('page-dots').forEach((pageDots) => {
        pageDots.dispatchEvent(
          new CustomEvent('control:filter', { detail: { filteredIndexes } })
        );
      });
    }

    _getSelectedKitVariantId() {
      const selectedRow = this.querySelector('[data-bundle-kit-row].is-selected');
      const rowVariantId = selectedRow?.getAttribute('data-variant-id');
      if (rowVariantId) return parseInt(rowVariantId, 10);
      return this._getCurrentVariant()?.id || null;
    }

    _getSelectedPresetIndex() {
      const selectedRow = this._getSelectedKitRow();
      const presetIndex = parseInt(selectedRow?.getAttribute('data-preset-index'), 10);
      if (presetIndex) return presetIndex;
      return parseInt(this.activePreset?.presetIndex, 10) || null;
    }

    _getParentVariantId() {
      if (this.hideKitSelection) {
        const hostVariantId = parseInt(this.getAttribute('data-parent-variant-id'), 10);
        if (hostVariantId) return hostVariantId;
        const defaultVariantId = parseInt(this.parentVariantMap?.defaultVariantId, 10);
        if (defaultVariantId) return defaultVariantId;
      }

      const selectedRow = this._getSelectedKitRow();
      const rowParentId = parseInt(selectedRow?.getAttribute('data-parent-variant-id'), 10);
      if (rowParentId) return rowParentId;

      const presetIndex = this._getSelectedPresetIndex();
      const parentMap = this.parentVariantMap;

      if (parentMap?.byPresetIndex && presetIndex && parentMap.byPresetIndex[presetIndex]) {
        return parseInt(parentMap.byPresetIndex[presetIndex], 10);
      }

      const kitValue = selectedRow?.getAttribute('data-kit-value');
      if (parentMap?.byKitValue && kitValue && parentMap.byKitValue[kitValue]) {
        return parseInt(parentMap.byKitValue[kitValue], 10);
      }

      if (parentMap?.defaultVariantId) {
        return parseInt(parentMap.defaultVariantId, 10);
      }

      const attrVariantId = parseInt(this.getAttribute('data-parent-variant-id'), 10);
      if (attrVariantId) return attrVariantId;

      return this._getSelectedKitVariantId();
    }

    _bindEvents() {
      this.querySelectorAll('[data-bundle-kit-row]').forEach((row) => {
        row.addEventListener('click', (e) => {
          if (this.hideKitSelection) return;
          const giftTrigger = e.target.closest('[data-bundle-kit-gift-trigger]');
          if (giftTrigger && row.classList.contains('is-selected')) {
            e.preventDefault();
            e.stopPropagation();
            const slot = parseInt(giftTrigger.getAttribute('data-gift-slot'), 10);
            const giftItem = this._getGiftItem(slot);
            if (!slot || this._isGiftSoldOut(giftItem)) return;
            this._openColorsDrawer(slot);
            return;
          }

          const kitValue = row.getAttribute('data-kit-value');
          if (!this._canSwitchToKit(kitValue)) {
            this._highlightMissing(row);
            return;
          }
          this._selectKit(row);
          if (e.isTrusted && this.scrollToFlavorStep) {
            this._scrollToFlavorStep();
          }
        });
      });

      this.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-slot-remove]');
        if (removeBtn) {
          e.preventDefault();
          e.stopPropagation();
          if (removeBtn.closest('[data-gratis-extra-slot-wrap]')) {
            this.gratisExtraSelection = null;
            this._renderGratisExtraSlot();
            this._updateUi();
            return;
          }
          if (removeBtn.closest('[data-promo-gifts-slot-wrap]')) {
            const promoIndex = parseInt(removeBtn.getAttribute('data-slot-index'), 10);
            if (!Number.isNaN(promoIndex)) {
              this.promoGiftSelections.splice(promoIndex, 1);
              this._renderPromoGiftSlots();
              this._updateKitRowPricing();
              this._updateUi();
            }
            return;
          }
          const index = parseInt(removeBtn.getAttribute('data-slot-index'), 10);
          if (!Number.isNaN(index)) {
            this._removeSelectionAtIndex(index);
          }
          return;
        }
        const giftRemoveBtn = e.target.closest('[data-gift-slot-remove]');
        if (giftRemoveBtn) {
          e.preventDefault();
          e.stopPropagation();
          const slot = parseInt(giftRemoveBtn.getAttribute('data-gift-slot'), 10);
          if (!Number.isNaN(slot)) {
            this._removeGiftSelection(slot);
          }
          return;
        }
        if (e.target.closest('[data-gratis-extra-slot-wrap] [data-bundle-open-drawer]')) {
          this._openGratisExtraDrawer();
          return;
        }
        if (e.target.closest('[data-promo-gifts-slot-wrap] [data-bundle-open-drawer]')) {
          this._openPromoGiftsDrawer();
          return;
        }
        if (e.target.closest('[data-bundle-open-drawer]')) {
          this._openDrawer();
          return;
        }
        const giftOpen = e.target.closest('[data-bundle-gift-open]');
        if (giftOpen) {
          e.preventDefault();
          e.stopPropagation();
          if (e.target.closest('.bk-media-bundle-builder__gift-qty')) return;
          const slot = parseInt(giftOpen.getAttribute('data-gift-slot'), 10);
          if (slot) this._openGiftModalForSlot(slot);
          return;
        }
        const colorsOpen = e.target.closest('[data-bundle-open-colors-drawer]');
        if (colorsOpen) {
          const slot = parseInt(colorsOpen.getAttribute('data-gift-slot'), 10);
          if (slot) this._openColorsDrawer(slot);
          return;
        }

        const progressTrigger = e.target.closest(
          '[data-flexible-progress-banner]:not([hidden]), [data-drawer-upgrade-progress]:not([hidden])'
        );
        if (progressTrigger?.classList.contains('is-clickable')) {
          e.preventDefault();
          const fromDrawer = Boolean(progressTrigger.matches('[data-drawer-upgrade-progress]'));
          this._handleFlexibleProgressAction(this._getFlexibleProgress(), { fromDrawer });
          return;
        }

        const featureScroll = e.target.closest('[data-bundle-feature-scroll]');
        if (featureScroll) {
          const selector = featureScroll.getAttribute('data-bundle-feature-scroll');
          if (!selector) return;
          const target = document.querySelector(selector);
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const progressTrigger = e.target.closest(
          '[data-flexible-progress-banner].is-clickable, [data-drawer-upgrade-progress].is-clickable'
        );
        if (progressTrigger) {
          e.preventDefault();
          const fromDrawer = Boolean(progressTrigger.matches('[data-drawer-upgrade-progress]'));
          this._handleFlexibleProgressAction(this._getFlexibleProgress(), { fromDrawer });
          return;
        }
        const kitGiftTrigger = e.target.closest('[data-bundle-kit-gift-trigger][role="button"]');
        if (kitGiftTrigger) {
          const kitRow = kitGiftTrigger.closest('[data-bundle-kit-row]');
          if (kitRow?.classList.contains('is-selected')) {
            e.preventDefault();
            const slot = parseInt(kitGiftTrigger.getAttribute('data-gift-slot'), 10);
            if (slot) this._openColorsDrawer(slot);
          }
          return;
        }
        const colorsOpen = e.target.closest('[data-bundle-open-colors-drawer][role="button"]');
        if (colorsOpen && colorsOpen.tagName !== 'BUTTON') {
          e.preventDefault();
          const slot = parseInt(colorsOpen.getAttribute('data-gift-slot'), 10);
          if (slot) this._openColorsDrawer(slot);
          return;
        }
        const giftOpen = e.target.closest('[data-bundle-gift-open][role="button"]');
        if (!giftOpen || giftOpen.tagName === 'BUTTON') return;
        e.preventDefault();
        const slot = parseInt(giftOpen.getAttribute('data-gift-slot'), 10);
        if (slot) this._openGiftModalForSlot(slot);
      });

      this.drawerConfirm?.addEventListener('click', () => this._confirmDrawer());

      this.drawer?.addEventListener('dialog:after-hide', () => {
        if (this._suppressDrawerPersist) {
          this._suppressDrawerPersist = false;
          this.drawerQuantities = {};
          this.drawerMode = 'default';
          this._setDrawerTitle(this.drawerDefaultTitle);
          this._setDrawerFooterPricesVisible(true);
          if (this.drawerList) this.drawerList.innerHTML = '';
          this._updateKitRowPricing();
          this._updateDrawerPricing();
          return;
        }
        this._persistDrawerSelections();
        this.drawerQuantities = {};
        this.drawerMode = 'default';
        this._setDrawerTitle(this.drawerDefaultTitle);
        this._setDrawerFooterPricesVisible(true);
        if (this.drawerList) this.drawerList.innerHTML = '';
        this._updateKitRowPricing();
        this._updateDrawerPricing();
      });

      this.atcButton?.addEventListener('click', () => this._addToCart());

      const form = this.form;
      if (form) {
        form.addEventListener('variant:change', (e) => this._onVariantChange(e));
      }
    }

    _getColorsPanelGiftItems() {
      return this._getGiftItems().filter(
        (item) => !this._isGiftProfiKitOnly(item)
      );
    }

    _formatGiftCompareLabel(cents) {
      if (!cents) return '';
      return `${formatMoneyAmount(cents)}\u00a0€`;
    }

    _setGiftPaidPriceElement(element, cents) {
      if (!element) return;
      if (cents > 0) {
        element.textContent = formatPriceDelta(cents);
        element.hidden = false;
      } else {
        element.textContent = '';
        element.hidden = true;
      }
    }

    _getGiftDrawerVariants(item) {
      const variants = item?.variants || [];
      const soldOutLead = (item?.soldOutDrawerVariants || []).map((variant) => ({
        ...variant,
        available: false
      }));
      return [...variants, ...soldOutLead].sort((a, b) => {
        const aAvailable = Boolean(a.available);
        const bAvailable = Boolean(b.available);
        if (aAvailable !== bAvailable) return aAvailable ? -1 : 1;
        const aDecline = this._isGiftDeclineVariant(a);
        const bDecline = this._isGiftDeclineVariant(b);
        if (aDecline !== bDecline) return aDecline ? 1 : -1;
        return 0;
      });
    }

    _isGiftDeclineVariant(variant) {
      return /nein|keine/i.test(String(variant?.title || ''));
    }

    _giftNeedsVariantPicker(item) {
      return this._getGiftDrawerVariants(item).length > 1;
    }

    _usesGiftOptInDrawer(item) {
      return Boolean(this.gift1OptInMode && item?.slot === 1);
    }

    _isGift1OptInDeclined() {
      if (!this.gift1OptInMode) return false;
      const gift1 = this._getGiftItem(1);
      if (!gift1 || !this._giftAppliesToCurrentPreset(gift1)) return false;
      return !this.giftSelections[1];
    }

    _shouldHideGift1DrawerImages(item) {
      return Boolean(this._usesGiftOptInDrawer(item));
    }

    _getOptInAcceptedVariant(item) {
      return this._getDefaultGiftVariant(item);
    }

    _getDefaultGiftVariant(item) {
      if (!item?.variants?.length) return null;
      return item.variants.find((variant) => variant.available) || item.variants[0] || null;
    }

    _giftOpensDrawer(item) {
      return this._usesGiftOptInDrawer(item) || this._giftNeedsVariantPicker(item);
    }

    _giftSlotPlaceholder(item) {
      return item?.placeholder || this.giftSelectionPlaceholder || this.colorsPlaceholder;
    }

    _syncColorsDrawerTitle(item) {
      const title = item?.drawerTitle || item?.title || '';
      if (!title) return;
      const header = this.colorsDrawer?.querySelector('[data-colors-drawer-header]');
      const confirmTitle = this.querySelector('[data-colors-picker-confirm-title]');
      if (header) header.textContent = title;
      if (confirmTitle) confirmTitle.textContent = title;
    }

    _giftHasAvailableVariant(item) {
      return Boolean(item?.variants?.some((variant) => variant.available));
    }

    _isGiftSoldOut(item) {
      return !this._giftHasAvailableVariant(item);
    }

    _getAutoGiftVariant(item) {
      if (!item?.variants?.length || this._giftNeedsVariantPicker(item)) return null;
      return item.variants.find((variant) => variant.available) || null;
    }

    _getEffectiveGiftVariant(slot) {
      const item = this._getGiftItem(slot);
      if (!item) return null;
      if (this._usesGiftOptInDrawer(item)) {
        return this._getSelectedGiftVariant(slot);
      }
      return this._getSelectedGiftVariant(slot) || this._getAutoGiftVariant(item);
    }

    _ensureSingleVariantGiftSelection(slot) {
      const item = this._getGiftItem(slot);
      if (this._usesGiftOptInDrawer(item)) return;
      const variant = this._getAutoGiftVariant(item);
      if (!variant || this.giftSelections[slot]) return;
      this.giftSelections[slot] = variant.id;
    }

    _isPaidGiftVariant(variant) {
      return (parseInt(variant?.price, 10) || 0) > 0;
    }

    _shouldAddPaidGiftExternally(variant) {
      return this._isPaidGiftVariant(variant) && !this.includePaidGiftsInBundle;
    }

    _getDisplayedPaidGiftCents(item, variant) {
      if (this.includePaidGiftsInBundle) return 0;
      return this._getGiftVariantPriceCents(item, variant);
    }

    _getGiftLineQuantity(item, presetIndex) {
      const configured = parseInt(item?.quantity, 10) || 1;
      if (configured <= 1) return 1;
      const kitNeedle = String(item.quantityKitValue || '').trim().toLowerCase();
      if (!kitNeedle) return configured;
      const index = parseInt(presetIndex, 10) || parseInt(this.activePreset?.presetIndex, 10) || 0;
      const preset = this.presets.find((entry) => entry.presetIndex === index);
      const kitValue = String(preset?.kitValue || '').trim().toLowerCase();
      if (!kitValue || !kitValue.includes(kitNeedle)) return 1;
      return configured;
    }

    _getGiftSavingsCentsFromItem(item, variant) {
      if (!item) return 0;
      const resolvedVariant =
        variant || this._getSelectedGiftVariant(item.slot) || item.variants?.[0];
      if (this._isPaidGiftVariant(resolvedVariant) && !this.includePaidGiftsInBundle) return 0;
      const custom = parseInt(item.customCompareCents, 10);
      if (custom > 0) return custom;
      if (!resolvedVariant) return 0;
      const price = parseInt(resolvedVariant.price, 10) || 0;
      if (price > 0) return price;
      const compare = parseInt(resolvedVariant.compare_at_price, 10) || 0;
      if (compare > 0) return compare;
      return 0;
    }

    _getGiftDisplayCompareCentsFromItem(item, variant) {
      if (this.hideGiftComparePrices) return 0;
      return this._getGiftSavingsCentsFromItem(item, variant);
    }

    _shouldIncludeGiftCompareInTotals(item) {
      return Boolean(item) && !this._isGiftSoldOut(item);
    }

    _renderGiftSlotHtml(item) {
      const usesOptIn = this._usesGiftOptInDrawer(item);
      const isSingleVariant = !this._giftNeedsVariantPicker(item);
      const soldOut = this._isGiftSoldOut(item);
      const singleVariant = isSingleVariant ? this._getAutoGiftVariant(item) : null;
      const previewVariant = singleVariant || item.variants?.[0] || null;
      const imageUrl =
        this._getGiftVariantImage(previewVariant, item) || item.fallbackImage || '';
      const lineQty = this._getGiftLineQuantity(item, this.activePreset?.presetIndex);
      const compareCents = soldOut ? 0 : this._getGiftDisplayCompareCentsFromItem(item) * lineQty;
      const slotTitle = lineQty > 1 ? `${lineQty}× ${item.title || ''}` : item.title || '';
      const compareHtml = `<span class="bk-media-bundle-builder__slot-compare bk-media-bundle-builder__kit-gift-compare text-subdued text-sm line-through" data-gift-slot="${item.slot}"${compareCents ? '' : ' hidden'}>${compareCents ? this._formatGiftCompareLabel(compareCents) : ''}</span>`;
      const selectedPaidCents = soldOut
        ? 0
        : this._getDisplayedPaidGiftCents(item, this._getSelectedGiftVariant(item.slot));
      const priceHtml = `<span class="bk-media-bundle-builder__slot-price text-sm" data-gift-slot-price data-gift-slot="${item.slot}"${selectedPaidCents ? '' : ' hidden'}>${selectedPaidCents ? formatPriceDelta(selectedPaidCents) : ''}</span>`;
      const slotLabel = soldOut
        ? 'Ausverkauft'
        : usesOptIn
          ? this.gift1DeclineLabel
          : this.giftOptional
            ? this.giftDeclineLabel
            : this._giftOpensDrawer(item)
              ? this._giftSlotPlaceholder(item)
              : this.colorsPlaceholder;
      const labelHtml =
        soldOut || !(isSingleVariant && !usesOptIn)
          ? `<span class="text-subdued text-sm" data-colors-slot-label>${slotLabel}</span>`
          : '';
      const openDrawerAttr =
        !soldOut && this._giftOpensDrawer(item) ? ' data-bundle-open-colors-drawer' : '';
      const openInfoAttr =
        !soldOut &&
        !this._giftOpensDrawer(item) &&
        this.bonusGiftPopup &&
        this._giftHasDescription(item)
          ? ' data-bundle-gift-open aria-haspopup="dialog"'
          : '';
      const hasAcceptSelection = Boolean(this.giftSelections[item.slot]);
      const filledClass =
        !soldOut &&
        ((isSingleVariant && !usesOptIn && singleVariant?.available) ||
          (usesOptIn && hasAcceptSelection))
          ? ' is-filled'
          : '';
      const soldOutClass = soldOut ? ' is-sold-out' : '';
      const checkHidden =
        !soldOut &&
        ((isSingleVariant && !usesOptIn && singleVariant?.available) ||
          (usesOptIn && hasAcceptSelection))
          ? 'false'
          : 'true';
      const removeHidden = ' hidden';
      const imageHtml = imageUrl
        ? `<img src="${imageUrl}" alt="" loading="lazy" width="60" height="60">`
        : `<svg class="placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525 525"><rect fill="#efefef" width="525" height="525"/></svg>`;

      return `
        <div class="bk-media-bundle-builder__slot-wrap" data-bundle-slot-wrap>
          <button
            type="button"
            class="bk-media-bundle-builder__slot${filledClass}${soldOutClass}"
            data-colors-slot
            data-gift-slot="${item.slot}"${openDrawerAttr}${openInfoAttr}
            ${soldOut ? 'disabled aria-disabled="true"' : ''}
          >
            <span class="bk-media-bundle-builder__slot-image" data-colors-slot-image>${imageHtml}</span>
            <span class="bk-media-bundle-builder__slot-box v-stack gap-0.5">
              <span class="bk-media-bundle-builder__slot-title-row">
                <span class="text-sm bold">${slotTitle}</span>
              </span>
              ${labelHtml}
            </span>
            ${priceHtml}
            ${compareHtml}
            <span class="bk-media-bundle-builder__slot-check" data-slot-check aria-hidden="${checkHidden}">
              <svg role="presentation" focusable="false" stroke-width="2" width="20" height="20" class="icon icon-success" style="--icon-height: 20px" viewBox="0 0 18 18">
                <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
                <path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path>
              </svg>
              <span class="sr-only">Ausgewählt</span>
            </span>
          </button>
          <button
            type="button"
            class="bk-media-bundle-builder__slot-remove"
            data-gift-slot-remove
            data-gift-slot="${item.slot}"${removeHidden}
            aria-label="Entfernen"
          >
            <svg role="presentation" stroke-width="2" focusable="false" width="12" height="12" viewBox="0 0 10 10">
              <path d="m.757.757 8.486 8.486m-8.486 0L9.243.757" stroke="currentColor"></path>
            </svg>
          </button>
        </div>
      `;
    }

    _renderColorsPanelSlotsFromGiftData() {
      if (!this.showGifts) return;

      const items = this._getApplicableGiftItems();
      const selectionContainer = this.querySelector('[data-colors-slots-selection]');
      const bonusContainer = this.querySelector('[data-colors-slots-bonus]');
      const legacyContainer = this.querySelector('[data-colors-slots]');

      if (selectionContainer || bonusContainer) {
        const selectionItems = items.filter((item) => this._giftOpensDrawer(item));
        const bonusItems = items.filter((item) => !this._giftOpensDrawer(item));
        const extraSelectionContainer = this.querySelector('[data-colors-slots-selection-2]');
        const primarySelectionItems = extraSelectionContainer
          ? selectionItems.filter((item) => item.slot === 1)
          : selectionItems;
        const extraSelectionItems = extraSelectionContainer
          ? selectionItems.filter((item) => item.slot !== 1)
          : [];

        if (selectionContainer) {
          selectionContainer.innerHTML = primarySelectionItems.length
            ? primarySelectionItems.map((item) => this._renderGiftSlotHtml(item)).join('')
            : '';
        }

        if (extraSelectionContainer) {
          extraSelectionContainer.innerHTML = extraSelectionItems.length
            ? extraSelectionItems.map((item) => this._renderGiftSlotHtml(item)).join('')
            : '';
        }

        if (bonusContainer) {
          bonusContainer.innerHTML = bonusItems.length
            ? bonusItems.map((item) => this._renderGiftSlotHtml(item)).join('')
            : '';
        }

        return;
      }

      if (!legacyContainer) return;

      if (!items.length) {
        legacyContainer.innerHTML = '';
        return;
      }

      legacyContainer.innerHTML = items
        .map((item) => this._renderGiftSlotHtml(item))
        .join('');
    }

    _initColorsDrawer() {
      const drawerId = this.getAttribute('data-colors-drawer-id');
      if (!drawerId) return;

      this.colorsDrawer = document.getElementById(drawerId);
      this.colorsDrawerList = this.querySelector('[data-colors-drawer-list]');
      this.colorsPickerStatus = this.querySelector('[data-colors-picker-status]');
      this.colorsPickerConfirm = this.querySelector('[data-colors-picker-confirm]');
      this.colorsPickerConfirmCount = this.querySelector('[data-colors-picker-confirm-count]');
      this.colorsDrawerCelebration = this.querySelector('[data-colors-drawer-celebration]');
      this.colorsDrawerGoalToast = this.querySelector('[data-colors-drawer-goal-toast]');
      if (!this.colorsDrawer || !this.colorsDrawerList) return;

      Object.defineProperty(this.colorsDrawer, 'openFrom', {
        get: () => 'right',
        configurable: true
      });

      this.colorsPickerConfirm?.addEventListener('click', () => this._confirmColorsDrawer());
      this.colorsDrawer.addEventListener('dialog:after-hide', () => {
        if (!this._activeColorsSlot) return;
        this._persistColorsDrawerSelection(this._activeColorsSlot);
        this._activeColorsSlot = null;
        this._activePickerContext = null;
      });
    }

    _initGiftDrawer() {
      const blockId = this.getAttribute('data-block-id');
      if (!blockId) return;
      this.giftDrawer = document.getElementById(`bundle-gift-drawer-${blockId}`);
      this.giftDrawerContent = this.querySelector('[data-gift-drawer-content]');
      this.giftDrawerHeader = this.querySelector('[data-gift-drawer-header]');
      this.giftDrawerFooter = this.querySelector('[data-gift-drawer-footer]');
      this.giftPickerStatus = this.querySelector('[data-gift-picker-status]');
      this.giftPickerConfirm = this.querySelector('[data-gift-picker-confirm]');
      if (!this.giftDrawer || !this.giftDrawerContent) return;

      Object.defineProperty(this.giftDrawer, 'openFrom', {
        get: () => this._getDrawerOpenFrom('right'),
        configurable: true
      });

      this.giftPickerConfirm?.addEventListener('click', () => {
        if (this._activeGiftPickerSlot) this._confirmGiftPicker(this._activeGiftPickerSlot);
      });
    }

    _initGiftInfoModal() {
      this.giftInfoModal = this.querySelector('[data-gift-info-modal]');
      this.giftInfoModalContent = this.giftInfoModal?.querySelector('[data-gift-info-modal-content]');
      if (!this.giftInfoModal) return;

      document.body.appendChild(this.giftInfoModal);

      this._giftInfoModalKeyHandler = (event) => {
        if (event.key === 'Escape') this._closeGiftInfoModal();
      };

      this.giftInfoModal.addEventListener('click', (event) => {
        if (event.target.closest('[data-gift-info-modal-close]')) {
          event.preventDefault();
          this._closeGiftInfoModal();
        }
      });
    }

    disconnectedCallback() {
      this._closeGiftInfoModal();
      this.giftInfoModal?.remove();
    }

    _openGiftInfoModal() {
      if (!this.giftInfoModal) return;
      this.giftInfoModal.classList.add('is-open');
      document.removeEventListener('keydown', this._giftInfoModalKeyHandler);
      document.addEventListener('keydown', this._giftInfoModalKeyHandler);
      this.giftInfoModal.querySelector('[data-gift-info-modal-close]')?.focus();
    }

    _closeGiftInfoModal() {
      if (!this.giftInfoModal) return;
      this.giftInfoModal.classList.remove('is-open');
      document.removeEventListener('keydown', this._giftInfoModalKeyHandler);
    }

    _initGiftModalDescription(root) {
      const scope = root || this.giftDrawerContent;
      const desc = scope?.querySelector('[data-gift-description]');
      const toggle = scope?.querySelector('[data-gift-read-toggle]');
      if (!desc || !toggle) return;

      desc.classList.add('is-collapsed');
      desc.classList.remove('is-expanded');
      toggle.hidden = true;
      toggle.textContent = 'Mehr lesen';
      toggle.onclick = () => this._toggleGiftDescription(desc, toggle);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (this._giftDescriptionOverflows(desc)) {
            toggle.hidden = false;
          } else {
            desc.classList.remove('is-collapsed');
          }
        });
      });
    }

    _createColorsVariantRow(item, variant, checked) {
      const row = document.createElement('label');
      const hideImages = this._shouldHideGift1DrawerImages(item);
      row.className =
        'bk-media-bundle-builder__drawer-item bk-media-bundle-builder__colors-variant-row';
      if (hideImages) {
        row.classList.add('bk-media-bundle-builder__colors-variant-row--no-image');
      }
      row.setAttribute('data-colors-variant-row', '');
      row.setAttribute('data-gift-slot', String(item.slot));
      row.setAttribute('data-variant-id', String(variant.id));
      if (!variant.available) row.classList.add('is-unavailable');
      if (checked) row.classList.add('is-selected');
      const isDecline = this._isGiftDeclineVariant(variant);

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `gift-colors-${item.slot}`;
      input.value = String(variant.id);
      input.checked = checked;
      input.disabled = !variant.available;
      input.addEventListener('change', () => {
        this._syncColorsDrawerState();
        if (this._activeColorsSlot) {
          const activeItem = this._getGiftItem(this._activeColorsSlot);
          if (!this._usesGiftOptInDrawer(activeItem)) {
            this._persistColorsDrawerSelection(this._activeColorsSlot);
          }
        }
      });
      row.addEventListener('click', () => {
        requestAnimationFrame(() => {
          this._syncColorsDrawerState();
          if (this._activeColorsSlot) {
            const activeItem = this._getGiftItem(this._activeColorsSlot);
            if (!this._usesGiftOptInDrawer(activeItem)) {
              this._persistColorsDrawerSelection(this._activeColorsSlot);
            }
          }
        });
      });

      const imageWrap = document.createElement('div');
      imageWrap.className = 'bk-media-bundle-builder__drawer-item-image';
      const showDeclineWithoutImage = isDecline && !variant.image;
      if (showDeclineWithoutImage) {
        row.classList.add('bk-media-bundle-builder__colors-variant-row--no-image');
      }
      if (!hideImages && !showDeclineWithoutImage) {
        const imageUrl = this._getGiftVariantImage(variant, item) || item.fallbackImage;
        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 56;
          img.height = 56;
          imageWrap.appendChild(img);
        }
      }

      const info = document.createElement('div');
      info.className = 'bk-media-bundle-builder__drawer-item-info v-stack gap-1';

      const title = document.createElement('span');
      title.className = 'text-base bk-media-bundle-builder__drawer-item-title';
      title.textContent = variant.title;
      info.appendChild(title);

      if (!variant.available) {
        const soldOut = document.createElement('span');
        soldOut.className = 'text-xs bk-media-bundle-builder__colors-variant-sold-out';
        soldOut.textContent = 'Ausverkauft';
        info.appendChild(soldOut);
      }

      const paidCents = this.includePaidGiftsInBundle ? 0 : parseInt(variant.price, 10) || 0;
      if (paidCents > 0) {
        const priceDelta = document.createElement('span');
        priceDelta.className = 'bk-media-bundle-builder__drawer-price-delta text-sm';
        priceDelta.textContent = formatPriceDelta(paidCents);
        info.appendChild(priceDelta);
      }

      row.appendChild(input);
      if (!hideImages && !showDeclineWithoutImage) {
        row.appendChild(imageWrap);
      }
      row.appendChild(info);
      return row;
    }

    _applyOptInDrawerChoice() {
      this._syncColorsDrawerState();
      if (!this._activeColorsSlot) return;

      const slot = this._activeColorsSlot;
      const item = this._getGiftItem(slot);
      if (!item || !this._usesGiftOptInDrawer(item)) return;

      this._persistColorsDrawerSelection(slot);
      this._activeColorsSlot = null;
      this._activePickerContext = null;
      this._closeColorsDrawer();
    }

    _handleOptInChoiceChange() {
      this._applyOptInDrawerChoice();
    }

    _createOptInChoiceRow(item, choice, label, checked) {
      const row = document.createElement('label');
      row.className =
        'bk-media-bundle-builder__drawer-item bk-media-bundle-builder__colors-variant-row bk-media-bundle-builder__colors-variant-row--no-image';
      row.setAttribute('data-colors-opt-in-row', '');
      row.setAttribute('data-gift-slot', String(item.slot));
      row.setAttribute('data-opt-in-choice', choice);
      if (checked) row.classList.add('is-selected');

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `gift-opt-in-${item.slot}`;
      input.value = choice;
      input.checked = checked;
      input.addEventListener('change', () => {
        if (input.checked) {
          this._handleOptInChoiceChange();
        }
      });

      const info = document.createElement('div');
      info.className = 'bk-media-bundle-builder__drawer-item-info v-stack gap-1';

      const title = document.createElement('span');
      title.className = 'text-base bk-media-bundle-builder__drawer-item-title';
      title.textContent = label;
      info.appendChild(title);

      row.appendChild(input);
      row.appendChild(info);
      return row;
    }

    _renderOptInDrawerContent(item) {
      const hasAccept = Boolean(this.giftSelections[item.slot]);
      this.colorsDrawerList.appendChild(
        this._createOptInChoiceRow(item, 'decline', this.gift1DeclineLabel, !hasAccept)
      );
      this.colorsDrawerList.appendChild(
        this._createOptInChoiceRow(item, 'accept', this.gift1AcceptLabel, hasAccept)
      );
    }

    _renderColorsDrawerContent(item) {
      const selectedId = this.giftSelections[item.slot];
      this._getGiftDrawerVariants(item).forEach((variant) => {
        const checked =
          Boolean(variant.available) && selectedId
            ? String(selectedId) === String(variant.id)
            : false;
        this.colorsDrawerList.appendChild(this._createColorsVariantRow(item, variant, checked));
      });
    }

    _getColorsDrawerSelectedVariant(item) {
      if (this._usesGiftOptInDrawer(item)) {
        const checked = this.colorsDrawerList?.querySelector(
          `input[name="gift-opt-in-${item.slot}"]:checked`
        );
        if (checked?.value !== 'accept') return null;
        return this._getOptInAcceptedVariant(item);
      }

      const checked = this.colorsDrawerList?.querySelector(
        `input[name="gift-colors-${item.slot}"]:checked`
      );
      if (!checked) return null;
      return (
        this._getGiftDrawerVariants(item).find((variant) => String(variant.id) === checked.value) ||
        null
      );
    }

    _persistColorsDrawerSelection(slot) {
      const item = this._getGiftItem(slot);
      if (!item) return false;

      if (this._usesGiftOptInDrawer(item)) {
        const checked = this.colorsDrawerList?.querySelector(
          `input[name="gift-opt-in-${item.slot}"]:checked`
        );
        const wantGift = checked?.value === 'accept';
        const variant = wantGift ? this._getColorsDrawerSelectedVariant(item) : null;
        const previousId = this.giftSelections[slot];

        if (wantGift && variant?.available) {
          const changed = previousId !== variant.id;
          this.giftSelections[slot] = variant.id;
          this._updateGiftCardUi(slot, variant, item);
          this._updateColorsSlotUi();
          this._updateUi();
          this._updateKitRowPricing();
          this._updateDrawerPricing();
          return changed;
        }

        const changed = Boolean(previousId);
        delete this.giftSelections[slot];
        this._updateGiftCardUi(slot, null, item);
        this._updateColorsSlotUi();
        this._updateUi();
        this._updateKitRowPricing();
        this._updateDrawerPricing();
        return changed;
      }

      const variant = this._getColorsDrawerSelectedVariant(item);
      if (!variant?.available) return false;

      const changed = this.giftSelections[slot] !== variant.id;
      this.giftSelections[slot] = variant.id;
      this._updateGiftCardUi(slot, variant, item);
      this._updateColorsSlotUi();
      this._updateUi();
      this._updateKitRowPricing();
      this._updateDrawerPricing();
      return changed;
    }

    _getColorsCelebrationContext() {
      return {
        goalToast: this.colorsDrawerGoalToast,
        celebration: this.colorsDrawerCelebration,
        confirm: this.colorsPickerConfirm,
        drawer: this.colorsDrawer,
        timeoutKey: '_colorsCelebrationTimeout',
        goalToastTimeoutKey: '_colorsGoalToastTimeout'
      };
    }

    _getRecipeCelebrationContext() {
      return {
        goalToast: this.drawerGoalToast,
        celebration: this.drawerCelebration,
        confirm: this.drawerConfirm,
        drawer: this.drawer,
        timeoutKey: '_celebrationTimeout',
        goalToastTimeoutKey: '_drawerGoalToastTimeout'
      };
    }

    _getAtcCelebrationContext() {
      return {
        goalToast: this.atcGoalToast,
        celebration: this.atcCelebration,
        confirm: this.atcButton,
        drawer: this,
        timeoutKey: '_atcCelebrationTimeout',
        goalToastTimeoutKey: '_atcGoalToastTimeout',
        message: this.atcSuccessMessage
      };
    }

    _openColorsDrawer(slot) {
      if (!this.colorsDrawer || !this.colorsDrawerList) return;

      const item = this._getGiftItem(slot);
      if (!item || this._isGiftSoldOut(item) || !this._giftOpensDrawer(item)) return;

      this._activePickerContext = 'colors';
      this._activeColorsSlot = slot;
      this._syncColorsDrawerTitle(item);
      this.colorsDrawerList.innerHTML = '';

      if (this._usesGiftOptInDrawer(item)) {
        this._renderOptInDrawerContent(item);
      } else {
        this._renderColorsDrawerContent(item);
      }

      const savedVariant = this._getSelectedGiftVariant(slot);
      this._colorsDrawerLastCount =
        this._usesGiftOptInDrawer(item) && savedVariant?.available
          ? 1
          : savedVariant?.available
            ? 1
            : 0;
      this._clearCelebration(this._getColorsCelebrationContext());

      this._syncColorsDrawerState();
      this.colorsDrawer.show?.();
    }

    _closeColorsDrawer() {
      if (!this.colorsDrawer) return;
      this.colorsDrawer.hide?.();
      this._clearCelebration(this._getColorsCelebrationContext());
      if (this.colorsPickerStatus) this.colorsPickerStatus.textContent = '';
      if (this.colorsPickerConfirm) this.colorsPickerConfirm.disabled = true;
    }

    _syncColorsDrawerState() {
      const slot = this._activeColorsSlot;
      const item = slot ? this._getGiftItem(slot) : null;
      if (!this.colorsDrawerList || !item) return;

      const usesOptIn = this._usesGiftOptInDrawer(item);
      const variant = this._getColorsDrawerSelectedVariant(item);
      const checked = this.colorsDrawerList?.querySelector(
        `input[name="gift-opt-in-${item.slot}"]:checked`
      );
      const declined = checked?.value === 'decline';
      const accepted = checked?.value === 'accept';
      const acceptedVariant = accepted ? this._getOptInAcceptedVariant(item) : null;
      const selected = usesOptIn
        ? declined
          ? 1
          : accepted && acceptedVariant?.available
            ? 1
            : 0
        : variant?.available
          ? 1
          : 0;
      const previousSelected = this._colorsDrawerLastCount ?? 0;
      let statusMessage = '';

      if (variant && !variant.available) {
        statusMessage = 'Diese Variante ist ausverkauft.';
      } else if (usesOptIn && accepted && !acceptedVariant?.available) {
        statusMessage = 'Dieses Geschenk ist derzeit ausverkauft.';
      }

      if (selected === 1 && previousSelected < 1) {
        this._triggerCelebration(this._getColorsCelebrationContext());
      } else if (selected < 1) {
        this._clearCelebration(this._getColorsCelebrationContext());
      }

      this._colorsDrawerLastCount = selected;

      if (this.colorsPickerConfirmCount) {
        this.colorsPickerConfirmCount.textContent = usesOptIn
          ? `${checked ? 1 : 0}/1 ausgewählt`
          : `${selected}/1 ausgewählt`;
      }
      if (this.colorsPickerStatus) {
        this.colorsPickerStatus.textContent = statusMessage;
      }
      if (this.colorsPickerConfirm) {
        if (usesOptIn) {
          this.colorsPickerConfirm.disabled = !(declined || (accepted && acceptedVariant?.available));
        } else {
          this.colorsPickerConfirm.disabled = selected !== 1;
        }
      }

      this.colorsDrawerList
        .querySelectorAll('[data-colors-variant-row], [data-colors-opt-in-row]')
        .forEach((row) => {
          const input = row.querySelector('input[type="radio"]');
          row.classList.toggle('is-selected', Boolean(input?.checked));
        });
    }

    _confirmColorsDrawer() {
      const slot = this._activeColorsSlot;
      if (!slot) return;

      const item = this._getGiftItem(slot);
      if (!item) return;

      if (this._usesGiftOptInDrawer(item)) {
        this._persistColorsDrawerSelection(slot);
        this._activeColorsSlot = null;
        this._activePickerContext = null;
        this._closeColorsDrawer();
        return;
      }

      const variant = this._getColorsDrawerSelectedVariant(item);
      if (!variant?.available) return;

      this._persistColorsDrawerSelection(slot);
      this._activeColorsSlot = null;
      this._activePickerContext = null;
      this._closeColorsDrawer();
    }

    _updateColorsSlotUi() {
      const slots = this.querySelectorAll('[data-colors-slot]');
      if (!slots.length) return;

      slots.forEach((button) => {
        const slot = parseInt(button.getAttribute('data-gift-slot'), 10);
        const item = this._getGiftItem(slot);
        const label = button.querySelector('[data-colors-slot-label]');
        const imageWrap = button.querySelector('[data-colors-slot-image]');
        const usesOptIn = this._usesGiftOptInDrawer(item);
        const needsPicker = this._giftNeedsVariantPicker(item);

        const soldOut = this._isGiftSoldOut(item);

        if (!soldOut && !needsPicker && !usesOptIn) {
          this._ensureSingleVariantGiftSelection(slot);
        }

        const variant = this._getEffectiveGiftVariant(slot);
        const hasSelection = soldOut
          ? false
          : usesOptIn
            ? Boolean(this._getSelectedGiftVariant(slot))
            : needsPicker
              ? Boolean(this._getSelectedGiftVariant(slot))
              : Boolean(variant?.available);

        button.classList.toggle('is-sold-out', soldOut);
        button.disabled = soldOut;
        button.toggleAttribute('aria-disabled', soldOut);

        if (label) {
          if (soldOut) {
            label.hidden = false;
            label.textContent = 'Ausverkauft';
            label.classList.add('text-subdued');
          } else if (!needsPicker && !usesOptIn) {
            label.hidden = true;
            label.textContent = '';
          } else if (hasSelection) {
            label.hidden = false;
            label.textContent = usesOptIn
              ? this.gift1AcceptLabel
              : variant.title ||
                (this._giftOpensDrawer(item)
                  ? this._giftSlotPlaceholder(item)
                  : this.colorsPlaceholder);
            label.classList.remove('text-subdued');
          } else if (usesOptIn || this.giftOptional) {
            label.hidden = false;
            label.textContent = usesOptIn ? this.gift1DeclineLabel : this.giftDeclineLabel;
            label.classList.add('text-subdued');
          } else {
            label.hidden = false;
            label.textContent = this._giftOpensDrawer(item)
              ? this._giftSlotPlaceholder(item)
              : this.colorsPlaceholder;
            label.classList.add('text-subdued');
          }
        }

        if (imageWrap && item) {
          const previewImage = variant
            ? this._getGiftVariantImage(variant, item)
            : this._getGiftVariantImage(item.variants?.[0], item) || item.fallbackImage || null;
          if (previewImage) {
            imageWrap.innerHTML = `<img src="${previewImage}" alt="" loading="lazy" width="60" height="60">`;
          }
        }

        const compareEl = button.querySelector(
          `.bk-media-bundle-builder__kit-gift-compare[data-gift-slot="${slot}"]`
        );
        if (compareEl && item) {
          const compareVariant = variant || item.variants?.[0];
          const compareCents = soldOut
            ? 0
            : this._getGiftDisplayCompareCentsFromItem(item, compareVariant);
          if (compareCents > 0) {
            compareEl.textContent = this._formatGiftCompareLabel(compareCents);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        this._setGiftPaidPriceElement(
          button.querySelector(`[data-gift-slot-price][data-gift-slot="${slot}"]`),
          soldOut || !hasSelection ? 0 : this._getDisplayedPaidGiftCents(item, variant)
        );

        button.classList.toggle('is-filled', hasSelection);

        const check = button.querySelector('[data-slot-check]');
        if (check) {
          check.setAttribute('aria-hidden', hasSelection ? 'false' : 'true');
        }

        const removeBtn = button
          .closest('[data-bundle-slot-wrap]')
          ?.querySelector('[data-gift-slot-remove]');
        if (removeBtn) {
          removeBtn.hidden = !needsPicker || !hasSelection || usesOptIn;
        }
      });

      this._updateKitGiftSlotUi();
    }

    _updateKitGiftSlotUi() {
      this.querySelectorAll('[data-bundle-kit-gift-trigger]').forEach((slotEl) => {
        const slot = parseInt(slotEl.getAttribute('data-gift-slot'), 10);
        const item = this._getGiftItem(slot);
        const variant = this._getEffectiveGiftVariant(slot);
        const needsPicker = this._giftNeedsVariantPicker(item);
        const soldOut = this._isGiftSoldOut(item);
        const hasSelection = soldOut
          ? false
          : needsPicker
            ? Boolean(this._getSelectedGiftVariant(slot))
            : this._usesGiftOptInDrawer(item)
              ? Boolean(this._getSelectedGiftVariant(slot))
              : Boolean(variant?.available);

        slotEl.hidden = false;
        slotEl.classList.toggle('is-sold-out', soldOut);
        slotEl.classList.toggle('is-filled', hasSelection);
        slotEl.classList.toggle('is-interactive', !soldOut && this._giftNeedsVariantPicker(item));
        if (soldOut) {
          slotEl.removeAttribute('role');
          slotEl.removeAttribute('tabindex');
        }

        if (this.kitGiftsPreset > 0 && item) {
          const imageWrap = slotEl.querySelector('.bk-media-bundle-builder__kit-gift-image');
          const previewImage = variant
            ? this._getGiftVariantImage(variant, item)
            : item.fallbackImage;
          if (imageWrap && previewImage) {
            imageWrap.innerHTML = `<img src="${previewImage}" alt="" loading="lazy" width="56" height="56">`;
          }
          const titleEl = slotEl.querySelector('.bk-media-bundle-builder__kit-gift-title');
          if (titleEl) {
            const pickedTitle = hasSelection && needsPicker ? variant?.title : '';
            const fallback = slotEl.getAttribute('data-default-title') || item.title || '';
            titleEl.textContent =
              pickedTitle && pickedTitle !== 'Default Title' ? pickedTitle : fallback;
          }
        }

        const badge = slotEl.querySelector('.badge');
        if (badge) {
          const paidCents =
            !soldOut && hasSelection ? this._getDisplayedPaidGiftCents(item, variant) : 0;
          badge.textContent = soldOut
            ? 'Ausverkauft'
            : paidCents > 0
              ? formatPriceDelta(paidCents)
              : 'GRATIS';
          badge.classList.toggle('badge--primary', !soldOut && paidCents <= 0);
          badge.classList.toggle('badge--sold-out', soldOut);
        }

        const row = slotEl.closest('[data-bundle-kit-row]');
        const compareEl = row?.querySelector(
          `.bk-media-bundle-builder__kit-gift-compare[data-gift-slot="${slot}"]`
        );
        if (compareEl && item) {
          const compareVariant = variant || item.variants?.[0];
          const compareCents = soldOut
            ? 0
            : this._getGiftDisplayCompareCentsFromItem(item, compareVariant);
          if (compareCents > 0) {
            compareEl.textContent = this._formatGiftCompareLabel(compareCents);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      });
    }

    _getTopPresetQuantity() {
      const fromAttr = parseInt(this.getAttribute('data-gifts-top-preset-quantity'), 10);
      if (fromAttr) return fromAttr;
      const fromJson = parseInt(this.giftPricing?.topPresetQuantity, 10);
      if (fromJson) return fromJson;
      return Math.max(...this.presets.map((preset) => preset.quantity || 0), 0);
    }

    _presetHasNoGifts(presetIndex, row = null) {
      const resolvedRow = row || this._getSelectedKitRow();
      if (resolvedRow?.getAttribute('data-no-gifts') === 'true') return true;

      const index = parseInt(presetIndex, 10);
      if (!index) return false;
      if (this.preset1NoGifts && index === 1) return true;
      const preset = this.presets.find((item) => item.presetIndex === index);
      return Boolean(preset?.noGifts);
    }

    _kitRowShowsGifts(row) {
      if (row?.getAttribute('data-no-gifts') === 'true') return false;
      const presetIndex = parseInt(row?.getAttribute('data-preset-index'), 10);
      if (this._presetHasNoGifts(presetIndex, row)) return false;
      return row?.getAttribute('data-shows-gifts') === 'true';
    }

    _kitRowIsProfi(row) {
      const rowQty = parseInt(row?.getAttribute('data-preset-quantity'), 10);
      if (!rowQty) return false;
      return rowQty >= this._getTopPresetQuantity();
    }

    _shouldShowBaseGifts() {
      if (!this.showGifts) return false;
      const row = this._getSelectedKitRow();
      const presetIndex = parseInt(
        row?.getAttribute('data-preset-index') || this.activePreset?.presetIndex,
        10
      );
      if (this._presetHasNoGifts(presetIndex, row)) return false;
      if (this.kitGiftsPreset > 0) {
        return presetIndex === this.kitGiftsPreset;
      }
      if (this.giftMode === 'single_always') {
        return Boolean(this._getGiftItem(1));
      }

      if (row) {
        return this._kitRowShowsGifts(row);
      }

      if (this.flexibleSelection) {
        const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
        if (this._presetHasVolumeDiscount(presetIndex)) return false;
        const effectiveQty = this._getPricingQuantity();
        const minQty = parseInt(this.giftPricing?.minQuantity, 10) || 4;
        return effectiveQty >= minQty;
      }
      const minQty = parseInt(this.giftPricing?.minQuantity, 10) || 4;
      return this._getRequiredQty() >= minQty;
    }

    _shouldShowGift3() {
      if (!this.showGifts) return false;
      const row = this._getSelectedKitRow();
      const presetIndex = parseInt(
        row?.getAttribute('data-preset-index') || this.activePreset?.presetIndex,
        10
      );
      if (this._presetHasNoGifts(presetIndex, row)) return false;
      if (this.giftMode === 'single_always') return false;

      if (row) {
        return this._kitRowIsProfi(row);
      }

      if (this.flexibleSelection) {
        const presetIndex = parseInt(this.activePreset?.presetIndex, 10);
        if (this._presetHasVolumeDiscount(presetIndex)) return false;
        const effectiveQty = this._getPricingQuantity();
        return effectiveQty >= this._getTopPresetQuantity();
      }
      return this._getRequiredQty() >= this._getTopPresetQuantity();
    }

    _isGiftProfiKitOnly(item) {
      if (!item) return false;
      if (item.profiKitOnly) return true;
      if (item.slot === 2) {
        return this.getAttribute('data-gift-2-profi-kit-only') === 'true';
      }
      if (item.slot === 3) {
        return this.getAttribute('data-gift-3-profi-kit-only') === 'true';
      }
      return false;
    }

    _giftAppliesToCurrentPreset(item) {
      if (!item) return false;
      if (this._presetHasNoGifts()) return false;
      if (this.giftMode === 'single_always') {
        return item.slot === 1;
      }
      if (this._isGiftProfiKitOnly(item)) {
        return this._shouldShowGift3();
      }
      return this._shouldShowBaseGifts();
    }

    _getApplicableGiftItems() {
      if (!this.showGifts) return [];
      return this._getGiftItems().filter((item) => this._giftAppliesToCurrentPreset(item));
    }

    _clearInactiveGiftSelections() {
      this._getGiftItems().forEach((item) => {
        if (!this._giftAppliesToCurrentPreset(item) || this._isGiftSoldOut(item)) {
          delete this.giftSelections[item.slot];
        }
      });
    }

    _ensureApplicableGiftSelections() {
      this._getApplicableGiftItems().forEach((item) => {
        if (this._usesGiftOptInDrawer(item)) return;
        if (this.giftSelections[item.slot]) return;

        if (!this._giftNeedsVariantPicker(item)) {
          const variant = this._getAutoGiftVariant(item);
          if (!variant?.available) return;
          this.giftSelections[item.slot] = variant.id;
          this._updateGiftCardUi(item.slot, variant, item);
          return;
        }

        const availableVariants = (item.variants || []).filter((variant) => variant.available);
        if (availableVariants.length === 1) {
          const variant = availableVariants[0];
          this.giftSelections[item.slot] = variant.id;
          this._updateGiftCardUi(item.slot, variant, item);
        }
      });
    }

    _updateColorsVisibility() {
      const selectedRow = this._getSelectedKitRow();
      const presetIndex = parseInt(
        selectedRow?.getAttribute('data-preset-index') || this.activePreset?.presetIndex,
        10
      );
      const hasNoGifts = this._presetHasNoGifts(presetIndex, selectedRow);
      const applicableItems = this._getApplicableGiftItems();
      const selectionItems = applicableItems.filter((item) => this._giftOpensDrawer(item));
      const bonusItems = applicableItems.filter((item) => !this._giftOpensDrawer(item));
      const selectionPanel = this.querySelector('[data-bundle-gift-selection-panel]');
      const extraSelectionPanel = this.querySelector('[data-bundle-gift-2-selection-panel]');
      const bonusPanel = this.querySelector('[data-bundle-gifts-panel]');
      const extraSelectionItems = extraSelectionPanel
        ? selectionItems.filter((item) => item.slot !== 1)
        : [];
      const primarySelectionItems = extraSelectionPanel
        ? selectionItems.filter((item) => item.slot === 1)
        : selectionItems;

      if (selectionPanel && bonusPanel) {
        selectionPanel.hidden =
          this.kitGiftsPreset > 0 ||
          !this.showGifts ||
          hasNoGifts ||
          primarySelectionItems.length === 0;
        bonusPanel.hidden =
          this.kitGiftsPreset > 0 ||
          !this.showGifts ||
          hasNoGifts ||
          bonusItems.length === 0;
      } else if (bonusPanel) {
        bonusPanel.hidden =
          !this.showGifts || hasNoGifts || applicableItems.length === 0;
      }

      if (extraSelectionPanel) {
        extraSelectionPanel.hidden =
          !this.showGifts || hasNoGifts || extraSelectionItems.length === 0;
      }

      if (!this._shouldShowBaseGifts() && !this._shouldShowGift3() && this.colorsDrawer?.open) {
        this._closeColorsDrawer();
      }
    }

    _giftHasDescription(item) {
      const text = String(item?.description || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      return text.length > 0;
    }

    _openGiftModalForSlot(slot) {
      const item = this._getGiftItem(slot);
      if (!item || this._isGiftSoldOut(item)) return;
      if (this.bonusGiftPopup && !this._giftHasDescription(item)) return;

      const blockId = this.getAttribute('data-block-id');
      const template = document.getElementById(`bundle-gift-content-${blockId}-${slot}`);
      const content = template
        ? template.content.cloneNode(true)
        : this._createGiftInfoFallback(item);
      if (!content) return;

      if (this.bonusGiftPopup && this.giftInfoModal && this.giftInfoModalContent) {
        this.giftInfoModalContent.innerHTML = '';
        this.giftInfoModalContent.appendChild(content);
        const description = this.giftInfoModalContent.querySelector(
          '.bk-media-gift-modal__description'
        );
        const descriptionText = description?.textContent?.replace(/\s+/g, ' ').trim();
        if (!description || !descriptionText) {
          this.giftInfoModalContent.innerHTML = '';
          return;
        }
        this.giftInfoModalContent.replaceChildren(description);
        this._initGiftModalDescription(this.giftInfoModalContent);
        this._openGiftInfoModal();
        return;
      }

      if (!this.giftDrawer || !this.giftDrawerContent) return;

      this.giftDrawerContent.innerHTML = '';
      this.giftDrawerContent.appendChild(content);

      if (this.giftDrawerHeader) {
        this.giftDrawerHeader.textContent = this._usesGiftOptInDrawer(item)
          ? item.title
          : `GRATIS: ${item.title}`;
      }

      this._initGiftModalDescription(this.giftDrawerContent);

      if (this.giftDrawerFooter) {
        this.giftDrawerFooter.hidden = true;
      }

      this.giftDrawer.show?.();
    }

    _createGiftInfoFallback(item) {
      if (!item?.description) return null;

      const body = document.createElement('div');
      body.className = 'bk-media-gift-modal__body v-stack gap-4';

      const wrap = document.createElement('div');
      wrap.className = 'bk-media-gift-modal__description';
      const inner = document.createElement('div');
      inner.className = 'prose bk-media-gift-modal__description-inner';
      inner.setAttribute('data-gift-description', '');
      inner.innerHTML = item.description;
      wrap.appendChild(inner);
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bk-media-gift-modal__toggle link text-sm';
      toggle.setAttribute('data-gift-read-toggle', '');
      toggle.hidden = true;
      toggle.textContent = 'Mehr lesen';
      wrap.appendChild(toggle);
      body.appendChild(wrap);

      return body;
    }

    _closeGiftModal() {
      this._closeGiftInfoModal();
      if (!this.giftDrawer) return;
      this.giftDrawer.hide?.();
      this._activeGiftPickerSlot = null;
      this._activePickerContext = null;
      if (this.giftDrawerFooter) this.giftDrawerFooter.hidden = true;
      if (this.giftPickerStatus) this.giftPickerStatus.textContent = '';
      if (this.giftPickerConfirm) this.giftPickerConfirm.disabled = true;
    }

    _giftDescriptionOverflows(element) {
      const styles = getComputedStyle(element);
      const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.6;
      const maxHeight = lineHeight * 5;
      return element.scrollHeight > maxHeight + 2;
    }

    _toggleGiftDescription(desc, toggle) {
      const expanded = desc.classList.toggle('is-expanded');
      desc.classList.toggle('is-collapsed', !expanded);
      toggle.textContent = expanded ? 'Weniger lesen' : 'Mehr lesen';
    }

    _initFromForm() {
      const variant = this._getCurrentVariant();
      if (!variant) return;
      this._updateKitRowVariants(variant);
      this._applyPresetForKit(getVariantOptions(variant)[this.kitOptionIndex]);
      this._syncKitRows(variant);
      this._renderSlots();
      this._updateKitRowPricing();
      this._updateUi();
      this._updateDrawerPricing();
      if (this.flexibleSelection) {
        this._flexibleLastSelectionCount = this._getEffectiveSelectionCount();
        this._updateFlexibleProgressBanner();
      }
    }

    _getCurrentVariant() {
      const form = this.form;
      if (!form) return this.variants[0] || null;
      const idInput = form.querySelector('input[name="id"]');
      const id = idInput ? parseInt(idInput.value, 10) : null;
      return this.variants.find((v) => v.id === id) || this.variants[0] || null;
    }

    _onVariantChange(event) {
      if (this._suppressVariantChangeHandling || this._kitRevertInProgress) return;
      const variant = event.detail?.variant;
      if (!variant) return;
      const full = this.variants.find((v) => v.id === variant.id) || variant;
      const kitValue = getVariantOptions(full)[this.kitOptionIndex];
      if (!this._canSwitchToKit(kitValue)) {
        this._revertToActiveKit();
        return;
      }
      this._syncKitRows(full);
      this._updateKitRowVariants(full);
      this._updateKitRowPricing();
      this._updateUi();
      this._updateDrawerPricing();
    }

    _applyPresetForKit(kitValue, presetIndex) {
      const index = parseInt(presetIndex, 10);
      let preset =
        this.presets.find((p) => p.kitValue === kitValue) ||
        (index ? this.presets.find((p) => p.presetIndex === index) : null);

      if (!preset && kitValue) {
        const row = this.querySelector(
          `[data-bundle-kit-row][data-kit-value="${CSS.escape(kitValue)}"]`
        );
        if (row) {
          preset = {
            kitValue,
            presetIndex: parseInt(row.getAttribute('data-preset-index'), 10) || index,
            quantity: parseInt(row.getAttribute('data-preset-quantity'), 10) || 1,
            discountPercent: 0,
            bundleGroup: row.getAttribute('data-bundle-group') || null,
            noGifts: row.getAttribute('data-no-gifts') === 'true'
          };
        }
      }

      this.activePreset = preset || { quantity: 1, discountPercent: 0, kitValue };
    }

    _trimSelectionsToRequired() {
      if (this._hasOptionalExtraSlots()) return;
      const required = this._getRequiredQty();
      if (this.selections.length > required) {
        this.selections = this.selections.slice(0, required);
      }
    }

    _getPresetQuantityForKitValue(kitValue) {
      if (!kitValue) return 0;
      const preset = this.presets.find((p) => p.kitValue === kitValue);
      if (preset?.quantity) return preset.quantity;
      const row = this.querySelector(
        `[data-bundle-kit-row][data-kit-value="${CSS.escape(kitValue)}"]`
      );
      return parseInt(row?.getAttribute('data-preset-quantity'), 10) || 0;
    }

    _getPresetIndexForKitValue(kitValue) {
      if (!kitValue) return null;
      const preset = this.presets.find((p) => p.kitValue === kitValue);
      if (preset?.presetIndex) return preset.presetIndex;
      const row = this.querySelector(
        `[data-bundle-kit-row][data-kit-value="${CSS.escape(kitValue)}"]`
      );
      const presetIndex = parseInt(row?.getAttribute('data-preset-index'), 10);
      return Number.isFinite(presetIndex) ? presetIndex : null;
    }

    _isFlexibleKitSwitchBlocked(currentPresetIndex, targetPresetIndex, selectionCount) {
      if (!selectionCount || !currentPresetIndex || !targetPresetIndex) return false;
      if (currentPresetIndex === targetPresetIndex) return false;

      if (this._presetHasVolumeDiscount(targetPresetIndex) && (currentPresetIndex === 1 || currentPresetIndex === 2)) {
        return true;
      }

      if (currentPresetIndex === 2 && targetPresetIndex === 1) {
        const starterRow = this.querySelector('[data-bundle-kit-row][data-preset-index="1"]');
        const starterMax = parseInt(starterRow?.getAttribute('data-preset-quantity'), 10) || 4;
        if (selectionCount > starterMax) return true;
      }

      return false;
    }

    _getIncomingSelections(previousKit) {
      const fromDrawer = this._flattenDrawerQuantitiesToSelections();
      if (fromDrawer.length > 0) return fromDrawer;
      if (this.selections.length > 0) {
        return [...this.selections];
      }
      if (previousKit && this.presetSelections[previousKit]?.length) {
        return [...this.presetSelections[previousKit]];
      }
      return [];
    }

    _flattenDrawerQuantitiesToSelections(products = this._getActiveDrawerProducts()) {
      const total = this._getDrawerTotalQty();
      if (total <= 0) return [];

      const flat = [];
      Object.entries(this.drawerQuantities).forEach(([variantId, qty]) => {
        const product = products.find((p) => String(p.variant_id) === variantId);
        if (!this._isProductAvailable(product)) return;
        for (let i = 0; i < qty; i++) {
          flat.push({
            variantId: parseInt(variantId, 10),
            title: formatDrawerProductTitle(product?.title || ''),
            image: product?.image || null
          });
        }
      });
      return flat;
    }

    _shouldPreserveSelectionsOnKitSwitch(previousPresetIndex, targetPresetIndex, selectionCount) {
      if (!selectionCount) return false;
      if (
        this.flexibleSelection &&
        this._isFlexibleKitSwitchBlocked(previousPresetIndex, targetPresetIndex, selectionCount)
      ) {
        return false;
      }
      if (this.flexibleSelection && previousPresetIndex === 1 && targetPresetIndex === 2) {
        return true;
      }
      return selectionCount > 0;
    }

    _getCurrentSelectionCount() {
      if (this.drawer?.open && this._getDrawerTotalQty() > 0) {
        return this._getDrawerTotalQty();
      }
      return this.selections.length;
    }

    _canSwitchToKit(targetKitValue) {
      const currentKit = this.activePreset?.kitValue;
      if (!targetKitValue || !currentKit || currentKit === targetKitValue) return true;

      const selectionCount = this._getCurrentSelectionCount();

      if (this.flexibleSelection) {
        if (selectionCount <= 0) return true;
        const currentPresetIndex = parseInt(this.activePreset?.presetIndex, 10);
        const targetPresetIndex = this._getPresetIndexForKitValue(targetKitValue);
        return !this._isFlexibleKitSwitchBlocked(
          currentPresetIndex,
          targetPresetIndex,
          selectionCount
        );
      }

      if (this.optionalExtraSlot) return true;

      const targetQty = this._getPresetQuantityForKitValue(targetKitValue);
      if (!targetQty) return true;

      return selectionCount <= targetQty;
    }

    _revertToActiveKit() {
      const kitValue = this.activePreset?.kitValue;
      if (!kitValue) return;
      const row = this.querySelector(
        `[data-bundle-kit-row][data-kit-value="${CSS.escape(kitValue)}"]`
      );
      if (!row) return;

      this._kitRevertInProgress = true;
      try {
        const variantId = row.getAttribute('data-variant-id');
        if (variantId) {
          this._setFormVariantId(variantId);
        }
        this._setKitOptionInForm(row.getAttribute('data-option-value-id'));
        this._syncGalleryForKitRow(row);
        this._highlightMissing(row);
      } finally {
        this._kitRevertInProgress = false;
      }
    }

    _updateKitRowSwitchability() {
      this.querySelectorAll('[data-bundle-kit-row]').forEach((row) => {
        const kitValue = row.getAttribute('data-kit-value');
        const isSelected = row.classList.contains('is-selected');
        const allowed = this._canSwitchToKit(kitValue);
        row.classList.toggle('is-switch-disabled', !allowed && !isSelected);
        if (!allowed && !isSelected) {
          row.setAttribute('aria-disabled', 'true');
        } else {
          row.removeAttribute('aria-disabled');
        }
      });
    }

    _removeSelectionAtIndex(index) {
      if (index < 0 || index >= this.selections.length) return;
      this.selections.splice(index, 1);
      this._saveSelectionsForPreset(this.activePreset?.kitValue);
      this._renderSlots();
      if (this.flexibleSelection) {
        this._syncFlexibleAfterSelectionChange();
        return;
      }
      if (this.optionalExtraSlot) {
        this._syncOptionalAfterSelectionChange();
        return;
      }
      this._updateKitRowPricing();
      this._updateKitRowSwitchability();
      this._updateUi();
      this._updateDrawerPricing();
    }

    _removeGiftSelection(slot) {
      if (!this.giftSelections[slot]) return;
      delete this.giftSelections[slot];
      const item = this._getGiftItem(slot);
      if (item) {
        this._updateGiftCardUi(slot, null, item);
      }
      this._updateColorsSlotUi();
      this._updateKitRowPricing();
      this._updateUi();
    }

    _saveSelectionsForPreset(kitValue) {
      if (!kitValue) return;
      this.presetSelections[kitValue] = [...this.selections];
    }

    _applyDrawerQuantitiesToSelections({ syncEmpty = true } = {}) {
      const flat = this._flattenDrawerQuantitiesToSelections();
      if (flat.length === 0) {
        if (syncEmpty) this.selections = [];
        return;
      }
      this.selections = flat;
    }

    _persistDrawerSelections() {
      if (this.drawerMode === 'gratis-extra') {
        this._persistGratisExtraFromDrawer();
        this._renderGratisExtraSlot();
        this._updateUi();
        return;
      }
      if (this.drawerMode === 'promo-gifts') {
        this._persistPromoGiftsFromDrawer();
        this._renderPromoGiftSlots();
        this._updateKitRowPricing();
        this._updateUi();
        return;
      }
      this._applyDrawerQuantitiesToSelections();
      this._saveSelectionsForPreset(this.activePreset?.kitValue);
      this._renderSlots();
      if (this.flexibleSelection) {
        this._syncFlexibleAfterSelectionChange();
      } else if (this.optionalExtraSlot) {
        this._syncOptionalAfterSelectionChange();
      } else {
        this._updateKitRowPricing();
        this._updateKitRowSwitchability();
        this._updateUi();
      }
    }

    _loadSelectionsForPreset(kitValue, previousKit, incomingSelections) {
      const saved = this.presetSelections[kitValue];
      const fromPrevious =
        previousKit &&
        previousKit !== kitValue &&
        this.presetSelections[previousKit]?.length
          ? [...this.presetSelections[previousKit]]
          : null;
      const incoming = incomingSelections?.length ? incomingSelections : null;

      if (incoming?.length) {
        this.selections = this._sanitizeSelections(incoming);
      } else if (saved?.length) {
        this.selections = this._sanitizeSelections(saved);
      } else if (fromPrevious) {
        this.selections = this._sanitizeSelections(fromPrevious);
      } else {
        this.selections = saved ? this._sanitizeSelections(saved) : [];
      }
      this._trimSelectionsToRequired();
    }

    _switchPreset(kitValue, presetIndex, options = {}) {
      const keepDrawerOpen = options.keepDrawerOpen === true;
      const previousKit = this.activePreset?.kitValue;
      const previousPresetIndex = this._getPresetIndexForKitValue(previousKit);
      const targetPresetIndex = this._getPresetIndexForKitValue(kitValue);

      const incomingSelections = this._getIncomingSelections(previousKit);

      if (previousKit && previousKit !== kitValue) {
        if (this._getDrawerTotalQty() > 0) {
          this._applyDrawerQuantitiesToSelections({ syncEmpty: false });
        } else if (incomingSelections.length > 0) {
          this.selections = this._sanitizeSelections(incomingSelections);
        }
        this._saveSelectionsForPreset(previousKit);
      }
      this._applyPresetForKit(kitValue, presetIndex);
      if (!kitValue) return;
      if (previousKit !== kitValue) {
        if (this.drawer?.open && !keepDrawerOpen) {
          this._suppressDrawerPersist = true;
          this.drawer.hide?.();
        }
        if (!keepDrawerOpen) {
          this.drawerQuantities = {};
        }

        const preserveSelections =
          options.preserveSelections ??
          this._shouldPreserveSelectionsOnKitSwitch(
            previousPresetIndex,
            targetPresetIndex,
            incomingSelections.length
          );

        if (preserveSelections && incomingSelections.length) {
          this.selections = this._sanitizeSelections(incomingSelections);
          const maxQty = this._getMaxSelectableQtyForKitValue(kitValue, targetPresetIndex);
          if (this.selections.length > maxQty) {
            this.selections = this.selections.slice(0, maxQty);
          }
          this._saveSelectionsForPreset(kitValue);
        } else {
          this._loadSelectionsForPreset(kitValue, previousKit, incomingSelections);
        }

        if (keepDrawerOpen && this.drawer?.open) {
          this._syncDrawerQuantitiesFromSelections();
          this._clearCelebration(this._getRecipeCelebrationContext());
        }
      } else {
        this._trimSelectionsToRequired();
      }
    }

    _selectKit(row, options = {}) {
      const kitValue = row.getAttribute('data-kit-value');
      const optionValueId = row.getAttribute('data-option-value-id');
      const presetIndex = row.getAttribute('data-preset-index');
      const variantId = row.getAttribute('data-variant-id');
      const keepDrawerOpen = options.keepDrawerOpen === true;

      this._kitSelectInProgress = true;
      try {
        this.querySelectorAll('[data-bundle-kit-row]').forEach((r) => {
          r.classList.toggle('is-selected', r === row);
          r.toggleAttribute('aria-current', r === row);
        });

        const plainSingle = row.hasAttribute('data-plain-single');
        if (!plainSingle && variantId) {
          this._setFormVariantId(variantId);
        }
        if (!plainSingle) {
          this._setKitOptionInForm(optionValueId);
        }
        if (plainSingle) {
          const galleryVariant = this._getVariantById(row.getAttribute('data-gallery-variant-id'));
          if (galleryVariant) this._applyGalleryFilterDom(galleryVariant);
        } else {
          this._syncGalleryForKitRow(row);
        }
        this._switchPreset(kitValue, presetIndex, { keepDrawerOpen });

        this._renderSlots();
        this._updateKitRowPricing();
        this._updateKitRowSwitchability();
        this._updateUi();
        this._updateDrawerPricing();
        if (keepDrawerOpen) {
          this._ensureDrawerUpgradeProgressRefs();
          this._syncDrawerQtyDisplay();
        }
        if (this.flexibleSelection) {
          this._updateFlexibleProgressBanner();
        }
        this._syncSubscriptionInterval();
        this._placeKitGifts(presetIndex);
      } finally {
        this._kitSelectInProgress = false;
      }
    }

    _kitGiftsHostPreset() {
      if (this.kitGiftsPreset <= 0) return 0;
      return this.kitGiftsPreset;
    }

    _placeKitGifts(presetIndex, options = {}) {
      if (this.kitGiftsPreset <= 0) return;
      const host = this._kitGiftsHostPreset(presetIndex);
      const wrap = this.querySelector('[data-kit-gifts-rows]');
      const mount = this.querySelector(`[data-kit-gifts-mount="${host}"]`);
      const clip = mount?.querySelector('[data-kit-gifts-clip]');
      if (!wrap || !mount || !clip) return;
      const fromMount = wrap.closest('[data-kit-gifts-mount]');
      if (fromMount === mount) return;

      const animate =
        options.animate !== false &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this._kitGiftsMoveId = (this._kitGiftsMoveId || 0) + 1;
      const moveId = this._kitGiftsMoveId;
      this.querySelectorAll('[data-kit-gifts-clone]').forEach((node) => node.remove());
      clearTimeout(this._kitGiftsMoveTimer);

      const releaseMount = (node, open) => {
        node.style.transition = 'none';
        node.style.height = '';
        node.classList.toggle('is-open', open);
      };

      if (!animate || !fromMount) {
        this.querySelectorAll('[data-kit-gifts-mount]').forEach((node) => releaseMount(node, false));
        clip.appendChild(wrap);
        releaseMount(mount, true);
        return;
      }

      const fromHeight = fromMount.getBoundingClientRect().height;
      const fromClip = fromMount.querySelector('[data-kit-gifts-clip]');
      const clone = wrap.cloneNode(true);
      clone.setAttribute('data-kit-gifts-clone', '');
      clone.removeAttribute('data-kit-gifts-rows');

      fromMount.style.transition = 'none';
      mount.style.transition = 'none';
      fromMount.style.height = `${fromHeight}px`;
      clip.appendChild(wrap);
      fromClip?.appendChild(clone);
      const toHeight = wrap.getBoundingClientRect().height;
      mount.style.height = '0px';
      mount.classList.add('is-open');
      fromMount.classList.remove('is-open');
      void mount.offsetHeight;

      const motion = 'height 0.38s cubic-bezier(0.22, 1, 0.36, 1)';
      fromMount.style.transition = motion;
      mount.style.transition = motion;
      fromMount.style.height = '0px';
      mount.style.height = `${toHeight}px`;

      const finish = () => {
        if (this._kitGiftsMoveId !== moveId) return;
        clone.remove();
        fromMount.style.transition = 'none';
        fromMount.style.height = '0px';
        fromMount.classList.remove('is-open');
        fromMount.style.height = '';
        mount.style.transition = 'none';
      };
      const onEnd = (event) => {
        if (event.target !== mount || event.propertyName !== 'height') return;
        finish();
      };
      mount.addEventListener('transitionend', onEnd);
      this._kitGiftsMoveTimer = window.setTimeout(() => {
        mount.removeEventListener('transitionend', onEnd);
        finish();
      }, 500);
    }

    _setKitOptionInForm(optionValueId) {
      const picker = this.variantPicker;
      const form = this.form;
      if (!picker || !form) return;

      const input = picker.querySelector(
        `input[data-option-position="${this.kitOptionPosition}"][value="${optionValueId}"]`
      );
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _syncKitRows(variant) {
      if (this._kitSelectInProgress) {
        const selected = this.querySelector('[data-bundle-kit-row].is-selected');
        if (selected?.hasAttribute('data-one-time') || selected?.hasAttribute('data-plain-single')) return;
      }

      const kitValue = getVariantOptions(variant)[this.kitOptionIndex];
      this.querySelectorAll('[data-bundle-kit-row]').forEach((row) => {
        const selected = row.getAttribute('data-kit-value') === kitValue;
        row.classList.toggle('is-selected', selected);
        row.toggleAttribute('aria-current', selected);
      });

      if (this._kitSelectInProgress) return;

      const previousKit = this.activePreset?.kitValue;
      const previousPresetIndex = this._getPresetIndexForKitValue(previousKit);
      const targetPresetIndex = this._getPresetIndexForKitValue(kitValue);

      if (
        previousPresetIndex &&
        targetPresetIndex &&
        previousPresetIndex === targetPresetIndex &&
        previousKit !== kitValue
      ) {
        this._applyPresetForKit(kitValue, targetPresetIndex);
        this._renderSlots();
        this._updateKitRowPricing();
        this._updateKitRowSwitchability();
        this._updateUi();
        this._updateDrawerPricing();
        return;
      }

      this._switchPreset(kitValue);
      this._renderSlots();
      this._updateKitRowPricing();
      this._updateKitRowSwitchability();
      this._updateUi();
      this._updateDrawerPricing();
    }

    _updateKitRowVariants(referenceVariant) {
      this.querySelectorAll('[data-bundle-kit-row]').forEach((row) => {
        const kitValue = row.getAttribute('data-kit-value');
        const match = this._findVariantForKitValue(kitValue, referenceVariant);
        if (match) {
          this._setKitRowVariantAttributes(row, match);
        }
      });
    }

    _findVariantForKitValue(kitValue, referenceVariant) {
      if (!kitValue) return null;
      const refOptions = referenceVariant ? getVariantOptions(referenceVariant) : [];
      const strictMatch = this.variants.find((v) => {
        const vOptions = getVariantOptions(v);
        if (vOptions[this.kitOptionIndex] !== kitValue) return false;
        if (refOptions.length <= 1) return true;
        return vOptions.every((opt, i) => {
          if (i === this.kitOptionIndex) return true;
          return opt === refOptions[i];
        });
      });
      return strictMatch || this.variants.find((v) => getVariantOptions(v)[this.kitOptionIndex] === kitValue) || null;
    }

    _renderSlots() {
      if (!this.slotsEl || !this.slotTemplate) return;
      if (this._hasOptionalExtraSlots()) {
        this._renderFlexibleSlots();
        this._renderGratisExtraSlot();
        return;
      }
      const qty = parseInt(this.activePreset?.quantity, 10) || 1;
      const placeholderLabel =
        this.slotTemplate.content.querySelector('[data-slot-label]')?.textContent?.trim() ||
        'Rezeptkarten auswählen...';
      const placeholderImageHtml =
        this.slotTemplate.content.querySelector('[data-slot-image]')?.innerHTML || '';

      this.slotsEl.innerHTML = '';
      for (let i = 0; i < qty; i++) {
        const node = this.slotTemplate.content.cloneNode(true);
        const btn = node.querySelector('[data-bundle-open-drawer]');
        const removeBtn = node.querySelector('[data-slot-remove]');
        const sel = this.selections[i];
        const check = btn?.querySelector('[data-slot-check]');
        if (sel && btn) {
          const label = btn.querySelector('[data-slot-label]');
          const imgWrap = btn.querySelector('[data-slot-image]');
          if (label) {
            label.textContent = sel.title;
            label.classList.remove('text-subdued');
          }
          if (imgWrap && sel.image) {
            imgWrap.innerHTML = `<img src="${sel.image}" alt="" loading="lazy" width="60" height="60">`;
          }
          btn.classList.add('is-filled');
          if (check) check.setAttribute('aria-hidden', 'false');
          if (removeBtn) {
            removeBtn.hidden = false;
            removeBtn.setAttribute('data-slot-index', String(i));
          }
        } else if (btn) {
          const label = btn.querySelector('[data-slot-label]');
          const imgWrap = btn.querySelector('[data-slot-image]');
          if (label) {
            label.textContent = placeholderLabel;
            label.classList.add('text-subdued');
          }
          if (imgWrap && placeholderImageHtml) {
            imgWrap.innerHTML = placeholderImageHtml;
          }
          btn.classList.remove('is-filled');
          if (check) check.setAttribute('aria-hidden', 'true');
          if (removeBtn) {
            removeBtn.hidden = true;
            removeBtn.removeAttribute('data-slot-index');
          }
        }
        this.slotsEl.appendChild(node);
      }
      this._updateKitRowSwitchability();
      this._renderGratisExtraSlot();
    }

    _renderFlexibleSlots() {
      const baseQty = this._getBaseRequiredQty();
      const maxQty = this._getMaxSelectableQty();
      if (this.selections.length > maxQty) {
        this.selections = this.selections.slice(0, maxQty);
      }
      const optionalLabel =
        this.flexibleConfig?.optionalSlotLabel ||
        this.getAttribute('data-optional-slot-label') ||
        'Optional auswählen...';
      const placeholderLabel =
        this.slotTemplate.content.querySelector('[data-slot-label]')?.textContent?.trim() ||
        'Rezeptkarten auswählen...';
      const placeholderImageHtml =
        this.slotTemplate.content.querySelector('[data-slot-image]')?.innerHTML || '';
      const filledCount = this.selections.length;
      const allowOptionalRows = this.optionalExtraSlot;
      const showExtraSlot =
        allowOptionalRows && maxQty > baseQty && filledCount < maxQty;
      const canShowFlexibleExtraSlot =
        maxQty > baseQty && filledCount >= baseQty && filledCount < maxQty;
      const totalSlots = allowOptionalRows
        ? Math.max(baseQty, filledCount) + (showExtraSlot ? 1 : 0)
        : Math.max(baseQty, filledCount) + (canShowFlexibleExtraSlot ? 1 : 0);

      this.slotsEl.innerHTML = '';

      for (let i = 0; i < totalSlots; i++) {
        const isOptional = allowOptionalRows && i >= baseQty;
        const node = this.slotTemplate.content.cloneNode(true);
        const btn = node.querySelector('[data-bundle-open-drawer]');
        const removeBtn = node.querySelector('[data-slot-remove]');
        const sel = this.selections[i];
        const check = btn?.querySelector('[data-slot-check]');

        if (isOptional) {
          btn?.classList.add('is-optional');
        }

        if (sel && btn) {
          const label = btn.querySelector('[data-slot-label]');
          const imgWrap = btn.querySelector('[data-slot-image]');
          if (label) {
            label.textContent = sel.title;
            label.classList.remove('text-subdued');
          }
          if (imgWrap && sel.image) {
            imgWrap.innerHTML = `<img src="${sel.image}" alt="" loading="lazy" width="60" height="60">`;
          }
          btn.classList.add('is-filled');
          if (check) check.setAttribute('aria-hidden', 'false');
          if (removeBtn) {
            removeBtn.hidden = false;
            removeBtn.setAttribute('data-slot-index', String(i));
          }
        } else if (btn) {
          const label = btn.querySelector('[data-slot-label]');
          const imgWrap = btn.querySelector('[data-slot-image]');
          const emptyLabel = isOptional ? optionalLabel : placeholderLabel;
          if (label) {
            label.textContent = emptyLabel;
            label.classList.add('text-subdued');
          }
          if (imgWrap && placeholderImageHtml) {
            imgWrap.innerHTML = placeholderImageHtml;
          }
          btn.classList.remove('is-filled');
          if (check) check.setAttribute('aria-hidden', 'true');
          if (removeBtn) {
            removeBtn.hidden = true;
            removeBtn.removeAttribute('data-slot-index');
          }
        }

        this.slotsEl.appendChild(node);
      }

      this._updateKitRowSwitchability();
      this._updateFlexibleProgressBanner();
    }

    _isGratisExtraPresetActive(presetIndex) {
      const index =
        presetIndex != null
          ? parseInt(presetIndex, 10)
          : parseInt(this.activePreset?.presetIndex, 10) ||
            parseInt(this._getSelectedKitRow()?.getAttribute('data-preset-index'), 10) ||
            1;
      if (this.gratisExtraPreset > 0) return index === this.gratisExtraPreset;
      return index >= 1;
    }

    _isGratisExtraActive() {
      return (
        this.gratisExtraEnabled &&
        this.gratisExtraProducts.length > 0 &&
        this._isGratisExtraPresetActive()
      );
    }

    _updateGratisExtraVisibility() {
      const isActive = this._isGratisExtraActive();
      this.gratisExtraProduct = isActive;

      if (this.gratisExtraPanel) {
        this.gratisExtraPanel.hidden = !isActive;
      }

      if (!isActive && this.gratisExtraSelection) {
        this.gratisExtraSelection = null;
      }

      this._renderGratisExtraSlot();
    }

    _renderGratisExtraSlot() {
      if (!this.gratisExtraSlotEl || !this.slotTemplate) return;
      if (!this.gratisExtraProduct) {
        this.gratisExtraSlotEl.innerHTML = '';
        return;
      }

      const placeholderImageHtml =
        this.slotTemplate.content.querySelector('[data-slot-image]')?.innerHTML || '';
      const sel = this.gratisExtraSelection;

      this.gratisExtraSlotEl.innerHTML = '';
      const node = this.slotTemplate.content.cloneNode(true);
      const wrap = node.querySelector('[data-bundle-slot-wrap]');
      if (wrap) {
        wrap.setAttribute('data-gratis-extra-slot-wrap', '');
        wrap.removeAttribute('data-bundle-slot-wrap');
      }

      const btn = node.querySelector('[data-bundle-open-drawer]');
      const removeBtn = node.querySelector('[data-slot-remove]');
      const check = btn?.querySelector('[data-slot-check]');

      if (sel && btn) {
        const label = btn.querySelector('[data-slot-label]');
        const imgWrap = btn.querySelector('[data-slot-image]');
        if (label) {
          label.textContent = sel.title;
          label.classList.remove('text-subdued');
        }
        if (imgWrap && sel.image) {
          imgWrap.innerHTML = `<img src="${sel.image}" alt="" loading="lazy" width="60" height="60">`;
        }
        btn.classList.add('is-filled');
        if (check) check.setAttribute('aria-hidden', 'false');
        if (removeBtn) removeBtn.hidden = false;
      } else if (btn) {
        const label = btn.querySelector('[data-slot-label]');
        const imgWrap = btn.querySelector('[data-slot-image]');
        if (label) {
          label.textContent = this.gratisExtraPlaceholder;
          label.classList.add('text-subdued');
        }
        if (imgWrap && placeholderImageHtml) {
          imgWrap.innerHTML = placeholderImageHtml;
        }
        btn.classList.remove('is-filled');
        if (check) check.setAttribute('aria-hidden', 'true');
        if (removeBtn) removeBtn.hidden = true;
      }

      this.gratisExtraSlotEl.appendChild(node);
    }

    _renderPromoGiftSlots() {
      if (!this.promoGiftsSlotsEl || !this.slotTemplate) return;
      if (!this.promoGiftsEnabled) {
        this.promoGiftsSlotsEl.innerHTML = '';
        return;
      }

      const placeholderImageHtml =
        this.promoGiftsPlaceholderImageHtml ||
        this.slotTemplate.content.querySelector('[data-slot-image]')?.innerHTML ||
        '';

      this.promoGiftsSlotsEl.innerHTML = '';
      for (let i = 0; i < this.promoGiftsCount; i++) {
        const sel = this.promoGiftSelections[i];
        const node = this.slotTemplate.content.cloneNode(true);
        const wrap = node.querySelector('[data-bundle-slot-wrap]');
        if (wrap) {
          wrap.setAttribute('data-promo-gifts-slot-wrap', '');
          wrap.removeAttribute('data-bundle-slot-wrap');
        }

        const btn = node.querySelector('[data-bundle-open-drawer]');
        const removeBtn = node.querySelector('[data-slot-remove]');
        const check = btn?.querySelector('[data-slot-check]');

        if (sel && btn) {
          const label = btn.querySelector('[data-slot-label]');
          const imgWrap = btn.querySelector('[data-slot-image]');
          if (label) {
            label.textContent = sel.title;
            label.classList.remove('text-subdued');
          }
          if (imgWrap && sel.image) {
            imgWrap.innerHTML = `<img src="${sel.image}" alt="" loading="lazy" width="60" height="60">`;
          }
          btn.classList.add('is-filled');
          if (check) check.setAttribute('aria-hidden', 'false');
          if (removeBtn) {
            removeBtn.hidden = false;
            removeBtn.setAttribute('data-slot-index', String(i));
          }
        } else if (btn) {
          const label = btn.querySelector('[data-slot-label]');
          const imgWrap = btn.querySelector('[data-slot-image]');
          if (label) {
            label.textContent = this.promoGiftsPlaceholder;
            label.classList.add('text-subdued');
          }
          if (imgWrap && placeholderImageHtml) {
            imgWrap.innerHTML = placeholderImageHtml;
          }
          btn.classList.remove('is-filled');
          if (check) check.setAttribute('aria-hidden', 'true');
          if (removeBtn) {
            removeBtn.hidden = true;
            removeBtn.removeAttribute('data-slot-index');
          }
        }

        this.promoGiftsSlotsEl.appendChild(node);
      }
    }

    _isProductAvailable(product) {
      if (this.forceDrawerSoldOut) return false;
      return Boolean(product?.available);
    }

    _sanitizeSelections(selections) {
      return (selections || []).filter((selection) => {
        const product = this.products.find((entry) => entry.variant_id === selection.variantId);
        return this._isProductAvailable(product);
      });
    }

    _getActiveDrawerProducts() {
      if (this.drawerMode === 'gratis-extra') return this.gratisExtraProducts;
      if (this.drawerMode === 'promo-gifts') return this.promoGiftsProducts;
      return this.products;
    }

    _setDrawerTitle(title) {
      const drawerTitle = title || this.drawerDefaultTitle;
      const headerTitle = this.drawer?.querySelector('.bk-media-bundle-builder__drawer-header .h5');
      if (headerTitle) headerTitle.textContent = drawerTitle;
      if (this.drawerConfirmTitle) {
        this._drawerConfirmDefaultTitle = drawerTitle;
        this.drawerConfirmTitle.textContent = drawerTitle;
      }
    }

    _setDrawerFooterPricesVisible(visible) {
      const pricesEl = this.drawer?.querySelector('.bk-media-bundle-builder__drawer-prices');
      if (pricesEl) pricesEl.hidden = !visible;
    }

    _shouldShowDrawerItemPrices(products = this._getActiveDrawerProducts()) {
      return products !== this.gratisExtraProducts && products !== this.promoGiftsProducts;
    }

    _getDrawerProductsSorted(products = this._getActiveDrawerProducts()) {
      return [...products].sort((a, b) => {
        const aAvailable = this._isProductAvailable(a);
        const bAvailable = this._isProductAvailable(b);
        if (aAvailable !== bAvailable) return aAvailable ? -1 : 1;
        return 0;
      });
    }

    _renderDrawerProducts(products = this._getActiveDrawerProducts()) {
      if (!this.drawerList) return;
      const qtyTemplate = this.querySelector('[data-bundle-qty-template]');
      const fragment = document.createDocumentFragment();

      this._getDrawerProductsSorted(products).forEach((product) => {
        const isUnavailable = !this._isProductAvailable(product);
        const item = document.createElement('div');
        item.className = 'bk-media-bundle-builder__drawer-item';
        if (isUnavailable) item.classList.add('is-unavailable');
        if (product.rowBackground) {
          item.style.backgroundColor = product.rowBackground;
        }
        item.setAttribute('data-drawer-item', '');
        item.setAttribute('data-variant-id', String(product.variant_id));
        item.setAttribute('data-product-id', String(product.id));
        item.setAttribute('data-price', String(product.price));
        item.setAttribute('data-available', isUnavailable ? 'false' : 'true');

        const imageWrap = document.createElement('div');
        imageWrap.className = 'bk-media-bundle-builder__drawer-item-image';
        if (product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 56;
          img.height = 56;
          imageWrap.appendChild(img);
        }

        const info = document.createElement('div');
        info.className = 'bk-media-bundle-builder__drawer-item-info v-stack gap-1';
        const title = document.createElement('span');
        title.className = 'text-base bk-media-bundle-builder__drawer-item-title';
        title.textContent = formatDrawerProductTitle(product.title);
        info.appendChild(title);
        /* START: drawer product badge */
        if (product.badge) {
          const badge = document.createElement('span');
          badge.className = 'badge badge--primary bk-media-bundle-builder__drawer-item-badge';
          badge.textContent = product.badge;
          info.appendChild(badge);
        }
        /* END: drawer product badge */
        if (product.subtitle) {
          const subtitle = document.createElement('span');
          subtitle.className = 'text-subdued text-sm';
          subtitle.textContent = product.subtitle;
          info.appendChild(subtitle);
        }

        if (isUnavailable) {
          const soldOut = document.createElement('span');
          soldOut.className = 'text-xs bk-media-bundle-builder__colors-variant-sold-out';
          soldOut.textContent = 'Ausverkauft';
          info.appendChild(soldOut);
        }

        if (this._shouldShowDrawerItemPrices(products) && this.defaultUnitPrice > 0) {
          const delta = product.price - this.defaultUnitPrice;
          if (delta !== 0) {
            const deltaSpan = document.createElement('span');
            deltaSpan.className = 'bk-media-bundle-builder__drawer-price-delta text-subdued text-sm';
            deltaSpan.textContent = formatPriceDelta(delta);
            info.appendChild(deltaSpan);
          }
        }

        item.appendChild(imageWrap);
        item.appendChild(info);
        if (qtyTemplate) {
          item.appendChild(qtyTemplate.content.cloneNode(true));
        }

        const variantId = product.variant_id;
        item.querySelector('[data-qty-minus]')?.addEventListener('click', () =>
          this._changeDrawerQty(variantId, -1)
        );
        item.querySelector('[data-qty-plus]')?.addEventListener('click', () =>
          this._changeDrawerQty(variantId, 1)
        );
        item.querySelector('[data-qty-value]')?.addEventListener('keydown', (e) => e.preventDefault());

        const plusBtn = item.querySelector('[data-qty-plus]');
        if (plusBtn && isUnavailable) plusBtn.disabled = true;

        fragment.appendChild(item);
      });

      this.drawerList.innerHTML = '';
      this.drawerList.appendChild(fragment);
    }

    _ensureDrawerUpgradeProgressRefs() {
      if (!this.drawer) return;
      if (this.drawerUpgradeProgress) return;
      this.drawerUpgradeProgress = this.drawer.querySelector('[data-drawer-upgrade-progress]');
      this.drawerUpgradeProgressText = this.drawer.querySelector(
        '[data-drawer-upgrade-progress-text]'
      );
      this.drawerUpgradeProgressBadge = this.drawer.querySelector(
        '[data-drawer-upgrade-progress-badge]'
      );
    }

    _syncDrawerQuantitiesFromSelections() {
      this.selections = this._sanitizeSelections(this.selections);
      const maxQty = this._getMaxSelectableQty();
      if (this.selections.length > maxQty) {
        this.selections = this.selections.slice(0, maxQty);
      }
      this.drawerQuantities = {};
      this.selections.forEach((sel) => {
        const id = String(sel.variantId);
        this.drawerQuantities[id] = (this.drawerQuantities[id] || 0) + 1;
      });
      this.drawerQuantities = this._capQuantitiesToLimit(this.drawerQuantities, maxQty);
      this._drawerLastTotal = this._getDrawerTotalQty();
    }

    _openDrawer() {
      this.drawerMode = 'default';
      this._setDrawerTitle(this.drawerDefaultTitle);
      this._setDrawerFooterPricesVisible(true);
      this._renderDrawerProducts(this.products);
      this._syncDrawerQuantitiesFromSelections();
      this._clearCelebration(this._getRecipeCelebrationContext());
      this._syncDrawerQtyDisplay();
      this._updateDrawerPricing();
      if (this.flexibleSelection) {
        this._ensureDrawerUpgradeProgressRefs();
        this._updateFlexibleProgressBanner();
      } else if (this.optionalExtraSlot) {
        this._ensureDrawerUpgradeProgressRefs();
        this._updateOptionalProgressBanner();
      }
      this.drawer?.show?.();
    }

    _openGratisExtraDrawer() {
      if (!this.gratisExtraProduct || this.gratisExtraProducts.length === 0) return;
      this.drawerMode = 'gratis-extra';
      this._setDrawerTitle(this.gratisExtraDrawerTitle);
      this._setDrawerFooterPricesVisible(false);
      this._renderDrawerProducts(this.gratisExtraProducts);
      this.drawerQuantities = {};
      if (this.gratisExtraSelection) {
        this.drawerQuantities[String(this.gratisExtraSelection.variantId)] = 1;
      }
      this._drawerLastTotal = this._getDrawerTotalQty();
      this._clearCelebration(this._getRecipeCelebrationContext());
      this._syncDrawerQtyDisplay();
      this._updateDrawerPricing();
      this.drawer?.show?.();
    }

    _persistGratisExtraFromDrawer() {
      const flat = this._flattenDrawerQuantitiesToSelections();
      this.gratisExtraSelection = flat[0] || null;
    }

    _openPromoGiftsDrawer() {
      if (!this.promoGiftsEnabled || this.promoGiftsProducts.length === 0) return;
      this.drawerMode = 'promo-gifts';
      this._setDrawerTitle(this.promoGiftsDrawerTitle);
      this._setDrawerFooterPricesVisible(false);
      this._renderDrawerProducts(this.promoGiftsProducts);
      this.drawerQuantities = {};
      this.promoGiftSelections.forEach((selection) => {
        const id = String(selection.variantId);
        this.drawerQuantities[id] = (this.drawerQuantities[id] || 0) + 1;
      });
      this._drawerLastTotal = this._getDrawerTotalQty();
      this._clearCelebration(this._getRecipeCelebrationContext());
      this._syncDrawerQtyDisplay();
      this._updateDrawerPricing();
      this.drawer?.show?.();
    }

    _persistPromoGiftsFromDrawer() {
      const flat = this._flattenDrawerQuantitiesToSelections(this.promoGiftsProducts);
      this.promoGiftSelections = flat.slice(0, this.promoGiftsCount);
    }

    _getDrawerTotalQty() {
      return Object.values(this.drawerQuantities).reduce((a, b) => a + b, 0);
    }

    _getSelectedKitRow() {
      const selected = this.querySelector('[data-bundle-kit-row].is-selected');
      if (selected) return selected;
      if (this.hideKitSelection) {
        return this.querySelector('[data-bundle-kit-row]');
      }
      return null;
    }

    _getRequiredQty() {
      if (this.flexibleSelection) {
        return this._getBaseRequiredQty();
      }
      const rowQty = parseInt(this._getSelectedKitRow()?.getAttribute('data-preset-quantity'), 10);
      if (rowQty) return rowQty;
      return parseInt(this.activePreset?.quantity, 10) || 1;
    }

    _getGiftItems() {
      const items = this.giftPricing?.items || [];
      if (this.giftMode === 'single_always') {
        return items.filter((item) => item.slot === 1);
      }
      return items;
    }

    _shouldRequireGiftSelection() {
      if (this.giftOptional) return false;
      return this._getApplicableGiftItems().length > 0;
    }

    _getGiftItem(slot) {
      return this._getGiftItems().find((item) => item.slot === slot);
    }

    _getVariantCompareCents(variant) {
      if (!variant) return 0;
      const compare = parseInt(variant.compare_at_price, 10) || 0;
      const price = parseInt(variant.price, 10) || 0;
      return compare > price ? compare : price;
    }

    _findGiftVariant(item, selections) {
      if (!item?.variants?.length) return null;
      if (!item.options?.length) {
        return item.variants.find((variant) => variant.available) || item.variants[0];
      }
      return item.variants.find((variant) =>
        item.options.every((option) => {
          const position = option.position || item.options.indexOf(option) + 1;
          const key = `option${position}`;
          return variant[key] === selections[key];
        })
      );
    }

    _getSelectedGiftVariant(slot) {
      const item = this._getGiftItem(slot);
      if (!item) return null;
      const variantId = this.giftSelections[slot];
      if (!variantId) return null;
      return item.variants.find((variant) => variant.id === variantId) || null;
    }

    _getGiftCompareAdd() {
      return this._getApplicableGiftItems().reduce((sum, item) => {
        if (this._isGiftSoldOut(item)) return sum;
        const selected = this._getSelectedGiftVariant(item.slot);
        if (selected) return sum + this._getVariantCompareCents(selected);
        if (this._usesGiftOptInDrawer(item)) return sum;
        const fallback = item.variants?.[0];
        return sum + this._getVariantCompareCents(fallback);
      }, 0);
    }

    _initGiftSelections() {
      this.giftSelections = {};
      this._getGiftItems().forEach((item) => {
        if (this._usesGiftOptInDrawer(item)) {
          this._updateGiftCardUi(item.slot, null, item);
          return;
        }

        if (this._isGiftSoldOut(item)) {
          delete this.giftSelections[item.slot];
          this._updateGiftCardUi(item.slot, null, item);
          return;
        }

        const variant = this._getAutoGiftVariant(item);
        if (variant?.available) {
          this.giftSelections[item.slot] = variant.id;
          this._updateGiftCardUi(item.slot, variant, item);
        } else {
          this._updateGiftCardUi(item.slot, null, item);
        }
      });
      this._updateColorsSlotUi();
      this._updateUi();
    }

    _updateGiftCardUi(slot, variant, item) {
      const card = this.querySelector(`[data-gift-card][data-gift-slot="${slot}"]`);
      if (!card) return;
      const giftItem = item || this._getGiftItem(slot);
      const label = card.querySelector(`[data-gift-variant-label][data-gift-slot="${slot}"]`);
      const image = card.querySelector('[data-gift-image]');
      const pickLink = card.querySelector('.bk-media-bundle-builder__gift-color-link');

      if (label) {
        if (!this._giftNeedsVariantPicker(giftItem)) {
          label.textContent = '';
          label.hidden = true;
        } else if (variant) {
          label.textContent = variant.title || '';
          label.hidden = false;
          label.classList.remove('is-missing');
        } else {
          label.textContent = '';
          label.hidden = true;
          label.classList.add('is-missing');
        }
      }

      if (image) {
        const nextImage = this._getGiftVariantImage(variant, giftItem);
        if (nextImage) {
          image.src = nextImage;
          image.removeAttribute('srcset');
        }
      }

      if (pickLink) {
        pickLink.classList.toggle('is-selected', Boolean(variant));
      }
    }

    _getGiftVariantImage(variant, item) {
      if (this._isGiftDeclineVariant(variant)) {
        return variant?.image || item?.fallbackImage || null;
      }
      if (variant?.image) return variant.image;
      return item?.fallbackImage || null;
    }

    _getGiftOptionPosition(option, optionIndex) {
      return option.position || optionIndex + 1;
    }

    _findGiftVariantByOptionValue(item, optionPosition, value) {
      return item.variants?.find((variant) => variant[`option${optionPosition}`] === value) || null;
    }

    _getInitialGiftPickerSelections(item, selectedVariant) {
      const initialSelections = {};
      if (selectedVariant) {
        item.options.forEach((option, optionIndex) => {
          const position = this._getGiftOptionPosition(option, optionIndex);
          initialSelections[`option${position}`] = selectedVariant[`option${position}`];
        });
        return initialSelections;
      }
      const firstAvailable = item.variants?.find((variant) => variant.available) || item.variants?.[0];
      item.options.forEach((option, optionIndex) => {
        const position = this._getGiftOptionPosition(option, optionIndex);
        initialSelections[`option${position}`] = firstAvailable?.[`option${position}`];
      });
      return initialSelections;
    }

    _createGiftPickerImage(src, alt, className) {
      if (!src) return null;
      const image = document.createElement('img');
      image.src = src;
      image.alt = alt || '';
      image.loading = 'lazy';
      image.width = 100;
      image.height = 100;
      image.className = className;
      return image;
    }

    _createGiftPickerVariantTile(slot, item, variant, optionPosition, checked) {
      const value = variant[`option${optionPosition}`];
      const label = document.createElement('label');
      label.className = 'bk-media-gift-picker__variant';
      if (!variant.available) label.classList.add('is-unavailable');
      if (checked) label.classList.add('is-selected');

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `gift-${slot}-option-${optionPosition}`;
      input.value = value;
      input.checked = checked;
      input.disabled = !variant.available;
      input.addEventListener('change', () => this._syncActivePickerState(slot));
      label.addEventListener('click', () => {
        requestAnimationFrame(() => this._syncActivePickerState(slot));
      });

      const image = this._createGiftPickerImage(
        this._getGiftVariantImage(variant, item),
        value,
        'bk-media-gift-picker__variant-image'
      );

      const text = document.createElement('span');
      text.className = 'text-xs';
      text.textContent = value;

      label.appendChild(input);
      if (image) label.appendChild(image);
      label.appendChild(text);
      return label;
    }

    _createGiftPickerValueOption(slot, item, optionPosition, value, checked) {
      const variant = this._findGiftVariantByOptionValue(item, optionPosition, value);
      const label = document.createElement('label');
      label.className = 'bk-media-gift-picker__value h-stack gap-2 align-center';
      if (variant && !variant.available) label.classList.add('is-unavailable');
      if (checked) label.classList.add('is-selected');

      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `gift-${slot}-option-${optionPosition}`;
      input.value = value;
      input.checked = checked;
      input.disabled = variant ? !variant.available : false;
      input.addEventListener('change', () => this._syncActivePickerState(slot));
      label.addEventListener('click', () => {
        requestAnimationFrame(() => this._syncActivePickerState(slot));
      });

      const image = this._createGiftPickerImage(
        this._getGiftVariantImage(variant, item),
        value,
        'bk-media-gift-picker__value-image'
      );

      const text = document.createElement('span');
      text.className = 'text-sm';
      text.textContent = value;

      label.appendChild(input);
      if (image) label.appendChild(image);
      label.appendChild(text);
      return label;
    }

    _renderGiftPickerOptions(slot, item, initialSelections, wrapper) {
      item.options.forEach((option, optionIndex) => {
        const position = this._getGiftOptionPosition(option, optionIndex);
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'bk-media-gift-picker__option v-stack gap-2';
        fieldset.setAttribute('data-gift-option-position', String(position));

        const legend = document.createElement('legend');
        legend.className = 'text-sm bold';
        legend.textContent = option.name;
        fieldset.appendChild(legend);

        const valuesWrap = document.createElement('div');
        const useVariantGrid = item.options.length === 1 && item.variants?.length > 1;
        valuesWrap.className = useVariantGrid
          ? 'bk-media-gift-picker__variants'
          : 'bk-media-gift-picker__values v-stack gap-2';

        if (useVariantGrid) {
          item.variants.forEach((variant) => {
            const value = variant[`option${position}`];
            valuesWrap.appendChild(
              this._createGiftPickerVariantTile(
                slot,
                item,
                variant,
                position,
                initialSelections[`option${position}`] === value
              )
            );
          });
        } else {
          (option.values || []).forEach((value) => {
            valuesWrap.appendChild(
              this._createGiftPickerValueOption(
                slot,
                item,
                position,
                value,
                initialSelections[`option${position}`] === value
              )
            );
          });
        }

        fieldset.appendChild(valuesWrap);
        wrapper.appendChild(fieldset);
      });
    }

    _getGiftPickerSelections(slot, item, root) {
      const container = root || this.giftDrawerContent;
      const selections = {};
      item.options.forEach((option, optionIndex) => {
        const position = option.position || optionIndex + 1;
        const checked = container?.querySelector(
          `input[name="gift-${slot}-option-${position}"]:checked`
        );
        if (checked) selections[`option${position}`] = checked.value;
      });
      return selections;
    }

    _syncActivePickerState(slot) {
      if (this._activePickerContext === 'colors') {
        this._syncColorsDrawerState();
        return;
      }
      this._syncGiftPickerState(slot);
    }

    _syncGiftPickerState(slot) {
      const item = this._getGiftItem(slot);
      if (!item || !this.giftDrawerContent) return;

      const selections = this._getGiftPickerSelections(slot, item, this.giftDrawerContent);
      const allSelected = item.options.every((option, optionIndex) => {
        const position = option.position || optionIndex + 1;
        return Boolean(selections[`option${position}`]);
      });
      const variant = allSelected ? this._findGiftVariant(item, selections) : null;
      const status = this.giftPickerStatus;
      const confirm = this.giftPickerConfirm;

      if (status) {
        if (!allSelected || (variant && variant.available)) {
          status.textContent = '';
        } else if (!variant) {
          status.textContent = 'Diese Kombination ist nicht verfügbar.';
        } else if (!variant.available) {
          status.textContent = 'Diese Variante ist ausverkauft.';
        }
      }

      if (confirm) {
        confirm.disabled = !variant || !variant.available;
      }

      this.giftDrawerContent?.querySelectorAll('.bk-media-gift-picker__variant, .bk-media-gift-picker__value').forEach((label) => {
        const input = label.querySelector('input[type="radio"]');
        label.classList.toggle('is-selected', Boolean(input?.checked));
      });
    }

    _confirmGiftPicker(slot) {
      const item = this._getGiftItem(slot);
      if (!item) return;
      const selections = this._getGiftPickerSelections(slot, item);
      const variant = this._findGiftVariant(item, selections);
      if (!variant || !variant.available) return;

      this.giftSelections[slot] = variant.id;
      this._updateGiftCardUi(slot, variant, item);
      this._closeGiftModal();
      this._updateColorsSlotUi();
      this._updateUi();
      this._updateDrawerPricing();
    }

    _allGiftsSelected() {
      return this._getApplicableGiftItems().every((item) => {
        if (this._isGiftSoldOut(item) || this._usesGiftOptInDrawer(item)) {
          return true;
        }
        if (!this._giftNeedsVariantPicker(item)) {
          return Boolean(this._getAutoGiftVariant(item)?.available);
        }
        return Boolean(this.giftSelections[item.slot]);
      });
    }

    _changeDrawerQty(variantId, delta) {
      const isGratisExtra = this.drawerMode === 'gratis-extra';
      const isPromoGifts = this.drawerMode === 'promo-gifts';
      const required = isGratisExtra ? 1 : isPromoGifts ? this.promoGiftsCount : this._getRequiredQty();
      const maxQty = isGratisExtra ? 1 : isPromoGifts ? this.promoGiftsCount : this._getMaxSelectableQty();
      const current = this._getDrawerTotalQty();
      const id = String(variantId);
      const product = this._getActiveDrawerProducts().find((entry) => String(entry.variant_id) === id);
      if (delta > 0 && !this._isProductAvailable(product)) return;
      if (isGratisExtra && delta > 0 && current >= 1) {
        this.drawerQuantities = {};
      }
      const next = (this.drawerQuantities[id] || 0) + delta;
      if (delta > 0 && current >= maxQty) return;
      if (next < 0) return;
      if (next === 0) {
        delete this.drawerQuantities[id];
      } else {
        this.drawerQuantities[id] = next;
      }
      if (this.optionalExtraSlot) {
        this._checkOptionalKitSync();
      }
      this._syncDrawerQtyDisplay();
      this._updateDrawerPricing();
      this._updateKitRowPricing();
      this._updateKitRowSwitchability();
      if (this.flexibleSelection) {
        this._checkFlexibleUpgrade();
        this._updateFlexibleProgressBanner();
      } else if (this.optionalExtraSlot) {
        this._updateOptionalProgressBanner();
      }
    }

    _syncDrawerQtyDisplay() {
      const isGratisExtra = this.drawerMode === 'gratis-extra';
      const isPromoGifts = this.drawerMode === 'promo-gifts';
      const isFixedGiftDrawer = isGratisExtra || isPromoGifts;
      const required = isGratisExtra ? 1 : isPromoGifts ? this.promoGiftsCount : this._getRequiredQty();
      const total = isFixedGiftDrawer ? this._getDrawerTotalQty() : this._getEffectiveSelectionCount();
      const maxQty = isGratisExtra ? 1 : isPromoGifts ? this.promoGiftsCount : this._getMaxSelectableQty();
      const isComplete = isFixedGiftDrawer
        ? total === required
        : this._hasOptionalExtraSlots()
          ? total >= required
          : total === required;
      const celebrationCtx = this._getRecipeCelebrationContext();

      if (!isFixedGiftDrawer) {
        const previousTotal = this._drawerLastTotal ?? this._flexibleLastSelectionCount ?? 0;
        this._maybeTriggerVolumeBestpriceCelebration(previousTotal, total);
        this._flexibleLastSelectionCount = total;

        if (this._shouldTriggerCurrentGoalCelebration(total, previousTotal, required)) {
          celebrationCtx.message = this._getGoalCelebrationMessage(total, required);
          this._triggerCelebration(celebrationCtx);
        } else if (this._shouldClearGoalCelebration(total, required)) {
          this._clearCelebration(celebrationCtx);
        }
      }

      this._drawerLastTotal = total;

      this.drawerList?.querySelectorAll('[data-drawer-item]').forEach((item) => {
        const id = item.getAttribute('data-variant-id');
        const val = this.drawerQuantities[id] || 0;
        const input = item.querySelector('[data-qty-value]');
        if (input) {
          input.value = String(val);
          input.size = Math.max(String(val).length + 1, 2);
        }
        const minusBtn = item.querySelector('[data-qty-minus]');
        const plusBtn = item.querySelector('[data-qty-plus]');
        const isUnavailable = item.getAttribute('data-available') === 'false';
        if (minusBtn) minusBtn.disabled = val <= 0;
        if (plusBtn) plusBtn.disabled = isUnavailable || total >= maxQty;
        item.classList.toggle('is-selected', val > 0);
      });
      if (this.drawerConfirmTitle && this.drawerConfirmCount) {
        if (isComplete) {
          this.drawerConfirmTitle.hidden = true;
          this.drawerConfirmCount.hidden = false;
          this.drawerConfirmCount.textContent = `🎉 Auswählen (${total})`;
          this.drawerConfirmCount.classList.add('bold');
          this.drawerConfirmCount.classList.remove('text-subdued');
        } else {
          this.drawerConfirmTitle.hidden = false;
          this.drawerConfirmCount.hidden = false;
          this.drawerConfirmTitle.textContent = this._drawerConfirmDefaultTitle;
          this.drawerConfirmTitle.classList.add('bold');
          this.drawerConfirmCount.classList.remove('bold');
          this.drawerConfirmCount.classList.add('text-subdued');
          this.drawerConfirmCount.textContent = `${total}/${required} ausgewählt`;
        }
      }
      if (this.drawerConfirm) {
        this.drawerConfirm.disabled = !isComplete;
      }

      if (isFixedGiftDrawer) return;

      if (this.flexibleSelection) {
        this._updateFlexibleProgressBanner();
      } else if (this.optionalExtraSlot) {
        this._updateOptionalProgressBanner();
      }
    }

    _positionDrawerCelebration(celebration, confirm) {
      if (!celebration || !confirm) return;
      const footer = celebration.parentElement;
      if (!footer) return;
      const footerRect = footer.getBoundingClientRect();
      const btnRect = confirm.getBoundingClientRect();
      const x = btnRect.left + btnRect.width / 2 - footerRect.left;
      const y = btnRect.top + btnRect.height / 2 - footerRect.top;
      celebration.style.left = `${x}px`;
      celebration.style.top = `${y}px`;
    }

    _spawnConfettiBurst(celebration, drawer) {
      if (!celebration) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      const accent =
        getComputedStyle(drawer || this).getPropertyValue('--bb-accent').trim() || '#E8614D';
      const colors = [accent, '#2d7a2d', '#F5A623', '#FFD54F', '#9B59B6', '#81D4FA', '#E91E8C'];
      const fragment = document.createDocumentFragment();

      for (let i = 0; i < 64; i++) {
        const angle = Math.random() * Math.PI * 2;
        const velocity = 55 + Math.random() * 95;
        const burstX = Math.round(Math.cos(angle) * velocity);
        const burstY = Math.round(Math.sin(angle) * velocity - 25);
        const size = 6 + Math.random() * 6;
        const piece = document.createElement('span');
        piece.className = 'bk-media-bundle-builder__drawer-confetti-piece';
        piece.style.setProperty('--burst-x', `${burstX}px`);
        piece.style.setProperty('--burst-y', `${burstY}px`);
        piece.style.setProperty('--burst-rotate', `${Math.round(Math.random() * 540 - 270)}deg`);
        piece.style.setProperty('--burst-delay', `${Math.random() * 0.08}s`);
        piece.style.width = `${size}px`;
        piece.style.height = `${size}px`;
        piece.style.background = colors[Math.floor(Math.random() * colors.length)];
        piece.style.borderRadius = Math.random() > 0.45 ? '50%' : '2px';
        fragment.appendChild(piece);
      }

      celebration.appendChild(fragment);
    }

    _triggerCelebration(ctx) {
      const { celebration, confirm, drawer, timeoutKey, goalToastTimeoutKey, goalToast, message } =
        ctx;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const isBestpriceGoal = this._isBestpriceGoalMessage(message);

      if (goalToast && message) {
        goalToast.textContent = message;
        goalToast.hidden = false;
        goalToast.classList.add('is-visible');
        goalToast.classList.toggle('is-bestprice-goal', isBestpriceGoal);
      }

      if (celebration) {
        celebration.innerHTML = '';
        celebration.setAttribute('aria-hidden', 'false');
        celebration.classList.add('is-active');
        this._positionDrawerCelebration(celebration, confirm);
        if (!reducedMotion) {
          requestAnimationFrame(() => {
            this._positionDrawerCelebration(celebration, confirm);
            this._spawnConfettiBurst(celebration, drawer);
          });
        }
      }

      clearTimeout(this[timeoutKey]);
      this[timeoutKey] = setTimeout(() => {
        if (celebration) {
          celebration.classList.remove('is-active');
          celebration.setAttribute('aria-hidden', 'true');
          celebration.innerHTML = '';
        }
      }, 1500);

      if (goalToast && message && goalToastTimeoutKey) {
        clearTimeout(this[goalToastTimeoutKey]);
        const toastDuration = this._getGoalToastDuration(message);
        this[goalToastTimeoutKey] = setTimeout(() => {
          this[goalToastTimeoutKey] = null;
          if (goalToast) {
            goalToast.classList.remove('is-visible', 'is-bestprice-goal');
            goalToast.hidden = true;
            goalToast.textContent = '';
          }
          this._syncAtcGoalToast();
        }, toastDuration);
      }
    }

    _clearCelebration(ctx) {
      const { celebration, timeoutKey, goalToastTimeoutKey, goalToast } = ctx;

      clearTimeout(this[timeoutKey]);
      this[timeoutKey] = null;
      if (goalToastTimeoutKey) {
        clearTimeout(this[goalToastTimeoutKey]);
        this[goalToastTimeoutKey] = null;
      }

      if (goalToast) {
        goalToast.classList.remove('is-visible', 'is-bestprice-goal');
        goalToast.hidden = true;
        goalToast.textContent = '';
      }

      if (celebration) {
        celebration.classList.remove('is-active');
        celebration.setAttribute('aria-hidden', 'true');
        celebration.innerHTML = '';
      }
    }

    _syncAtcGoalToast() {
      const ctx = this._getAtcCelebrationContext();
      const { goalToast } = ctx;
      if (!goalToast) return;

      if (!this._isComplete()) {
        this._clearCelebration(ctx);
        return;
      }

      if (this._atcGoalToastTimeout) return;

      goalToast.textContent = this.atcSuccessMessage;
      goalToast.hidden = false;
      goalToast.classList.add('is-visible');
      goalToast.classList.remove('is-bestprice-goal');
    }

    _getPresetForRow(row) {
      if (!row) return null;
      const kitValue = row.getAttribute('data-kit-value');
      const presetIndex = parseInt(row.getAttribute('data-preset-index'), 10);
      return (
        this.presets.find((preset) => preset.kitValue === kitValue) ||
        (presetIndex ? this.presets.find((preset) => preset.presetIndex === presetIndex) : null)
      );
    }

    _getKitVariantForRow(row) {
      const variantId = row?.getAttribute('data-variant-id');
      if (!variantId) return null;
      return this.variants.find((variant) => String(variant.id) === variantId) || null;
    }

    _usesParentKitProduct() {
      return Boolean(this.getAttribute('data-parent-product-id'));
    }

    _setKitRowVariantAttributes(row, variant, fallbackPrice) {
      if (!row || !variant) return;
      row.setAttribute('data-variant-id', String(variant.id));
      if (this._usesParentKitProduct()) return;

      const price = parseInt(variant.price, 10) || 0;
      row.setAttribute('data-variant-price', String(price));
      const compare = parseInt(variant.compare_at_price, 10) || 0;
      row.setAttribute(
        'data-variant-compare-at',
        String(compare > price ? compare : price)
      );
    }

    _getParentKitPricing(kitValue, presetIndex) {
      const index = presetIndex || this._getPresetIndexForKitValue(kitValue);
      if (index && this.parentVariantMap?.priceByPresetIndex?.[index]) {
        return this.parentVariantMap.priceByPresetIndex[index];
      }
      if (!kitValue || !this.parentVariantMap?.priceByKitValue) return null;
      return this.parentVariantMap.priceByKitValue[kitValue] || null;
    }

    _getPresetCustomPriceCents(presetIndex) {
      const preset = this.presets.find((entry) => entry.presetIndex === presetIndex);
      return parseInt(preset?.customPriceCents, 10) || 0;
    }

    _resolveParentKitPriceCents(row, kitValue) {
      if (row?.hasAttribute('data-one-time')) {
        const oneTimePrice = parseInt(row.getAttribute('data-variant-price'), 10);
        if (!Number.isNaN(oneTimePrice) && oneTimePrice >= 0) return oneTimePrice;
      }

      const presetIndex = parseInt(row?.getAttribute('data-preset-index'), 10) || null;
      const customPrice = this._getPresetCustomPriceCents(presetIndex);
      if (customPrice > 0) return customPrice;

      const parentPricing = this._getParentKitPricing(kitValue, presetIndex);
      if (parentPricing != null && Number.isFinite(parentPricing.price) && parentPricing.price > 0) {
        return parentPricing.price;
      }

      const fromAttr = parseInt(row?.getAttribute('data-variant-price'), 10);
      if (!Number.isNaN(fromAttr) && fromAttr >= 0) {
        return fromAttr;
      }

      return 0;
    }

    _resolveParentKitCompareCents(row, kitValue, kitPrice) {
      const price = Number.isFinite(kitPrice) ? kitPrice : 0;
      const presetIndex = parseInt(row?.getAttribute('data-preset-index'), 10) || null;
      const parentPricing = this._getParentKitPricing(kitValue, presetIndex);
      if (parentPricing != null) {
        const parentPrice = Number.isFinite(parentPricing.price) ? parentPricing.price : 0;
        const parentCompareAt = Number.isFinite(parentPricing.compareAtPrice)
          ? parentPricing.compareAtPrice
          : 0;
        if (parentCompareAt > parentPrice) {
          return parentCompareAt;
        }
        return 0;
      }

      const fromAttr = parseInt(row?.getAttribute('data-variant-compare-at'), 10);
      if (!Number.isNaN(fromAttr) && fromAttr > price) {
        return fromAttr;
      }

      return 0;
    }

    _getKitVariantCents(row) {
      const kitValue = row?.getAttribute('data-kit-value');
      if (this._usesParentKitProduct()) {
        return this._resolveParentKitPriceCents(row, kitValue);
      }

      const fromAttr = parseInt(row?.getAttribute('data-variant-price'), 10);
      if (!Number.isNaN(fromAttr) && fromAttr >= 0) {
        return fromAttr;
      }
      const variant = this._getKitVariantForRow(row);
      if (variant && Number.isFinite(parseInt(variant.price, 10))) {
        return parseInt(variant.price, 10) || 0;
      }
      return 0;
    }

    _getKitVariantCompareCents(row) {
      const kitValue = row?.getAttribute('data-kit-value');
      const price = this._getKitVariantCents(row);
      if (this._usesParentKitProduct()) {
        return this._resolveParentKitCompareCents(row, kitValue, price);
      }

      const fromAttr = parseInt(row?.getAttribute('data-variant-compare-at'), 10);
      if (!Number.isNaN(fromAttr) && fromAttr > price) {
        return fromAttr;
      }

      const variant = this._getKitVariantForRow(row);
      if (!variant) return 0;
      const compare = parseInt(variant.compare_at_price, 10) || 0;
      return compare > price ? compare : 0;
    }

    _getVariantPricingProductCompareCents(qty, kitPrice, kitCompareCents) {
      let productCompare = 0;
      if (this.defaultUnitPrice > 0 && qty > 0) {
        productCompare = this.defaultUnitPrice * qty;
      }
      const kitCompareAt = kitCompareCents > kitPrice ? kitCompareCents : 0;
      if (kitCompareAt > productCompare) {
        productCompare = kitCompareAt;
      }
      return productCompare;
    }

    _getVariantPricingOrderDiscountCompare(qty, discountPercent) {
      const discount = this._parseDiscountPercent(discountPercent);
      if (discount <= 0 || this.defaultUnitPrice <= 0 || qty <= 0) return 0;
      return this.defaultUnitPrice * qty;
    }

    _usesParentKitCompareRules() {
      return this.variantPricingOnly || this._usesParentKitProduct();
    }

    _getBundleListCompareCents(qty, discountPercent, presetIndex, finalTotal = 0) {
      const extrasCompare = this._getCompareExtrasCents(qty, presetIndex);
      const orderDiscountCompare = this._getVariantPricingOrderDiscountCompare(qty, discountPercent);

      if (orderDiscountCompare > 0) {
        return orderDiscountCompare + extrasCompare;
      }

      return Math.max(0, finalTotal) + extrasCompare;
    }

    _applyCustomPresetCompareToPricing(pricing, presetIndex) {
      if (!this.enableCustomPresetComparePrices || !pricing) return pricing;

      const preset = this.presets.find((entry) => entry.presetIndex === presetIndex);
      const customCompare = preset?.customCompareCents || 0;
      if (customCompare <= pricing.finalTotal) return pricing;

      const compareTotal = customCompare;
      return {
        ...pricing,
        compareTotal,
        savings: Math.max(0, compareTotal - pricing.finalTotal)
      };
    }

    _finalizePresetPricing(result, qty, discountPercent, presetIndex) {
      let finalized = result;
      if (this._usesParentKitCompareRules()) {
        const compareTotal = this._getBundleListCompareCents(
          qty,
          discountPercent,
          presetIndex,
          result.finalTotal
        );
        finalized = {
          ...result,
          compareTotal,
          savings: Math.max(0, compareTotal - result.finalTotal)
        };
      }
      finalized = this._applyCustomPresetCompareToPricing(finalized, presetIndex);

      const customPrice = this._getPresetCustomPriceCents(presetIndex);
      if (customPrice > 0) {
        finalized = {
          ...finalized,
          finalTotal: customPrice
        };
        finalized = this._applyCustomPresetCompareToPricing(finalized, presetIndex);
        finalized = {
          ...finalized,
          finalTotal: customPrice,
          savings: Math.max(0, (finalized.compareTotal || 0) - customPrice)
        };
      }

      return finalized;
    }

    _getAuthoritativeCartPricing(row, preset) {
      const pricing = this._getKitRowPricing(row, preset);
      return {
        finalTotal: pricing.finalTotal,
        compareTotal: pricing.compareTotal,
        savings: Math.max(0, pricing.compareTotal - pricing.finalTotal)
      };
    }

    _resolveAuthoritativeListCompare(cartPricing, preset) {
      const finalTotal = Math.round(cartPricing.finalTotal);
      if (finalTotal <= 0) {
        return { compare: 0, final: 0, customCompare: 0 };
      }

      let compareTotal = Math.round(cartPricing.compareTotal);
      let customCompare = 0;

      if (this.enableCustomPresetComparePrices && preset) {
        customCompare = preset.customCompareCents || 0;
        if (customCompare > finalTotal) {
          compareTotal = customCompare;
        }
      }

      const compare = compareTotal > finalTotal ? compareTotal : 0;
      return {
        compare,
        final: finalTotal,
        customCompare: customCompare > finalTotal ? customCompare : 0
      };
    }

    _syncKitRowPricingAttributes(row, pricing) {
      if (!row || !pricing) return;
      row.setAttribute('data-computed-price', String(Math.round(pricing.finalTotal)));
      if (pricing.compareTotal > pricing.finalTotal) {
        row.setAttribute('data-computed-compare', String(Math.round(pricing.compareTotal)));
      } else {
        row.removeAttribute('data-computed-compare');
      }
    }

    _getRowComputedPriceCents(row) {
      const computed = parseInt(row?.getAttribute('data-computed-price'), 10);
      return !Number.isNaN(computed) && computed > 0 ? computed : 0;
    }

    _getProductCompareCents(product) {
      if (!product) return 0;
      const compare = parseInt(product.compare_at_price, 10) || 0;
      const price = parseInt(product.price, 10) || 0;
      return compare > price ? compare : price;
    }

    _sumCardAmountsFromQuantities(quantities, targetQty, mode) {
      const qty = targetQty || 0;
      if (!qty) return 0;

      let selectedTotal = 0;
      let totalCount = 0;

      Object.entries(quantities || {}).forEach(([variantId, count]) => {
        const product = this.products.find((p) => String(p.variant_id) === variantId);
        if (!product || !count) return;
        const amount =
          mode === 'compare' ? this._getProductCompareCents(product) : parseInt(product.price, 10) || 0;
        selectedTotal += amount * count;
        totalCount += count;
      });

      const remaining = Math.max(0, qty - totalCount);
      const defaultPerSlot = this.defaultUnitPrice;

      if (totalCount === 0) {
        return defaultPerSlot * qty;
      }

      return selectedTotal + defaultPerSlot * remaining;
    }

    _getGiftVariantPriceCents(item, variant) {
      if (!item) return 0;
      const resolvedVariant =
        variant || this._getSelectedGiftVariant(item.slot) || item.variants?.[0];
      if (!resolvedVariant) return 0;
      return parseInt(resolvedVariant.price, 10) || 0;
    }

    _getIncludedBundleGiftCents(quantity, presetIndex) {
      if (!this.includePaidGiftsInBundle) return 0;
      return this._getGiftPriceCentsForQuantity(quantity, presetIndex);
    }

    _sumGiftAmountsForQuantity(quantity, presetIndex, amountFn) {
      const qty = quantity || 0;
      if (!qty) return 0;

      const pricingPresetIndex =
        (presetIndex ?? parseInt(this.activePreset?.presetIndex, 10)) || 1;
      if (this._presetHasNoGifts(pricingPresetIndex)) return 0;
      if (this.flexibleSelection && this._presetHasVolumeDiscount(pricingPresetIndex)) return 0;

      const addItemAmount = (item, variant) => {
        if (!item || !this._shouldIncludeGiftCompareInTotals(item)) {
          return 0;
        }
        return amountFn(item, variant) * this._getGiftLineQuantity(item, pricingPresetIndex);
      };

      if (this.giftMode === 'single_always') {
        const gift1 = this._getGiftItem(1);
        if (!gift1) return 0;
        const selected = this._getSelectedGiftVariant(1);
        if (selected) return addItemAmount(gift1, selected);
        if (this._usesGiftOptInDrawer(gift1) || this.giftOptional) return 0;
        return addItemAmount(gift1, gift1.variants?.[0]);
      }

      const minQty = parseInt(this.giftPricing?.minQuantity, 10) || 4;
      const topQty = this._getTopPresetQuantity();
      let total = 0;

      if (qty >= minQty) {
        this._getGiftItems()
          .filter((item) => !this._isGiftProfiKitOnly(item))
          .forEach((item) => {
            const selected = this._getSelectedGiftVariant(item.slot);
            if (selected) {
              total += addItemAmount(item, selected);
            } else if (this._usesGiftOptInDrawer(item)) {
              return;
            } else {
              total += addItemAmount(item, item.variants?.[0]);
            }
          });
      }

      if (qty >= topQty) {
        const gift2 = this._getGiftItem(2);
        if (gift2 && this._isGiftProfiKitOnly(gift2)) {
          const selected2 = this._getSelectedGiftVariant(2);
          total += addItemAmount(gift2, selected2 || gift2.variants?.[0]);
        }

        const gift3 = this._getGiftItem(3);
        if (gift3 && this._isGiftProfiKitOnly(gift3)) {
          const selected3 = this._getSelectedGiftVariant(3);
          total += addItemAmount(gift3, selected3 || gift3.variants?.[0]);
        }
      }

      return total;
    }

    _getGiftCompareForQuantity(quantity, presetIndex) {
      return this._sumGiftAmountsForQuantity(quantity, presetIndex, (item, variant) =>
        this._getGiftSavingsCentsFromItem(item, variant)
      );
    }

    _getGiftPriceCentsForQuantity(quantity, presetIndex) {
      return this._sumGiftAmountsForQuantity(quantity, presetIndex, (item, variant) =>
        this._getGiftVariantPriceCents(item, variant)
      );
    }

    _getPaidGiftSurchargeCents(quantity, presetIndex) {
      if (this.includePaidGiftsInBundle) return 0;
      const qty = quantity || 0;
      if (!qty) return 0;
      const pricingPresetIndex =
        (presetIndex ?? parseInt(this.activePreset?.presetIndex, 10)) || 1;
      if (this._presetHasNoGifts(pricingPresetIndex)) return 0;
      if (this.flexibleSelection && this._presetHasVolumeDiscount(pricingPresetIndex)) return 0;

      return this._getApplicableGiftItems().reduce((sum, item) => {
        if (this._isGiftSoldOut(item)) return sum;
        const selected = this._getSelectedGiftVariant(item.slot);
        if (!selected) return sum;
        return sum + (parseInt(selected.price, 10) || 0);
      }, 0);
    }

    _withPaidGiftSurcharge(pricing, quantity, presetIndex) {
      const surcharge = this._getPaidGiftSurchargeCents(quantity, presetIndex);
      if (!surcharge || !pricing) return pricing;
      const finalTotal = (pricing.finalTotal || 0) + surcharge;
      const compareTotal = (pricing.compareTotal || 0) + surcharge;
      return {
        ...pricing,
        finalTotal,
        compareTotal,
        savings: Math.max(0, compareTotal - finalTotal)
      };
    }

    _calcPresetPricing(
      quantity,
      discountPercent,
      quantities,
      kitVariantCents,
      kitCompareCents,
      presetIndex
    ) {
      const qty = quantity || 0;
      const discount = discountPercent ?? this.activePreset?.discountPercent ?? 0;
      const qtyMap = quantities || this.drawerQuantities || {};
      const kitPrice = kitVariantCents || 0;
      const kitCompareAt = kitCompareCents > kitPrice ? kitCompareCents : 0;
      let kitCompare = kitCompareAt;
      if (!this.variantPricingOnly && !this._usesParentKitProduct() && kitCompareAt === 0) {
        kitCompare = kitPrice;
      }
      const pricingPresetIndex =
        (presetIndex ?? parseInt(this.activePreset?.presetIndex, 10)) || 1;

      if (this.variantPricingOnly) {
        const extrasCompare = this._getCompareExtrasCents(qty, pricingPresetIndex);
        let finalTotal = kitPrice;

        if (this.defaultUnitPrice > 0 && qty > 0 && this.useKitIndexAsQuantity) {
          const cardsSubtotal = this.defaultUnitPrice * qty;
          const effectiveDiscount = this._resolveVariantPricingDiscount(qty, discount);
          finalTotal = this._applyScaledSubtotalDiscount(cardsSubtotal, effectiveDiscount);
        } else if (finalTotal <= 0 && this.defaultUnitPrice > 0 && qty > 0) {
          const cardsSubtotal = this.defaultUnitPrice * qty;
          const effectiveDiscount = this._resolveVariantPricingDiscount(qty, discount);
          finalTotal = this._applyScaledSubtotalDiscount(cardsSubtotal, effectiveDiscount);
        }

        const productCompare = this._getVariantPricingProductCompareCents(
          qty,
          kitPrice,
          kitCompareCents
        );
        const compareTotal = productCompare + extrasCompare;
        const savings = Math.max(0, compareTotal - finalTotal);
        return this._finalizePresetPricing(
          { finalTotal, compareTotal, savings, discountPercent: discount },
          qty,
          discount,
          pricingPresetIndex
        );
      }

      if (this.useKitIndexAsQuantity && this.defaultUnitPrice > 0 && qty > 0) {
        const cardsSubtotal = this.defaultUnitPrice * qty;
        const finalTotal = this._applyCardsOrderDiscount(this.defaultUnitPrice, qty, discount);
        const giftCompare = this._getCardsOnlyGiftCompare(qty);
        const compareTotal =
          cardsSubtotal + giftCompare + this._getGratisExtraCompareCents(pricingPresetIndex);
        const savings = Math.max(0, compareTotal - finalTotal);
        return this._finalizePresetPricing(
          { finalTotal, compareTotal, savings, discountPercent: discount },
          qty,
          discount,
          pricingPresetIndex
        );
      }

      if (
        this.flexibleSelection &&
        !this._presetHasVolumeDiscount(pricingPresetIndex) &&
        this.defaultUnitPrice > 0 &&
        qty > 0
      ) {
        const cardPriceSum = this._sumCardAmountsFromQuantities(qtyMap, qty, 'price');
        const cardsCompareSum = this._sumCardAmountsFromQuantities(qtyMap, qty, 'compare');
        const extrasCompare = this._getCompareExtrasCents(qty, pricingPresetIndex);
        const presetDiscount = this._parseDiscountPercent(
          this.presets.find((entry) => entry.presetIndex === pricingPresetIndex)?.discountPercent
        );
        let finalTotal;
        if (pricingPresetIndex === 1) {
          finalTotal = kitPrice + cardPriceSum;
        } else if (presetDiscount > 0) {
          finalTotal = this._applyBundleDiscount(cardPriceSum, presetDiscount);
        } else {
          finalTotal = kitPrice + cardPriceSum;
        }
        const compareTotal = kitPrice + cardsCompareSum + extrasCompare;
        const savings = Math.max(0, compareTotal - finalTotal);
        return this._finalizePresetPricing(
          { finalTotal, compareTotal, savings, discountPercent: presetDiscount },
          qty,
          presetDiscount,
          pricingPresetIndex
        );
      }

      if (
        this.flexibleSelection &&
        this._presetHasVolumeDiscount(pricingPresetIndex) &&
        this.defaultUnitPrice > 0 &&
        qty > 0
      ) {
        const cardPriceSum = this._sumCardAmountsFromQuantities(qtyMap, qty, 'price');
        const estimatedCardSubtotal = this.defaultUnitPrice * qty;
        const cardsSubtotal = cardPriceSum > 0 ? cardPriceSum : estimatedCardSubtotal;
        const extrasCompare = this._getCompareExtrasCents(qty, pricingPresetIndex);
        const compareTotal = cardsSubtotal + extrasCompare;
        const finalTotal = kitPrice + this._applyScaledSubtotalDiscount(cardsSubtotal, discount);
        const savings = Math.max(0, compareTotal - finalTotal);
        return this._finalizePresetPricing(
          { finalTotal, compareTotal, savings, discountPercent: discount },
          qty,
          discount,
          pricingPresetIndex
        );
      }

      if (this.defaultUnitPrice > 0 && qty > 0) {
        const baseSubtotal = this.defaultUnitPrice * qty;
        const cardPriceSum = this._sumCardAmountsFromQuantities(qtyMap, qty, 'price');
        const extrasCompare = this._getCompareExtrasCents(qty, pricingPresetIndex);
        const includedGiftCents = this._getIncludedBundleGiftCents(qty, pricingPresetIndex);
        const bundleBase = baseSubtotal + kitPrice + includedGiftCents;
        const bundleDiscounted = this._applyBundleDiscount(bundleBase, discount);
        const finalTotal = bundleDiscounted + (cardPriceSum - baseSubtotal);
        const compareTotal = kitPrice + baseSubtotal + extrasCompare;
        const savings = Math.max(0, compareTotal - finalTotal);
        return this._finalizePresetPricing(
          { finalTotal, compareTotal, savings, discountPercent: discount },
          qty,
          discount,
          pricingPresetIndex
        );
      }

      let subtotal = 0;
      let compareTotal = kitCompare;
      Object.entries(qtyMap).forEach(([variantId, count]) => {
        const product = this.products.find((p) => String(p.variant_id) === variantId);
        if (!product) return;
        subtotal += product.price * count;
        const compare =
          product.compare_at_price > product.price ? product.compare_at_price : product.price;
        compareTotal += compare * count;
      });
      const extrasCompare = this._getCompareExtrasCents(qty, pricingPresetIndex);
      compareTotal += extrasCompare;
      const includedGiftCents = this._getIncludedBundleGiftCents(qty, pricingPresetIndex);
      const bundleBase = subtotal + kitPrice + includedGiftCents;
      const finalTotal = this._applyBundleDiscount(bundleBase, discount);
      const savings = Math.max(0, compareTotal - finalTotal);
      return this._finalizePresetPricing(
        { finalTotal, compareTotal, savings, discountPercent: discount },
        qty,
        discount,
        pricingPresetIndex
      );
    }

    _getKitRowPricingQtyAndDiscount(row, preset, isSelected) {
      const presetIndex = parseInt(preset.presetIndex, 10);
      let pricingQty = this._getPresetPricingQuantity(preset);
      let discount = preset.discountPercent;

      if (this.flexibleSelection && isSelected) {
        if (this._presetHasVolumeDiscount(presetIndex)) {
          pricingQty = this._getPricingQuantity();
          discount = this._getActiveDiscountPercent();
        } else if (this._flexiblePresetAllowsExtras(presetIndex)) {
          pricingQty =
            presetIndex === 2
              ? Math.max(this._getPresetPricingQuantity(preset), this._getPricingQuantity())
              : this._getPricingQuantity();
          discount = preset.discountPercent;
        } else {
          pricingQty = this._getPresetPricingQuantity(preset);
          discount = preset.discountPercent;
        }
      } else if (this.optionalExtraSlot && isSelected && this.useKitIndexAsQuantity) {
        pricingQty = this._getPricingQuantity();
        discount = this._getActiveDiscountPercent();
      }

      return { pricingQty, discount };
    }

    _getKitRowPricing(row, preset) {
      if (!row || !preset) {
        return { finalTotal: 0, compareTotal: 0, savings: 0 };
      }

      const isSelected = this.hideKitSelection || row === this._getSelectedKitRow();
      const { pricingQty, discount } = this._getKitRowPricingQtyAndDiscount(row, preset, isSelected);
      const quantities = this._getQuantitiesForKitRow(row, preset);
      const kitCents = this._getKitVariantCents(row);
      const kitCompareCents = this._getKitVariantCompareCents(row);

      if (this.variantPricingOnly) {
        return this._calcHeaderPricing(row, preset);
      }

      if (this.useKitIndexAsQuantity) {
        return this._calcPresetPricing(
          pricingQty,
          discount,
          quantities,
          kitCents,
          kitCompareCents,
          preset.presetIndex
        );
      }

      const computed = this._getRowComputedPriceCents(row);
      if (computed > 0 && !Object.keys(quantities || {}).length && !this.flexibleSelection) {
        const compareTotal = this._getBundleListCompareCents(
          this._getPresetPricingQuantity(preset),
          discount,
          preset.presetIndex,
          computed
        );
        return this._applyCustomPresetCompareToPricing(
          {
            finalTotal: computed,
            compareTotal,
            savings: Math.max(0, compareTotal - computed)
          },
          preset.presetIndex
        );
      }

      return this._calcPresetPricing(
        pricingQty,
        discount,
        quantities,
        kitCents,
        kitCompareCents,
        preset.presetIndex
      );
    }

    _selectionsToQuantities(selections) {
      const quantities = {};
      (selections || []).forEach((sel) => {
        const id = String(sel.variantId);
        quantities[id] = (quantities[id] || 0) + 1;
      });
      return quantities;
    }

    _capQuantitiesToLimit(quantities, limit) {
      if (!limit || limit < 1) return {};
      const capped = {};
      let remaining = limit;

      Object.entries(quantities || {}).forEach(([variantId, count]) => {
        if (remaining <= 0 || !count) return;
        const take = Math.min(count, remaining);
        capped[variantId] = take;
        remaining -= take;
      });

      return capped;
    }

    _getActiveKitSelectionPreview() {
      if (this.selections?.length) {
        return this.selections;
      }
      const activeKit = this.activePreset?.kitValue;
      if (!activeKit) return null;
      const saved = this.presetSelections[activeKit];
      return saved?.length ? saved : null;
    }

    _getQuantitiesForKitRow(row, preset) {
      const kitValue = row?.getAttribute('data-kit-value');
      const drawerOpen = this.drawer?.open;
      const kitLimit =
        parseInt(preset?.quantity, 10) || parseInt(row?.getAttribute('data-preset-quantity'), 10) || 0;
      const isActiveRow = row === this._getSelectedKitRow();
      const presetIndex = parseInt(preset?.presetIndex, 10);
      const allowUncappedQuantities =
        this.flexibleSelection && isActiveRow && this._flexiblePresetAllowsExtras(presetIndex);
      const maybeCapQuantities = (quantities) =>
        allowUncappedQuantities ? quantities || {} : this._capQuantitiesToLimit(quantities, kitLimit);

      if (this._hasOptionalExtraSlots() && isActiveRow) {
        if (drawerOpen) {
          return this.drawerQuantities || {};
        }
        if (this.selections?.length) {
          return this._selectionsToQuantities(this.selections);
        }
      }

      if (drawerOpen) {
        return maybeCapQuantities(this.drawerQuantities);
      }

      if (kitValue && this.presetSelections[kitValue]?.length) {
        return this._selectionsToQuantities(this.presetSelections[kitValue]);
      }

      const preview = this._getActiveKitSelectionPreview();
      if (preview?.length) {
        return maybeCapQuantities(this._selectionsToQuantities(preview));
      }

      return {};
    }

    _getHeaderPriceElement() {
      return this.closest('.product-info')?.querySelector('[data-bundle-header-price]')
        || this.parentElement?.querySelector('[data-bundle-header-price]')
        || null;
    }

    _setMoneyElementContent(element, cents) {
      if (!element) return;
      const srOnly = element.querySelector('.sr-only');
      const srMarkup = srOnly ? srOnly.outerHTML : '';
      element.innerHTML = `${srMarkup}${formatMoney(cents)}`;
    }

    _getHeaderDiscountBadgeText(savings, compareTotal) {
      if (savings <= 0 || compareTotal <= 0) return '';

      const mode = this.getAttribute('data-header-discount-mode') || 'percentage';
      if (mode === 'percentage') {
        return `Du sparst ${Math.round((savings * 100) / compareTotal)}%`;
      }

      return `Du sparst ${formatMoneyAmount(savings)}\u00a0€`;
    }

    _calcHeaderPricing(row, preset) {
      const treatAsSelected = this.hideKitSelection || row === this._getSelectedKitRow();
      const { pricingQty, discount } = this._getKitRowPricingQtyAndDiscount(
        row,
        preset,
        treatAsSelected
      );
      const pricing = this._calcPresetPricing(
        pricingQty,
        discount,
        this._getQuantitiesForKitRow(row, preset),
        this._getKitVariantCents(row),
        this._getKitVariantCompareCents(row),
        preset.presetIndex
      );

      let { finalTotal } = pricing;
      let compareTotal = pricing.compareTotal;

      if (this.variantPricingOnly) {
        const qty = pricingQty;
        const kitPrice = this._getKitVariantCents(row) || 0;
        const kitCompareCents = this._getKitVariantCompareCents(row);
        const extrasCompare = this._getCompareExtrasCents(pricingQty, preset.presetIndex);

        if (this.defaultUnitPrice > 0 && qty > 0 && this.useKitIndexAsQuantity) {
          finalTotal = pricing.finalTotal;
        } else if (finalTotal <= 0 && this.defaultUnitPrice > 0 && qty > 0) {
          const cardsSubtotal = this.defaultUnitPrice * qty;
          const effectiveDiscount = this._resolveVariantPricingDiscount(qty, discount);
          finalTotal = this._applyScaledSubtotalDiscount(cardsSubtotal, effectiveDiscount);
        }

        const productCompare = this._getVariantPricingProductCompareCents(
          qty,
          kitPrice,
          kitCompareCents
        );
        compareTotal = productCompare + extrasCompare;
      } else if (this._usesParentKitCompareRules()) {
        compareTotal = this._getBundleListCompareCents(
          pricingQty,
          discount,
          preset.presetIndex,
          finalTotal
        );
      }

      const savings = Math.max(0, compareTotal - finalTotal);
      return this._applyCustomPresetCompareToPricing(
        { finalTotal, compareTotal, savings },
        preset.presetIndex
      );
    }

    _updateHeaderPrice() {
      if (!this.hideKitSelection) return;

      const header = this._getHeaderPriceElement();
      if (!header) return;

      const row =
        this.querySelector('[data-bundle-kit-row][data-preset-index="1"]') ||
        this.querySelector('[data-bundle-kit-row]');
      const preset = this._getPresetForRow(row) || this.presets.find((entry) => entry.presetIndex === 1);
      if (!row || !preset) return;

      const headerQty = this._getKitRowPricingQtyAndDiscount(row, preset, true).pricingQty;
      const { finalTotal, compareTotal, savings } = this._withPaidGiftSurcharge(
        this._calcHeaderPricing(row, preset),
        headerQty,
        preset.presetIndex
      );
      const showCompare = compareTotal > finalTotal;

      const saleEl = header.querySelector('[data-bundle-header-sale]');
      const compareEl = header.querySelector('[data-bundle-header-compare]');
      const badgeEl = header.querySelector('[data-bundle-header-badge]');

      this._setMoneyElementContent(saleEl, finalTotal);
      if (saleEl) {
        saleEl.classList.toggle('text-on-sale', showCompare);
        saleEl.classList.toggle('text-subdued', !showCompare);
      }

      if (compareEl) {
        if (showCompare) {
          this._setMoneyElementContent(compareEl, compareTotal);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (badgeEl) {
        if (showCompare && savings > 0) {
          badgeEl.textContent = this._getHeaderDiscountBadgeText(savings, compareTotal);
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }

      header.setAttribute('data-header-final-cents', String(finalTotal));
      header.setAttribute('data-header-compare-cents', String(compareTotal));
    }

    _updateKitRowPricing() {
      if (!this.defaultUnitPrice && !this.variantPricingOnly) {
        this._updateHeaderPrice();
        return;
      }

      this.querySelectorAll('[data-bundle-kit-row]').forEach((row) => {
        if (row.hasAttribute('data-one-time') || row.hasAttribute('data-plain-single')) return;
        const preset = this._getPresetForRow(row);
        if (!preset) return;

        const { pricingQty } = this._getKitRowPricingQtyAndDiscount(
          row,
          preset,
          this.hideKitSelection || row === this._getSelectedKitRow()
        );
        const basePricing = this._getKitRowPricing(row, preset);
        const pricing = this._withPaidGiftSurcharge(
          basePricing,
          pricingQty,
          preset.presetIndex
        );
        const { finalTotal, compareTotal, savings } = pricing;
        const showCompare = compareTotal > finalTotal;

        const saleEl = row.querySelector('.bk-media-bundle-builder__price-sale');
        if (saleEl) {
          saleEl.textContent = formatMoney(finalTotal);
        }

        const compareEl = row.querySelector('[data-bundle-kit-compare]');
        if (compareEl) {
          if (showCompare) {
            compareEl.textContent = formatMoney(compareTotal);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        const savingsBadge = row.querySelector('[data-bundle-kit-savings]');
        if (savingsBadge) {
          if (savings > 0) {
            if (this.classList.contains('bk-media-bundle-builder--funnel') && compareTotal > 0) {
              savingsBadge.textContent = `Du sparst ${Math.round((savings * 100) / compareTotal)}%`;
            } else {
              savingsBadge.textContent = `Du sparst ${formatMoneyAmount(savings)}\u00a0€`;
            }
            savingsBadge.hidden = false;
          } else {
            savingsBadge.hidden = true;
          }
        }

        this._syncKitRowPricingAttributes(row, basePricing);
      });

      this._updateHeaderPrice();
      this._registerParentCardPrice();
    }

    _updateDrawerPricing() {
      if (this.drawerMode === 'gratis-extra' || this.drawerMode === 'promo-gifts') return;

      const plainRow = this._getSelectedKitRow();
      if (plainRow?.hasAttribute('data-plain-single')) {
        const price = parseInt(plainRow.getAttribute('data-computed-price'), 10) || 0;
        if (this.drawerTotal) this.drawerTotal.textContent = formatMoney(price);
        if (this.drawerCompare) this.drawerCompare.hidden = true;
        if (this.drawerDiscountBadge) this.drawerDiscountBadge.hidden = true;
        return;
      }

      const pricingQty = this._getPricingQuantity();
      const kitRow =
        this.optionalExtraSlot && this.useKitIndexAsQuantity
          ? this._getOptionalPricingKitRow(pricingQty)
          : this._getSelectedKitRow();
      const preset = this._getPresetForRow(kitRow) || this.activePreset;
      const presetIndex = parseInt(preset?.presetIndex || this.activePreset?.presetIndex, 10);
      const pricing =
        kitRow && preset
          ? this._getKitRowPricing(kitRow, preset)
          : this._calcPresetPricing(
              pricingQty,
              this._getActiveDiscountPercent(),
              this.drawerQuantities,
              this._getKitVariantCents(kitRow),
              this._getKitVariantCompareCents(kitRow),
              presetIndex
            );
      const { finalTotal, compareTotal, savings } = this._withPaidGiftSurcharge(
        pricing,
        pricingQty,
        presetIndex
      );
      const showCompare = compareTotal > finalTotal;

      if (this.drawerTotal) {
        this.drawerTotal.textContent = formatMoney(finalTotal);
      }
      if (this.drawerCompare) {
        if (showCompare) {
          this.drawerCompare.textContent = formatMoney(compareTotal);
          this.drawerCompare.hidden = false;
        } else {
          this.drawerCompare.hidden = true;
        }
      }
      if (this.drawerDiscountBadge) {
        if (showCompare && savings > 0) {
          this.drawerDiscountBadge.textContent = `-${formatMoney(savings)}`;
          this.drawerDiscountBadge.hidden = false;
        } else {
          this.drawerDiscountBadge.hidden = true;
        }
      }
    }

    _confirmDrawer() {
      const isGratisExtra = this.drawerMode === 'gratis-extra';
      const isPromoGifts = this.drawerMode === 'promo-gifts';
      const required = isGratisExtra ? 1 : isPromoGifts ? this.promoGiftsCount : this._getRequiredQty();
      const total = this._getDrawerTotalQty();
      if (isGratisExtra || isPromoGifts) {
        if (total !== required) return;
        this.drawer?.hide?.();
        return;
      }
      if (this._hasOptionalExtraSlots() ? total < required : total !== required) return;
      this.drawer?.hide?.();
    }

    _isComplete() {
      const required = this._getRequiredQty();
      const selections = this._sanitizeSelections(this.selections);
      if (selections.length !== this.selections.length) {
        this.selections = selections;
        this._renderSlots();
      }
      if (this._hasOptionalExtraSlots()) {
        if (selections.length < required) return false;
      } else if (selections.length !== required) {
        return false;
      }
      if (this.gratisExtraProduct && !this.gratisExtraSelection) return false;
      if (this.promoGiftsEnabled && this.promoGiftSelections.length < this.promoGiftsCount) return false;
      if (this._shouldRequireGiftSelection() && !this._allGiftsSelected()) return false;
      return true;
    }

    _clearMissingHighlights() {
      this.querySelectorAll('.is-missing-highlight').forEach((el) => {
        el.classList.remove('is-missing-highlight');
      });
      if (this._missingHighlightTimeout) {
        clearTimeout(this._missingHighlightTimeout);
        this._missingHighlightTimeout = null;
      }
    }

    _highlightMissing(element) {
      this._clearMissingHighlights();
      if (!element) return;
      element.classList.add('is-missing-highlight');
      this._missingHighlightTimeout = setTimeout(() => {
        element.classList.remove('is-missing-highlight');
        this._missingHighlightTimeout = null;
      }, 4000);
    }

    /* START: scroll to flavor step */
    _scrollToFlavorStep() {
      const target =
        this.querySelector('[data-bundle-flavor-step]') ||
        this.querySelector('[data-bundle-cards-panel]');
      if (!target || target.hidden) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      requestAnimationFrame(() => {
        target.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
    /* END: scroll to flavor step */

    _scrollToMissing(element) {
      if (!element) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      element.scrollIntoView({
        behavior: reducedMotion ? 'auto' : 'smooth',
        block: 'center'
      });
    }

    _getFirstMissingTarget() {
      const required = this._getRequiredQty();

      if (this.selections.length < required) {
        const slots = this.querySelectorAll(
          '[data-bundle-cards-panel] [data-bundle-slots] [data-bundle-open-drawer]'
        );
        const missingIndex = this.selections.length;
        if (slots[missingIndex]) return slots[missingIndex];
        return this.querySelector('[data-bundle-cards-panel]');
      }

      if (this.gratisExtraProduct && !this.gratisExtraSelection) {
        return (
          this.querySelector('[data-gratis-extra-slot-wrap] [data-bundle-open-drawer]') ||
          this.querySelector('[data-gratis-extra-panel]')
        );
      }

      if (this.promoGiftsEnabled && this.promoGiftSelections.length < this.promoGiftsCount) {
        const promoSlots = this.querySelectorAll(
          '[data-promo-gifts-slots] [data-bundle-open-drawer]'
        );
        const missingPromo = promoSlots[this.promoGiftSelections.length];
        if (missingPromo) return missingPromo;
        return this.querySelector('[data-promo-gifts-panel]');
      }

      if (this._shouldRequireGiftSelection()) {
        const items = this._getApplicableGiftItems().slice().sort((a, b) => a.slot - b.slot);
        for (const item of items) {
          if (this._isGiftSoldOut(item)) continue;
          if (!this._giftNeedsVariantPicker(item)) continue;
          if (this.giftSelections[item.slot]) continue;
          if (item.slot === 2 && this._isGiftProfiKitOnly(item) && !this.hideGiftsInKitRows) {
            const kitGiftTrigger = this.querySelector(
              '[data-bundle-kit-gift-trigger][data-gift-slot="2"]'
            );
            if (kitGiftTrigger) return kitGiftTrigger;
            continue;
          }
          if (this.kitGiftsPreset > 0) {
            const kitGiftTrigger = this.querySelector(
              `[data-bundle-kit-row].is-selected [data-bundle-kit-gift-trigger][data-gift-slot="${item.slot}"]`
            );
            if (kitGiftTrigger) return kitGiftTrigger;
          }
          const slot = this.querySelector(`[data-colors-slot][data-gift-slot="${item.slot}"]`);
          if (slot) return slot;
        }
      }

      return null;
    }

    _showMissingSelectionHint() {
      const target = this._getFirstMissingTarget();
      if (!target) return;
      this._scrollToMissing(target);
      this._highlightMissing(target);
    }

    _updateGiftsVisibility() {
      if (!this._shouldShowBaseGifts() && this.giftDrawer?.open) {
        this._closeGiftModal();
      }
    }

    _syncFlavorStepHeading() {
      const heading = this.querySelector('[data-bundle-flavor-step] > .bk-media-bundle-builder__step-heading');
      if (!heading) return;
      if (!heading.hasAttribute('data-default-heading')) {
        heading.setAttribute('data-default-heading', heading.textContent);
      }
      const plain = Boolean(this._getSelectedKitRow()?.hasAttribute('data-plain-single'));
      heading.textContent = plain
        ? '2. Wähle Deinen Geschmack'
        : heading.getAttribute('data-default-heading');
    }

    _updateUi() {
      this._syncFlavorStepHeading();
      this._clearInactiveGiftSelections();
      this._ensureApplicableGiftSelections();
      this._updateGiftsVisibility();
      this._updateGratisExtraVisibility();
      this._renderPromoGiftSlots();
      this._renderColorsPanelSlotsFromGiftData();
      this._updateColorsVisibility();
      this._updateColorsSlotUi();
      this._updateKitRowSwitchability();
      if (this.flexibleSelection) {
        this._updateFlexibleProgressBanner();
      }
      if (this._isComplete()) {
        this._clearMissingHighlights();
      }
      this._syncAtcGoalToast();
    }

    _findBundleProductEntry(variantId) {
      const parsedId = parseInt(variantId, 10);
      if (!parsedId) return null;

      const collections = [
        this.products,
        this.gratisExtraProducts,
        this.promoGiftsProducts,
        ...(this.giftPricing?.items || [])
      ];

      for (const collection of collections) {
        const match = (collection || []).find(
          (entry) => parseInt(entry.variant_id, 10) === parsedId
        );
        if (match) return match;
      }

      for (const item of this.giftPricing?.items || []) {
        const variantMatch = (item.variants || []).find(
          (variant) => parseInt(variant.id, 10) === parsedId
        );
        if (variantMatch) {
          return {
            ...item,
            variant_id: variantMatch.id,
            compare_at_price: variantMatch.compare_at_price,
            price: variantMatch.price
          };
        }
      }

      return null;
    }

    _getVariantCompareCentsForCart(variantId) {
      const entry = this._findBundleProductEntry(variantId);
      if (!entry) return 0;

      if (!this.variantPricingOnly && this.defaultUnitPrice > 0) {
        return this._getProductCompareCents(entry);
      }

      const compare = parseInt(entry.compare_at_price, 10) || 0;
      const price = parseInt(entry.price, 10) || 0;
      if (compare > price) return compare;
      if (compare > 0 && price === 0) return compare;
      return 0;
    }

    _getGratisExtraLineCompareCents(presetIndex) {
      return this._getGratisExtraCompareCents(presetIndex);
    }

    _getHideVariantNameProperties() {
      if (this.hideLineItemVariantName) {
        return { _BundleHideVariantName: '1' };
      }
      return {};
    }

    _getOrderTags() {
      const seen = new Set();
      const tags = [];
      String(this.getAttribute('data-order-tags') || '')
        .split(',')
        .forEach((part) => {
          const tag = part.trim();
          if (!tag) return;
          const key = tag.toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          tags.push(tag);
        });
      return tags.join(', ');
    }

    async _syncOrderTags(cartContent) {
      if (!window.BkMediaOrderTags?.sync || !cartContent) return;
      try {
        const taggedCart = await window.BkMediaOrderTags.sync(cartContent);
        if (taggedCart?.attributes) cartContent.attributes = taggedCart.attributes;
      } catch (error) {
        console.error('Order tags:', error);
      }
    }

    _getAddonLineProperties(addonLineProps, compareCents) {
      const properties = { ...addonLineProps };
      const parsedCompare = parseInt(compareCents, 10);
      if (parsedCompare > 0) {
        properties._BundleCompareCents = String(parsedCompare);
      }
      return properties;
    }

    _mergeAddonLineProperties(existing, addonLineProps, compareCents) {
      existing.quantity += 1;
      const parsedCompare = parseInt(compareCents, 10);
      if (parsedCompare <= 0) return;
      const previousCompare = parseInt(existing.properties?._BundleCompareCents, 10) || 0;
      existing.properties = {
        ...existing.properties,
        ...addonLineProps,
        _BundleCompareCents: String(previousCompare + parsedCompare)
      };
    }

    _stampParentLineProperties(items, lineProps) {
      if (!items?.length || !lineProps) return;
      const stamp = {};
      [
        '_BundleParentVariantId',
        '_BundleParentHandle',
        '_BundleGroup',
        '_BundleTitle',
        '_BundleId',
        '_DiscountId',
        '_BundleInstance',
        '_OrderTags'
      ].forEach((key) => {
        if (lineProps[key]) stamp[key] = lineProps[key];
      });
      if (!Object.keys(stamp).length) return;
      items.forEach((item) => {
        if (item.properties?._BundleExternalAddon === '1') return;
        item.properties = { ...item.properties, ...stamp };
      });
    }

    _appendGiftCartItems(items, instanceId, addonLineProps, authoritativeListCompare = 0) {
      if (!this.showGifts) return;
      this._getApplicableGiftItems().forEach((item) => {
        if (this._isGiftSoldOut(item)) return;
        let variantId = this.giftSelections[item.slot];
        if (
          !variantId &&
          !this._giftNeedsVariantPicker(item) &&
          !this._usesGiftOptInDrawer(item)
        ) {
          variantId = this._getAutoGiftVariant(item)?.id;
        }
        const id = parseInt(variantId, 10);
        if (!id) return;

        const lineQty = this._getGiftLineQuantity(item, this.activePreset?.presetIndex);
        const variant =
          item.variants?.find((entry) => parseInt(entry.id, 10) === id) || item.variants?.[0];
        if (this._shouldAddPaidGiftExternally(variant)) {
          items.push({
            id,
            quantity: lineQty,
            properties: {
              ...bundlePaidGiftLineProperties(instanceId, item.slot),
              ...this._getHideVariantNameProperties()
            }
          });
          return;
        }

        if (this.addGiftsInBundle && addonLineProps) {
          const unitCompareCents =
            authoritativeListCompare > 0
              ? 0
              : this._getGiftSavingsCentsFromItem(item, variant);
          const compareCents = unitCompareCents * lineQty;
          const giftProperties = {
            ...this._getAddonLineProperties(addonLineProps, compareCents),
            ...bundleGiftLineProperties(instanceId, item.slot)
          };
          const existing = items.find((entry) => entry.id === id);
          if (existing) {
            existing.quantity += lineQty;
            const previousCompare = parseInt(existing.properties?._BundleCompareCents, 10) || 0;
            existing.properties = {
              ...existing.properties,
              ...addonLineProps,
              ...bundleGiftLineProperties(instanceId, item.slot)
            };
            if (compareCents > 0) {
              existing.properties._BundleCompareCents = String(previousCompare + compareCents);
            }
          } else {
            items.push({
              id,
              quantity: lineQty,
              properties: giftProperties
            });
          }
          return;
        }

        items.push({
          id,
          quantity: lineQty,
          properties: {
            ...(addonLineProps || {}),
            ...bundleGiftLineProperties(instanceId, item.slot),
            ...this._getHideVariantNameProperties()
          }
        });
      });
    }

    _resetBundleBuilderState() {
      this.selections = [];
      this.gratisExtraSelection = null;
      this.promoGiftSelections = [];
      this.presetSelections = {};
      this.drawerQuantities = {};
      this._drawerLastTotal = 0;
      this._colorsDrawerLastCount = 0;
      this._activeColorsSlot = null;
      this._activePickerContext = null;
      this._activeGiftPickerSlot = null;

      this._clearCelebration(this._getRecipeCelebrationContext());
      this._clearCelebration(this._getColorsCelebrationContext());
      this._clearCelebration(this._getAtcCelebrationContext());
      this._clearMissingHighlights();

      if (this.drawer?.open) this.drawer.hide?.();
      this._closeColorsDrawer();
      this._closeGiftModal();

      this._initGiftSelections();
      this._renderSlots();
      this._renderGratisExtraSlot();
      this._renderPromoGiftSlots();
      this._updateKitRowPricing();
      this._updateKitRowSwitchability();
      this._updateDrawerPricing();
      this._syncDrawerQtyDisplay();
      this._updateUi();
    }

    /* START: abo cart */
    _syncSubscriptionInterval() {
      if (!this.subscriptionMode) return;
      const interval = this.querySelector('[data-subscription-interval]');
      if (!interval) return;
      const row = this._getSelectedKitRow();
      const oneTime = row?.hasAttribute('data-one-time');
      const group = row?.getAttribute('data-plan-group') || '';
      interval.hidden = Boolean(oneTime);
      let firstVisible = null;
      interval.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = input.closest('label');
        const visible = !oneTime && input.getAttribute('data-plan-group') === group;
        if (label) label.hidden = !visible;
        if (visible && !firstVisible) firstVisible = input;
      });
      const checked = interval.querySelector('input[type="radio"]:checked');
      if (firstVisible && (!checked || checked.closest('label')?.hidden)) {
        firstVisible.checked = true;
      }
    }

    _getSelectedSellingPlanId() {
      const selected = this.querySelector(
        '[data-subscription-interval] input[type="radio"]:checked:not([hidden])'
      );
      const label = selected?.closest('label');
      if (!selected || label?.hidden) return 0;
      return parseInt(selected.value, 10) || 0;
    }

    _getSubscriptionAddonSelection() {
      const item = this._getGiftItem(1);
      const selectedId = this.giftSelections[1];
      if (item && selectedId && this.subscriptionAddonCollectionId) {
        const variant = (item.variants || []).find(
          (entry) => String(entry.id) === String(selectedId)
        );
        const productId = variant?.productId || item.productId;
        if (variant && productId) {
          return {
            collectionId: this.subscriptionAddonCollectionId,
            productId: String(productId),
            variantId: String(variant.id),
            label: variant.title || this.subscriptionAddonLabel
          };
        }
      }

      if (
        this.subscriptionAddonVariantId &&
        this.subscriptionAddonProductId &&
        this.subscriptionAddonCollectionId
      ) {
        return {
          collectionId: this.subscriptionAddonCollectionId,
          productId: this.subscriptionAddonProductId,
          variantId: this.subscriptionAddonVariantId,
          label: this.subscriptionAddonLabel
        };
      }

      return null;
    }

    _buildSubscriptionSelections() {
      const quantities = {};
      const order = [];
      this._sanitizeSelections(this.selections).forEach((selection) => {
        const variantId = String(selection.variantId);
        if (!quantities[variantId]) {
          order.push(variantId);
          quantities[variantId] = 0;
        }
        quantities[variantId] += 1;
      });

      const items = [];
      const contentLines = [];

      order.forEach((variantId) => {
        const product = this.products.find((entry) => String(entry.variant_id) === variantId);
        if (!product) return;
        const quantity = quantities[variantId];
        items.push({
          collectionId: this.subscriptionCollectionId,
          productId: String(product.id),
          variantId: String(product.variant_id),
          quantity,
          sku: ''
        });
        contentLines.push(`${quantity}x ${product.title}`);
      });

      const addon = this._getSubscriptionAddonSelection();
      if (addon) {
        items.unshift({
          collectionId: addon.collectionId,
          productId: addon.productId,
          variantId: addon.variantId,
          quantity: 1,
          sku: ''
        });
        contentLines.unshift(`1x ${addon.label}`);
      }

      return { items, contents: contentLines.join('\n') };
    }

    async _addSubscriptionToCart() {
      const parentVariantId = this._getParentVariantId();
      const parentProductId = this.getAttribute('data-parent-product-id');
      const oneTime = this._getSelectedKitRow()?.hasAttribute('data-one-time');
      const sellingPlanId = oneTime ? 0 : this._getSelectedSellingPlanId();
      const interval = this.querySelector('[data-subscription-interval]');

      if (!oneTime && !sellingPlanId) {
        if (interval) this._highlightMissing(interval);
        return;
      }
      if (!parentVariantId || !parentProductId || !this.subscriptionCollectionId) {
        alert('Abo konnte nicht vorbereitet werden.');
        return;
      }

      const { items: selections, contents } = this._buildSubscriptionSelections();
      if (!selections.length) return;

      const cartDrawerElement = document.querySelector('cart-drawer');
      const sectionId = cartDrawerElement?.getAttribute('data-section-id') || 'cart-drawer';
      let sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );
      if (!sectionsToBundle.includes(sectionId)) sectionsToBundle.push(sectionId);

      let checkoutRedirectPending = false;

      try {
        this.atcButton?.setAttribute('aria-busy', 'true');
        if (this.atcButton) this.atcButton.disabled = true;

        const recharge = await loadRechargeEncoder();
        const timestampResponse = await fetch(
          `${window.Shopify.routes.root}tools/recurring/bundling-storefront-manager/t`,
          { headers: { Accept: 'application/json' } }
        );
        const timestampJson = await timestampResponse.json();
        const encoded = recharge.encodeBundle({
          variantId: String(parentVariantId),
          version: timestampJson.timestamp || Math.ceil(Date.now() / 1000),
          items: selections
        });

        const bundleResponse = await fetch(
          `${window.Shopify.routes.root}tools/recurring/bundling-storefront-manager/api/v1/bundles`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ bundle: encoded })
          }
        );
        const bundleJson = await bundleResponse.json();
        if (!bundleResponse.ok || !bundleJson.id) {
          throw new Error(bundleJson.message || 'Abo-Auswahl konnte nicht gespeichert werden.');
        }

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              {
                id: parentVariantId,
                quantity: 1,
                ...(oneTime ? {} : { selling_plan: sellingPlanId }),
                properties: {
                  _rb_id: bundleJson.id,
                  Inhalt: contents,
                  ...(this._getOrderTags() ? { _OrderTags: this._getOrderTags() } : {})
                }
              }
            ],
            sections: sectionsToBundle.join(',')
          })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add to cart');
        }

        const responseJson = await response.json();
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        await this._syncOrderTags(cartContent);

        if (!responseJson.sections?.[sectionId]) {
          const cartDrawerResponse = await fetch(
            `${window.Shopify.routes.root}cart?section_id=${sectionId}`
          );
          const cartDrawerHtml = await cartDrawerResponse.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = cartDrawerHtml;
          const newCartDrawer = tempDiv.querySelector('#cart-drawer');
          if (newCartDrawer) {
            if (!responseJson.sections) responseJson.sections = {};
            responseJson.sections[sectionId] = newCartDrawer.outerHTML;
          }
        }

        if (!cartContent.sections) cartContent.sections = {};
        cartContent.sections = Object.assign(cartContent.sections, responseJson.sections || {});

        this._triggerCelebration(this._getAtcCelebrationContext());

        if (this.redirectToCheckout) {
          checkoutRedirectPending = true;
          setTimeout(() => {
            window.location.href = `${window.Shopify.routes.root}checkout`;
          }, 1200);
          return;
        }

        const productForm = this.form || document.querySelector('form[is="product-form"]');
        const formToUse = productForm || document.createElement('form');
        let formAdded = false;
        if (!productForm) {
          document.body.appendChild(formToUse);
          formAdded = true;
        }

        formToUse.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            cancelable: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          })
        );

        if (formAdded) document.body.removeChild(formToUse);
        this._resetBundleBuilderState();
      } catch (error) {
        console.error('Abo add to cart:', error);
        alert(error.message || 'Abo konnte nicht hinzugefügt werden.');
      } finally {
        if (!checkoutRedirectPending) {
          this.atcButton?.removeAttribute('aria-busy');
          if (this.atcButton) this.atcButton.disabled = false;
          this._updateUi();
        }
      }
    }
    /* END: abo cart */

    /* START: plain single */
    async _addPlainSingleToCart() {
      const selection = this._sanitizeSelections(this.selections)[0];
      const variantId = parseInt(selection?.variantId, 10);
      if (!variantId) return;

      const items = [{ id: variantId, quantity: 1 }];
      const cartDrawerElement = document.querySelector('cart-drawer');
      const sectionId = cartDrawerElement?.getAttribute('data-section-id') || 'cart-drawer';
      let sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );
      if (!sectionsToBundle.includes(sectionId)) {
        sectionsToBundle.push(sectionId);
      }

      let checkoutRedirectPending = false;

      try {
        this.atcButton?.setAttribute('aria-busy', 'true');
        this.atcButton.disabled = true;

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items, sections: sectionsToBundle.join(',') })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add to cart');
        }

        const responseJson = await response.json();
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();

        if (!responseJson.sections?.[sectionId]) {
          const cartDrawerResponse = await fetch(
            `${window.Shopify.routes.root}cart?section_id=${sectionId}`
          );
          const cartDrawerHtml = await cartDrawerResponse.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = cartDrawerHtml;
          const newCartDrawer = tempDiv.querySelector('#cart-drawer');
          if (newCartDrawer) {
            if (!responseJson.sections) responseJson.sections = {};
            responseJson.sections[sectionId] = newCartDrawer.outerHTML;
          }
        }

        if (!cartContent.sections) cartContent.sections = {};
        cartContent.sections = Object.assign(cartContent.sections, responseJson.sections || {});

        this._triggerCelebration(this._getAtcCelebrationContext());

        if (this.redirectToCheckout) {
          checkoutRedirectPending = true;
          setTimeout(() => {
            window.location.href = `${window.Shopify.routes.root}checkout`;
          }, 1200);
          return;
        }

        const productForm = this.form || document.querySelector('form[is="product-form"]');
        const formToUse = productForm || document.createElement('form');
        let formAdded = false;
        if (!productForm) {
          document.body.appendChild(formToUse);
          formAdded = true;
        }

        formToUse.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            cancelable: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          })
        );

        if (formAdded) document.body.removeChild(formToUse);
        this._resetBundleBuilderState();
      } catch (error) {
        console.error('Bundle builder add to cart:', error);
        alert(error.message || 'Produkte konnten nicht hinzugefügt werden.');
      } finally {
        if (!checkoutRedirectPending) {
          this.atcButton?.removeAttribute('aria-busy');
          if (this.atcButton) this.atcButton.disabled = false;
          this._updateUi();
        }
      }
    }
    /* END: plain single */

    async _addToCart() {
      if (!this._isComplete()) {
        this._showMissingSelectionHint();
        return;
      }

      if (this.subscriptionMode) {
        await this._addSubscriptionToCart();
        return;
      }

      /* START: plain single */
      if (this._getSelectedKitRow()?.hasAttribute('data-plain-single')) {
        await this._addPlainSingleToCart();
        return;
      }
      /* END: plain single */

      const parentVariantId = this._getParentVariantId();
      if (!parentVariantId) return;

      const instanceId = generateBundleInstanceId();
      const bundleGroup = this._getEffectiveBundleGroup();
      const bundleId = generateBundleId(bundleGroup, instanceId);
      const kitRow = this._getSelectedKitRow();
      const preset = this._getPresetForRow(kitRow);
      const bundleTitle = this._getBundleCartTitle(preset);
      const parentHandle = this.parentVariantMap?.parentHandle || this.getAttribute('data-parent-product-handle') || '';
      const lineProps = {
        ...bundleLineProperties(
          bundleId,
          parentVariantId,
          bundleTitle,
          bundleGroup,
          instanceId,
          parentHandle
        ),
        ...this._getHideVariantNameProperties()
      };
      const orderTags = this._getOrderTags();
      if (orderTags) lineProps._OrderTags = orderTags;

      const cartPricing = this._getAuthoritativeCartPricing(kitRow, preset);
      this._syncKitRowPricingAttributes(kitRow, cartPricing);
      const discountScaleQty = this._getDiscountScaleQuantity();
      lineProps._BundleDiscountScaleQty = String(discountScaleQty);
      const authoritativePricing = this._resolveAuthoritativeListCompare(cartPricing, preset);
      const authoritativeListCompare = authoritativePricing.compare;
      const authoritativeListFinal = authoritativePricing.final;
      if (authoritativeListCompare > 0) {
        lineProps._BundleListCompareCents = String(authoritativeListCompare);
        lineProps._BundleCompareAt = String(authoritativeListCompare);
      }
      if (authoritativePricing.customCompare > 0) {
        lineProps._BundleCustomCompareCents = String(authoritativePricing.customCompare);
      }
      if (authoritativeListFinal > 0) {
        lineProps._BundleListFinalCents = String(authoritativeListFinal);
        lineProps._BundleFinal = String(authoritativeListFinal);
      }

      const addonLineProps = {
        ...bundleAddonLineProperties(bundleId, bundleGroup, discountScaleQty, instanceId),
        ...this._getHideVariantNameProperties()
      };
      if (bundleTitle) {
        addonLineProps._BundleTitle = bundleTitle;
      }
      if (lineProps._BundleParentVariantId) {
        addonLineProps._BundleParentVariantId = lineProps._BundleParentVariantId;
      }
      if (lineProps._BundleParentHandle) {
        addonLineProps._BundleParentHandle = lineProps._BundleParentHandle;
      }
      const items = [];

      const selectionOrder = [];
      const selectionQuantities = {};
      this._sanitizeSelections(this.selections).forEach((sel) => {
        const variantId = parseInt(sel.variantId, 10);
        if (!variantId || (parentVariantId && variantId === parentVariantId)) return;
        if (!selectionQuantities[variantId]) {
          selectionOrder.push(variantId);
          selectionQuantities[variantId] = 0;
        }
        selectionQuantities[variantId] += 1;
      });
      selectionOrder.forEach((variantId) => {
        const quantity = selectionQuantities[variantId];
        const lineCompareCents =
          authoritativeListCompare > 0
            ? 0
            : this._getVariantCompareCentsForCart(variantId) * quantity;
        items.push({
          id: variantId,
          quantity,
          properties: this._getAddonLineProperties(addonLineProps, lineCompareCents)
        });
      });

      if (this.gratisExtraSelection) {
        const gratisVariantId = this.gratisExtraSelection.variantId;
        if (gratisVariantId && (!parentVariantId || gratisVariantId !== parentVariantId)) {
          const gratisCompareCents =
            authoritativeListCompare > 0
              ? 0
              : this._getGratisExtraLineCompareCents(preset?.presetIndex);
          items.push({
            id: gratisVariantId,
            quantity: 1,
            properties: {
              ...this._getAddonLineProperties(addonLineProps, gratisCompareCents),
              ...bundleGratisExtraLineProperties()
            }
          });
        }
      }

      if (this.promoGiftsEnabled) {
        const promoOrder = [];
        const promoQuantities = {};
        this.promoGiftSelections.forEach((selection) => {
          const variantId = parseInt(selection.variantId, 10);
          if (!variantId || (parentVariantId && variantId === parentVariantId)) return;
          if (!promoQuantities[variantId]) {
            promoOrder.push(variantId);
            promoQuantities[variantId] = 0;
          }
          promoQuantities[variantId] += 1;
        });
        promoOrder.forEach((variantId) => {
          const quantity = promoQuantities[variantId];
          const lineCompareCents =
            authoritativeListCompare > 0
              ? 0
              : this._getVariantCompareCentsForCart(variantId) * quantity;
          items.push({
            id: variantId,
            quantity,
            properties: {
              ...this._getAddonLineProperties(addonLineProps, lineCompareCents),
              ...bundleGratisExtraLineProperties()
            }
          });
        });
      }

      if (!items.length) return;
      items[0].properties = {
        ...items[0].properties,
        ...lineProps
      };

      this._appendGiftCartItems(items, instanceId, addonLineProps, authoritativeListCompare);
      this._stampParentLineProperties(items, lineProps);

      const cartDrawerElement = document.querySelector('cart-drawer');
      const sectionId = cartDrawerElement?.getAttribute('data-section-id') || 'cart-drawer';
      let sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );
      if (!sectionsToBundle.includes(sectionId)) {
        sectionsToBundle.push(sectionId);
      }

      let checkoutRedirectPending = false;

      try {
        this.atcButton?.setAttribute('aria-busy', 'true');
        this.atcButton.disabled = true;

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items, sections: sectionsToBundle.join(',') })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add to cart');
        }

        const responseJson = await response.json();
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();

        let pricingPersisted = false;
        if (window.BkMediaBundleCartPricing?.persist) {
          const compareToPersist =
            authoritativeListCompare || authoritativePricing.customCompare || 0;
          const persistResult = await window.BkMediaBundleCartPricing.persist({
            bundleId,
            instanceId,
            compareCents: compareToPersist,
            finalCents: authoritativeListFinal,
            sections: sectionsToBundle
          });
          pricingPersisted = compareToPersist > authoritativeListFinal;
          if (persistResult) {
            Object.assign(cartContent, persistResult);
            if (persistResult.sections) {
              if (!responseJson.sections) responseJson.sections = {};
              Object.assign(responseJson.sections, persistResult.sections);
            }
          } else {
            const refreshedCart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
            Object.assign(cartContent, refreshedCart);
          }
        }

        if (!responseJson.sections?.[sectionId] || pricingPersisted) {
          const cartDrawerResponse = await fetch(
            `${window.Shopify.routes.root}cart?section_id=${sectionId}`
          );
          const cartDrawerHtml = await cartDrawerResponse.text();
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = cartDrawerHtml;
          const newCartDrawer = tempDiv.querySelector('#cart-drawer');
          if (newCartDrawer) {
            if (!responseJson.sections) responseJson.sections = {};
            responseJson.sections[sectionId] = newCartDrawer.outerHTML;
          }
        }

        if (!cartContent.sections) cartContent.sections = {};
        cartContent.sections = Object.assign(cartContent.sections, responseJson.sections || {});

        await this._syncOrderTags(cartContent);
        this._triggerCelebration(this._getAtcCelebrationContext());

        if (this.redirectToCheckout) {
          checkoutRedirectPending = true;
          setTimeout(() => {
            window.location.href = `${window.Shopify.routes.root}checkout`;
          }, 1200);
          return;
        }

        const productForm = this.form || document.querySelector('form[is="product-form"]');
        const formToUse = productForm || document.createElement('form');
        let formAdded = false;
        if (!productForm) {
          document.body.appendChild(formToUse);
          formAdded = true;
        }

        formToUse.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            cancelable: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent
            }
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cartContent }
          })
        );

        if (formAdded) document.body.removeChild(formToUse);

        this._resetBundleBuilderState();
      } catch (error) {
        console.error('Bundle builder add to cart:', error);
        alert(error.message || 'Produkte konnten nicht hinzugefügt werden.');
      } finally {
        if (!checkoutRedirectPending) {
          this.atcButton?.removeAttribute('aria-busy');
          if (this.atcButton) this.atcButton.disabled = false;
          this._updateUi();
        }
      }
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('bundle-builder').forEach((el) => {
      if (!el._initialized) {
        el._initialized = true;
      }
    });
  });
})();
